(function(){"use strict";try{if(typeof document<"u"){var a=document.createElement("style");a.appendChild(document.createTextNode("._tooltip_5svgn_1{width:260px}._popover_5svgn_5{background:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);box-sizing:border-box;z-index:100}._bar_1n5dj_1{overflow:hidden}._section_1n5dj_5{position:relative}._sectionHidden_1n5dj_8{display:none!important}._sectionInheritRadius_1n5dj_11{border-radius:inherit}._valueOutside_1n5dj_15{position:absolute;left:calc(100% + var(--dixa-size-spacer-100));z-index:1}:root{--dixa-analytics-color-default-1: var(--dixa-color-purple-700);--dixa-analytics-color-default-2: var(--dixa-color-blue-300);--dixa-analytics-color-default-3: var(--dixa-color-red-500);--dixa-analytics-color-default-4: var(--dixa-color-orange-300);--dixa-analytics-color-default-5: var(--dixa-color-purple-500);--dixa-analytics-color-default-6: var(--dixa-color-green-400);--dixa-analytics-color-default-7: var(--dixa-color-neutral-600);--dixa-analytics-color-default-8: var(--dixa-color-neutral-400);--dixa-analytics-color-rating-1: var(--dixa-color-red-600);--dixa-analytics-color-rating-2: var(--dixa-color-red-400);--dixa-analytics-color-rating-3: var(--dixa-color-orange-300);--dixa-analytics-color-rating-4: var(--dixa-color-green-500);--dixa-analytics-color-rating-5: var(--dixa-color-green-600)}[data-color-mode=dark]{--dixa-analytics-color-default-1: var(--dixa-color-blue-300);--dixa-analytics-color-default-2: var(--dixa-color-blue-700);--dixa-analytics-color-default-3: var(--dixa-color-red-400);--dixa-analytics-color-default-4: var(--dixa-color-orange-600);--dixa-analytics-color-default-5: var(--dixa-color-purple-500);--dixa-analytics-color-default-6: var(--dixa-color-green-500);--dixa-analytics-color-default-7: var(--dixa-color-neutral-400);--dixa-analytics-color-default-8: var(--dixa-color-neutral-800);--dixa-analytics-color-rating-1: var(--dixa-color-red-400);--dixa-analytics-color-rating-2: var(--dixa-color-red-600);--dixa-analytics-color-rating-3: var(--dixa-color-orange-600);--dixa-analytics-color-rating-4: var(--dixa-color-green-400);--dixa-analytics-color-rating-5: var(--dixa-color-green-300)}._container_1t2a7_1{overflow:hidden}._root_6kwn9_1{display:grid;column-gap:var(--dixa-size-spacer-200);row-gap:var(--dixa-size-spacer-300);white-space:nowrap}._root_6kwn9_1:not(._rootBounded_6kwn9_7):not(._rootFluid_6kwn9_7){grid-template-columns:repeat(auto-fit,minmax(min(100% / 2 - var(--dixa-size-spacer-200) * (2 - 1) / 2,max(96px,100% / 6 - var(--dixa-size-spacer-200) * (6 - 1) / 6)),1fr))}._rootFluid_6kwn9_7,._rootBounded_6kwn9_7{grid-template-columns:repeat(auto-fit,minmax(96px,1fr))}._rootBounded_6kwn9_7{max-width:calc(6 * 96px + var(--dixa-size-spacer-200) * (6 - 1))}._wrapper_1w7q6_1{display:inline-flex;align-self:flex-start}._text_1w7q6_6{font-size:var(--dixa-typography-size-600)}._colorIndicator_luubh_1{width:6px;height:6px;border-radius:50%;flex-shrink:0}._root_7a8ds_48{display:flex;flex-direction:column;gap:var(--dixa-size-spacer-300);padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);box-shadow:var(--dixa-effect-box-shadow-300);background-color:light-dark(var(--dixa-color-neutral-900),var(--dixa-color-neutral-200));color:light-dark(var(--dixa-color-neutral-000),var(--dixa-typography-color-primary))}@supports not (color: light-dark(white,black)){._root_7a8ds_48{background-color:var(--dixa-color-neutral-900)}}@supports not (color: light-dark(white,black)){._root_7a8ds_48{color:var(--dixa-color-neutral-000)}}._legendItem_1mjjb_48{flex-shrink:0;overflow:hidden;white-space:nowrap;cursor:pointer;opacity:1}._legendItemInactive_1mjjb_55{opacity:.4}._legendIcon_1mjjb_59{flex-shrink:0;width:12px;border-radius:var(--dixa-size-border-radius-50);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-sizing:border-box}._legendIconBar_1mjjb_66{height:12px}._legendIconLine_1mjjb_69{height:4px}._trigger_1mrk9_1{width:100%;height:100%}._cell_hfkay_1{display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;cursor:default;opacity:1;transition:opacity .2s ease-in-out}._cell_hfkay_1:hover ._cellText_hfkay_11{color:var(--dixa-typography-color-primary)}._cellDimmed_hfkay_14{opacity:var(--dixa-effect-opacity-200)}._cellContent_hfkay_18{display:flex;align-items:center;justify-content:center;width:100%;height:100%}._cellText_hfkay_11{transition:color .2s ease-in-out}._grid_1qk2p_1{display:grid;grid-auto-rows:minmax(var(--dixa-size-spacer-500),1fr);flex-grow:1}._row_1qk2p_7{display:grid;grid-auto-columns:1fr;grid-auto-flow:column;align-items:center;text-align:center}._legend_bx9pd_48{position:relative}._trigger_bx9pd_52{position:absolute;top:-50%;right:0}._popover_bx9pd_58{width:256px;max-height:298px;padding:var(--dixa-size-spacer-300);z-index:100;box-sizing:border-box;background:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);margin:0 var(--dixa-size-spacer-200);overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._breakdown_bx9pd_77{display:flex;flex-direction:column;gap:var(--dixa-size-spacer-250);list-style:none;margin:0;padding:0}._breakdown_bx9pd_77 li{display:grid;grid-template-columns:1fr auto;gap:var(--dixa-size-spacer-200)}._breakdown_bx9pd_77 li>:first-child{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._tooltip_h4i5v_1{max-width:300px}._trigger_h4i5v_5{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0}._tableWrapper_1xmkm_1{overflow:auto}._tableWrapperEmpty_1xmkm_4{flex-grow:1}._thCell_1xmkm_8{white-space:nowrap}._tdCell_1xmkm_12{position:relative;max-width:240px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._tooltip_1xmkm_20{max-width:300px}")),document.head.appendChild(a)}}catch(r){console.error("vite-plugin-css-injected-by-js",r)}})();
import * as D from "react";
import ro, { useCallback as U, createContext as wt, useMemo as W, createElement as V, useContext as no, forwardRef as se, Children as st, isValidElement as Zt, cloneElement as lr, Fragment as El, useEffect as Y, useRef as Q, useState as ee, useLayoutEffect as Pt, useReducer as fd, memo as we } from "react";
import { IconButton as ao, ButtonList as Ar, FlexBox as X, Text as K, Tooltip as Et, Box as io, ButtonGroup as Ol, Button as Al, EmptyState as Tl, Divider as dd, Badge as hd, Table as Ce, HelpIcon as pd, Pagination as vd } from "@dixa/lib-shared-habla";
import * as gd from "react-dom";
import md, { flushSync as ql } from "react-dom";
import qe from "classnames";
import { usePrevious as jl, useInterval as bd, useList as yd, useUpdateEffect as Ot, useMap as _d } from "react-use";
import { Sector as Lo, LabelList as xd, Cell as Bo, ResponsiveContainer as wd, XAxis as Cd, YAxis as Rd, CartesianGrid as Sd, ReferenceLine as $d, Label as Pd, Legend as Ed, Tooltip as Od, PieChart as Ad, AreaChart as Td, LineChart as qd, BarChart as jd, Line as Id, Bar as Md, Area as Dd, Pie as Fd } from "recharts";
import ct from "moment-timezone";
import { colors as Il, typography as Nd } from "@dixa/lib-shared-tokens";
import { TagChips as kd } from "lib-shared-tagging";
var Ft = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Re(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Ld(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      var a = !1;
      try {
        a = this instanceof n;
      } catch {
      }
      return a ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Nt = { exports: {} }, pt = {};
var Vo;
function Bd() {
  if (Vo) return pt;
  Vo = 1;
  var e = ro, t = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, c, u) {
    var d, l = {}, h = null, f = null;
    u !== void 0 && (h = "" + u), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (f = c.ref);
    for (d in c) n.call(c, d) && !i.hasOwnProperty(d) && (l[d] = c[d]);
    if (s && s.defaultProps) for (d in c = s.defaultProps, c) l[d] === void 0 && (l[d] = c[d]);
    return { $$typeof: t, type: s, key: h, ref: f, props: l, _owner: a.current };
  }
  return pt.Fragment = r, pt.jsx = o, pt.jsxs = o, pt;
}
var vt = {};
var Ho;
function Vd() {
  return Ho || (Ho = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = ro, t = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), n = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), i = /* @__PURE__ */ Symbol.for("react.profiler"), o = /* @__PURE__ */ Symbol.for("react.provider"), s = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), u = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), l = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), f = /* @__PURE__ */ Symbol.for("react.offscreen"), g = Symbol.iterator, p = "@@iterator";
    function m(v) {
      if (v === null || typeof v != "object")
        return null;
      var O = g && v[g] || v[p];
      return typeof O == "function" ? O : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function _(v) {
      {
        for (var O = arguments.length, j = new Array(O > 1 ? O - 1 : 0), N = 1; N < O; N++)
          j[N - 1] = arguments[N];
        C("error", v, j);
      }
    }
    function C(v, O, j) {
      {
        var N = b.ReactDebugCurrentFrame, z = N.getStackAddendum();
        z !== "" && (O += "%s", j = j.concat([z]));
        var G = j.map(function(H) {
          return String(H);
        });
        G.unshift("Warning: " + O), Function.prototype.apply.call(console[v], console, G);
      }
    }
    var R = !1, $ = !1, E = !1, A = !1, x = !1, w;
    w = /* @__PURE__ */ Symbol.for("react.module.reference");
    function P(v) {
      return !!(typeof v == "string" || typeof v == "function" || v === n || v === i || x || v === a || v === u || v === d || A || v === f || R || $ || E || typeof v == "object" && v !== null && (v.$$typeof === h || v.$$typeof === l || v.$$typeof === o || v.$$typeof === s || v.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      v.$$typeof === w || v.getModuleId !== void 0));
    }
    function S(v, O, j) {
      var N = v.displayName;
      if (N)
        return N;
      var z = O.displayName || O.name || "";
      return z !== "" ? j + "(" + z + ")" : j;
    }
    function I(v) {
      return v.displayName || "Context";
    }
    function T(v) {
      if (v == null)
        return null;
      if (typeof v.tag == "number" && _("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof v == "function")
        return v.displayName || v.name || null;
      if (typeof v == "string")
        return v;
      switch (v) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case u:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof v == "object")
        switch (v.$$typeof) {
          case s:
            var O = v;
            return I(O) + ".Consumer";
          case o:
            var j = v;
            return I(j._context) + ".Provider";
          case c:
            return S(v, v.render, "ForwardRef");
          case l:
            var N = v.displayName || null;
            return N !== null ? N : T(v.type) || "Memo";
          case h: {
            var z = v, G = z._payload, H = z._init;
            try {
              return T(H(G));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, F = 0, q, k, L, te, ae, ne, pe;
    function oe() {
    }
    oe.__reactDisabledLog = !0;
    function le() {
      {
        if (F === 0) {
          q = console.log, k = console.info, L = console.warn, te = console.error, ae = console.group, ne = console.groupCollapsed, pe = console.groupEnd;
          var v = {
            configurable: !0,
            enumerable: !0,
            value: oe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: v,
            log: v,
            warn: v,
            error: v,
            group: v,
            groupCollapsed: v,
            groupEnd: v
          });
        }
        F++;
      }
    }
    function ve() {
      {
        if (F--, F === 0) {
          var v = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, v, {
              value: q
            }),
            info: M({}, v, {
              value: k
            }),
            warn: M({}, v, {
              value: L
            }),
            error: M({}, v, {
              value: te
            }),
            group: M({}, v, {
              value: ae
            }),
            groupCollapsed: M({}, v, {
              value: ne
            }),
            groupEnd: M({}, v, {
              value: pe
            })
          });
        }
        F < 0 && _("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var J = b.ReactCurrentDispatcher, ge;
    function fe(v, O, j) {
      {
        if (ge === void 0)
          try {
            throw Error();
          } catch (z) {
            var N = z.stack.trim().match(/\n( *(at )?)/);
            ge = N && N[1] || "";
          }
        return `
` + ge + v;
      }
    }
    var ie = !1, ye;
    {
      var Ae = typeof WeakMap == "function" ? WeakMap : Map;
      ye = new Ae();
    }
    function Fe(v, O) {
      if (!v || ie)
        return "";
      {
        var j = ye.get(v);
        if (j !== void 0)
          return j;
      }
      var N;
      ie = !0;
      var z = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var G;
      G = J.current, J.current = null, le();
      try {
        if (O) {
          var H = function() {
            throw Error();
          };
          if (Object.defineProperty(H.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(H, []);
            } catch (he) {
              N = he;
            }
            Reflect.construct(v, [], H);
          } else {
            try {
              H.call();
            } catch (he) {
              N = he;
            }
            v.call(H.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (he) {
            N = he;
          }
          v();
        }
      } catch (he) {
        if (he && N && typeof he.stack == "string") {
          for (var B = he.stack.split(`
`), ue = N.stack.split(`
`), Z = B.length - 1, re = ue.length - 1; Z >= 1 && re >= 0 && B[Z] !== ue[re]; )
            re--;
          for (; Z >= 1 && re >= 0; Z--, re--)
            if (B[Z] !== ue[re]) {
              if (Z !== 1 || re !== 1)
                do
                  if (Z--, re--, re < 0 || B[Z] !== ue[re]) {
                    var _e = `
` + B[Z].replace(" at new ", " at ");
                    return v.displayName && _e.includes("<anonymous>") && (_e = _e.replace("<anonymous>", v.displayName)), typeof v == "function" && ye.set(v, _e), _e;
                  }
                while (Z >= 1 && re >= 0);
              break;
            }
        }
      } finally {
        ie = !1, J.current = G, ve(), Error.prepareStackTrace = z;
      }
      var tt = v ? v.displayName || v.name : "", He = tt ? fe(tt) : "";
      return typeof v == "function" && ye.set(v, He), He;
    }
    function de(v, O, j) {
      return Fe(v, !1);
    }
    function Te(v) {
      var O = v.prototype;
      return !!(O && O.isReactComponent);
    }
    function ce(v, O, j) {
      if (v == null)
        return "";
      if (typeof v == "function")
        return Fe(v, Te(v));
      if (typeof v == "string")
        return fe(v);
      switch (v) {
        case u:
          return fe("Suspense");
        case d:
          return fe("SuspenseList");
      }
      if (typeof v == "object")
        switch (v.$$typeof) {
          case c:
            return de(v.render);
          case l:
            return ce(v.type, O, j);
          case h: {
            var N = v, z = N._payload, G = N._init;
            try {
              return ce(G(z), O, j);
            } catch {
            }
          }
        }
      return "";
    }
    var Ne = Object.prototype.hasOwnProperty, Mt = {}, Dt = b.ReactDebugCurrentFrame;
    function Ze(v) {
      if (v) {
        var O = v._owner, j = ce(v.type, v._source, O ? O.type : null);
        Dt.setExtraStackFrame(j);
      } else
        Dt.setExtraStackFrame(null);
    }
    function Rr(v, O, j, N, z) {
      {
        var G = Function.call.bind(Ne);
        for (var H in v)
          if (G(v, H)) {
            var B = void 0;
            try {
              if (typeof v[H] != "function") {
                var ue = Error((N || "React class") + ": " + j + " type `" + H + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof v[H] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ue.name = "Invariant Violation", ue;
              }
              B = v[H](O, H, N, j, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Z) {
              B = Z;
            }
            B && !(B instanceof Error) && (Ze(z), _("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", N || "React class", j, H, typeof B), Ze(null)), B instanceof Error && !(B.message in Mt) && (Mt[B.message] = !0, Ze(z), _("Failed %s type: %s", j, B.message), Ze(null));
          }
      }
    }
    var Qe = Array.isArray;
    function Sr(v) {
      return Qe(v);
    }
    function Uf(v) {
      {
        var O = typeof Symbol == "function" && Symbol.toStringTag, j = O && v[Symbol.toStringTag] || v.constructor.name || "Object";
        return j;
      }
    }
    function Wf(v) {
      try {
        return Eo(v), !1;
      } catch {
        return !0;
      }
    }
    function Eo(v) {
      return "" + v;
    }
    function Oo(v) {
      if (Wf(v))
        return _("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Uf(v)), Eo(v);
    }
    var Ao = b.ReactCurrentOwner, Gf = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, To, qo;
    function Kf(v) {
      if (Ne.call(v, "ref")) {
        var O = Object.getOwnPropertyDescriptor(v, "ref").get;
        if (O && O.isReactWarning)
          return !1;
      }
      return v.ref !== void 0;
    }
    function Yf(v) {
      if (Ne.call(v, "key")) {
        var O = Object.getOwnPropertyDescriptor(v, "key").get;
        if (O && O.isReactWarning)
          return !1;
      }
      return v.key !== void 0;
    }
    function Xf(v, O) {
      typeof v.ref == "string" && Ao.current;
    }
    function Jf(v, O) {
      {
        var j = function() {
          To || (To = !0, _("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", O));
        };
        j.isReactWarning = !0, Object.defineProperty(v, "key", {
          get: j,
          configurable: !0
        });
      }
    }
    function Zf(v, O) {
      {
        var j = function() {
          qo || (qo = !0, _("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", O));
        };
        j.isReactWarning = !0, Object.defineProperty(v, "ref", {
          get: j,
          configurable: !0
        });
      }
    }
    var Qf = function(v, O, j, N, z, G, H) {
      var B = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: v,
        key: O,
        ref: j,
        props: H,
        // Record the component responsible for creating this element.
        _owner: G
      };
      return B._store = {}, Object.defineProperty(B._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(B, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: N
      }), Object.defineProperty(B, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: z
      }), Object.freeze && (Object.freeze(B.props), Object.freeze(B)), B;
    };
    function ed(v, O, j, N, z) {
      {
        var G, H = {}, B = null, ue = null;
        j !== void 0 && (Oo(j), B = "" + j), Yf(O) && (Oo(O.key), B = "" + O.key), Kf(O) && (ue = O.ref, Xf(O, z));
        for (G in O)
          Ne.call(O, G) && !Gf.hasOwnProperty(G) && (H[G] = O[G]);
        if (v && v.defaultProps) {
          var Z = v.defaultProps;
          for (G in Z)
            H[G] === void 0 && (H[G] = Z[G]);
        }
        if (B || ue) {
          var re = typeof v == "function" ? v.displayName || v.name || "Unknown" : v;
          B && Jf(H, re), ue && Zf(H, re);
        }
        return Qf(v, B, ue, z, N, Ao.current, H);
      }
    }
    var $r = b.ReactCurrentOwner, jo = b.ReactDebugCurrentFrame;
    function et(v) {
      if (v) {
        var O = v._owner, j = ce(v.type, v._source, O ? O.type : null);
        jo.setExtraStackFrame(j);
      } else
        jo.setExtraStackFrame(null);
    }
    var Pr;
    Pr = !1;
    function Er(v) {
      return typeof v == "object" && v !== null && v.$$typeof === t;
    }
    function Io() {
      {
        if ($r.current) {
          var v = T($r.current.type);
          if (v)
            return `

Check the render method of \`` + v + "`.";
        }
        return "";
      }
    }
    function td(v) {
      return "";
    }
    var Mo = {};
    function rd(v) {
      {
        var O = Io();
        if (!O) {
          var j = typeof v == "string" ? v : v.displayName || v.name;
          j && (O = `

Check the top-level render call using <` + j + ">.");
        }
        return O;
      }
    }
    function Do(v, O) {
      {
        if (!v._store || v._store.validated || v.key != null)
          return;
        v._store.validated = !0;
        var j = rd(O);
        if (Mo[j])
          return;
        Mo[j] = !0;
        var N = "";
        v && v._owner && v._owner !== $r.current && (N = " It was passed a child from " + T(v._owner.type) + "."), et(v), _('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', j, N), et(null);
      }
    }
    function Fo(v, O) {
      {
        if (typeof v != "object")
          return;
        if (Sr(v))
          for (var j = 0; j < v.length; j++) {
            var N = v[j];
            Er(N) && Do(N, O);
          }
        else if (Er(v))
          v._store && (v._store.validated = !0);
        else if (v) {
          var z = m(v);
          if (typeof z == "function" && z !== v.entries)
            for (var G = z.call(v), H; !(H = G.next()).done; )
              Er(H.value) && Do(H.value, O);
        }
      }
    }
    function nd(v) {
      {
        var O = v.type;
        if (O == null || typeof O == "string")
          return;
        var j;
        if (typeof O == "function")
          j = O.propTypes;
        else if (typeof O == "object" && (O.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        O.$$typeof === l))
          j = O.propTypes;
        else
          return;
        if (j) {
          var N = T(O);
          Rr(j, v.props, "prop", N, v);
        } else if (O.PropTypes !== void 0 && !Pr) {
          Pr = !0;
          var z = T(O);
          _("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", z || "Unknown");
        }
        typeof O.getDefaultProps == "function" && !O.getDefaultProps.isReactClassApproved && _("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ad(v) {
      {
        for (var O = Object.keys(v.props), j = 0; j < O.length; j++) {
          var N = O[j];
          if (N !== "children" && N !== "key") {
            et(v), _("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", N), et(null);
            break;
          }
        }
        v.ref !== null && (et(v), _("Invalid attribute `ref` supplied to `React.Fragment`."), et(null));
      }
    }
    var No = {};
    function ko(v, O, j, N, z, G) {
      {
        var H = P(v);
        if (!H) {
          var B = "";
          (v === void 0 || typeof v == "object" && v !== null && Object.keys(v).length === 0) && (B += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ue = td();
          ue ? B += ue : B += Io();
          var Z;
          v === null ? Z = "null" : Sr(v) ? Z = "array" : v !== void 0 && v.$$typeof === t ? (Z = "<" + (T(v.type) || "Unknown") + " />", B = " Did you accidentally export a JSX literal instead of a component?") : Z = typeof v, _("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Z, B);
        }
        var re = ed(v, O, j, z, G);
        if (re == null)
          return re;
        if (H) {
          var _e = O.children;
          if (_e !== void 0)
            if (N)
              if (Sr(_e)) {
                for (var tt = 0; tt < _e.length; tt++)
                  Fo(_e[tt], v);
                Object.freeze && Object.freeze(_e);
              } else
                _("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Fo(_e, v);
        }
        if (Ne.call(O, "key")) {
          var He = T(v), he = Object.keys(O).filter(function(ld) {
            return ld !== "key";
          }), Or = he.length > 0 ? "{key: someKey, " + he.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!No[He + Or]) {
            var ud = he.length > 0 ? "{" + he.join(": ..., ") + ": ...}" : "{}";
            _(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Or, He, ud, He), No[He + Or] = !0;
          }
        }
        return v === n ? ad(re) : nd(re), re;
      }
    }
    function id(v, O, j) {
      return ko(v, O, j, !0);
    }
    function od(v, O, j) {
      return ko(v, O, j, !1);
    }
    var sd = od, cd = id;
    vt.Fragment = n, vt.jsx = sd, vt.jsxs = cd;
  })()), vt;
}
var zo;
function Hd() {
  return zo || (zo = 1, process.env.NODE_ENV === "production" ? Nt.exports = Bd() : Nt.exports = Vd()), Nt.exports;
}
var y = Hd();
function Pe() {
  return Pe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pe.apply(this, arguments);
}
function Gt(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(a) {
    if (e?.(a), r === !1 || !a.defaultPrevented) return t?.(a);
  };
}
function zd(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ud(...e) {
  return (t) => e.forEach(
    (r) => zd(r, t)
  );
}
function oo(...e) {
  return U(Ud(...e), e);
}
function Wd(e, t = []) {
  let r = [];
  function n(i, o) {
    const s = /* @__PURE__ */ wt(o), c = r.length;
    r = [
      ...r,
      o
    ];
    function u(l) {
      const { scope: h, children: f, ...g } = l, p = h?.[e][c] || s, m = W(
        () => g,
        Object.values(g)
      );
      return /* @__PURE__ */ V(p.Provider, {
        value: m
      }, f);
    }
    function d(l, h) {
      const f = h?.[e][c] || s, g = no(f);
      if (g) return g;
      if (o !== void 0) return o;
      throw new Error(`\`${l}\` must be used within \`${i}\``);
    }
    return u.displayName = i + "Provider", [
      u,
      d
    ];
  }
  const a = () => {
    const i = r.map((o) => /* @__PURE__ */ wt(o));
    return function(s) {
      const c = s?.[e] || i;
      return W(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return a.scopeName = e, [
    n,
    Gd(a, ...t)
  ];
}
function Gd(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map(
      (a) => ({
        useScope: a(),
        scopeName: a.scopeName
      })
    );
    return function(i) {
      const o = n.reduce((s, { useScope: c, scopeName: u }) => {
        const l = c(i)[`__scope${u}`];
        return {
          ...s,
          ...l
        };
      }, {});
      return W(
        () => ({
          [`__scope${t.scopeName}`]: o
        }),
        [
          o
        ]
      );
    };
  };
  return r.scopeName = t.scopeName, r;
}
function Qt() {
  return Qt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qt.apply(this, arguments);
}
function Tr(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(a) {
    if (e?.(a), r === !1 || !a.defaultPrevented) return t?.(a);
  };
}
function er() {
  return er = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, er.apply(this, arguments);
}
function Kd(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Yd(...e) {
  return (t) => e.forEach(
    (r) => Kd(r, t)
  );
}
const Ge = /* @__PURE__ */ se((e, t) => {
  const { children: r, ...n } = e, a = st.toArray(r), i = a.find(Jd);
  if (i) {
    const o = i.props.children, s = a.map((c) => c === i ? st.count(o) > 1 ? st.only(null) : /* @__PURE__ */ Zt(o) ? o.props.children : null : c);
    return /* @__PURE__ */ V(Gi, er({}, n, {
      ref: t
    }), /* @__PURE__ */ Zt(o) ? /* @__PURE__ */ lr(o, void 0, s) : null);
  }
  return /* @__PURE__ */ V(Gi, er({}, n, {
    ref: t
  }), r);
});
Ge.displayName = "Slot";
const Gi = /* @__PURE__ */ se((e, t) => {
  const { children: r, ...n } = e;
  return /* @__PURE__ */ Zt(r) ? /* @__PURE__ */ lr(r, {
    ...Zd(n, r.props),
    ref: t ? Yd(t, r.ref) : r.ref
  }) : st.count(r) > 1 ? st.only(null) : null;
});
Gi.displayName = "SlotClone";
const Xd = ({ children: e }) => /* @__PURE__ */ V(El, null, e);
function Jd(e) {
  return /* @__PURE__ */ Zt(e) && e.type === Xd;
}
function Zd(e, t) {
  const r = {
    ...t
  };
  for (const n in t) {
    const a = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? a && i ? r[n] = (...s) => {
      i(...s), a(...s);
    } : a && (r[n] = a) : n === "style" ? r[n] = {
      ...a,
      ...i
    } : n === "className" && (r[n] = [
      a,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...r
  };
}
const Qd = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], eh = Qd.reduce((e, t) => {
  const r = /* @__PURE__ */ se((n, a) => {
    const { asChild: i, ...o } = n, s = i ? Ge : t;
    return Y(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ V(s, Qt({}, o, {
      ref: a
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {});
function th(e, t) {
  e && ql(
    () => e.dispatchEvent(t)
  );
}
function rh(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function nh(...e) {
  return (t) => e.forEach(
    (r) => rh(r, t)
  );
}
function ah(...e) {
  return U(nh(...e), e);
}
function so(e) {
  const t = Q(e);
  return Y(() => {
    t.current = e;
  }), W(
    () => (...r) => {
      var n;
      return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...r);
    },
    []
  );
}
function ih(e, t = globalThis?.document) {
  const r = so(e);
  Y(() => {
    const n = (a) => {
      a.key === "Escape" && r(a);
    };
    return t.addEventListener("keydown", n), () => t.removeEventListener("keydown", n);
  }, [
    r,
    t
  ]);
}
const Ki = "dismissableLayer.update", oh = "dismissableLayer.pointerDownOutside", sh = "dismissableLayer.focusOutside";
let Uo;
const ch = /* @__PURE__ */ wt({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), uh = /* @__PURE__ */ se((e, t) => {
  var r;
  const { disableOutsidePointerEvents: n = !1, onEscapeKeyDown: a, onPointerDownOutside: i, onFocusOutside: o, onInteractOutside: s, onDismiss: c, ...u } = e, d = no(ch), [l, h] = ee(null), f = (r = l?.ownerDocument) !== null && r !== void 0 ? r : globalThis?.document, [, g] = ee({}), p = ah(
    t,
    (x) => h(x)
  ), m = Array.from(d.layers), [b] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), _ = m.indexOf(b), C = l ? m.indexOf(l) : -1, R = d.layersWithOutsidePointerEventsDisabled.size > 0, $ = C >= _, E = lh((x) => {
    const w = x.target, P = [
      ...d.branches
    ].some(
      (S) => S.contains(w)
    );
    !$ || P || (i?.(x), s?.(x), x.defaultPrevented || c?.());
  }, f), A = fh((x) => {
    const w = x.target;
    [
      ...d.branches
    ].some(
      (S) => S.contains(w)
    ) || (o?.(x), s?.(x), x.defaultPrevented || c?.());
  }, f);
  return ih((x) => {
    C === d.layers.size - 1 && (a?.(x), !x.defaultPrevented && c && (x.preventDefault(), c()));
  }, f), Y(() => {
    if (l)
      return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (Uo = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(l)), d.layers.add(l), Wo(), () => {
        n && d.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = Uo);
      };
  }, [
    l,
    f,
    n,
    d
  ]), Y(() => () => {
    l && (d.layers.delete(l), d.layersWithOutsidePointerEventsDisabled.delete(l), Wo());
  }, [
    l,
    d
  ]), Y(() => {
    const x = () => g({});
    return document.addEventListener(Ki, x), () => document.removeEventListener(Ki, x);
  }, []), /* @__PURE__ */ V(eh.div, Qt({}, u, {
    ref: p,
    style: {
      pointerEvents: R ? $ ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Tr(e.onFocusCapture, A.onFocusCapture),
    onBlurCapture: Tr(e.onBlurCapture, A.onBlurCapture),
    onPointerDownCapture: Tr(e.onPointerDownCapture, E.onPointerDownCapture)
  }));
});
function lh(e, t = globalThis?.document) {
  const r = so(e), n = Q(!1), a = Q(() => {
  });
  return Y(() => {
    const i = (s) => {
      if (s.target && !n.current) {
        let u = function() {
          Ml(oh, r, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = u, t.addEventListener("click", a.current, {
          once: !0
        })) : u();
      } else
        t.removeEventListener("click", a.current);
      n.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [
    t,
    r
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function fh(e, t = globalThis?.document) {
  const r = so(e), n = Q(!1);
  return Y(() => {
    const a = (i) => {
      i.target && !n.current && Ml(sh, r, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [
    t,
    r
  ]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function Wo() {
  const e = new CustomEvent(Ki);
  document.dispatchEvent(e);
}
function Ml(e, t, r, { discrete: n }) {
  const a = r.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: r
  });
  t && a.addEventListener(e, t, {
    once: !0
  }), n ? th(a, i) : a.dispatchEvent(i);
}
let qr = 0;
function dh() {
  Y(() => {
    var e, t;
    const r = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = r[0]) !== null && e !== void 0 ? e : Go()), document.body.insertAdjacentElement("beforeend", (t = r[1]) !== null && t !== void 0 ? t : Go()), qr++, () => {
      qr === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (n) => n.remove()
      ), qr--;
    };
  }, []);
}
function Go() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
function tr() {
  return tr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tr.apply(this, arguments);
}
function hh(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ph(...e) {
  return (t) => e.forEach(
    (r) => hh(r, t)
  );
}
function vh(...e) {
  return U(ph(...e), e);
}
const gh = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], mh = gh.reduce((e, t) => {
  const r = /* @__PURE__ */ se((n, a) => {
    const { asChild: i, ...o } = n, s = i ? Ge : t;
    return Y(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ V(s, tr({}, o, {
      ref: a
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {});
function Ko(e) {
  const t = Q(e);
  return Y(() => {
    t.current = e;
  }), W(
    () => (...r) => {
      var n;
      return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...r);
    },
    []
  );
}
const jr = "focusScope.autoFocusOnMount", Ir = "focusScope.autoFocusOnUnmount", Yo = {
  bubbles: !1,
  cancelable: !0
}, bh = /* @__PURE__ */ se((e, t) => {
  const { loop: r = !1, trapped: n = !1, onMountAutoFocus: a, onUnmountAutoFocus: i, ...o } = e, [s, c] = ee(null), u = Ko(a), d = Ko(i), l = Q(null), h = vh(
    t,
    (p) => c(p)
  ), f = Q({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Y(() => {
    if (n) {
      let p = function(C) {
        if (f.paused || !s) return;
        const R = C.target;
        s.contains(R) ? l.current = R : ke(l.current, {
          select: !0
        });
      }, m = function(C) {
        if (f.paused || !s) return;
        const R = C.relatedTarget;
        R !== null && (s.contains(R) || ke(l.current, {
          select: !0
        }));
      }, b = function(C) {
        if (document.activeElement === document.body)
          for (const $ of C) $.removedNodes.length > 0 && ke(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", m);
      const _ = new MutationObserver(b);
      return s && _.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", m), _.disconnect();
      };
    }
  }, [
    n,
    s,
    f.paused
  ]), Y(() => {
    if (s) {
      Jo.add(f);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const b = new CustomEvent(jr, Yo);
        s.addEventListener(jr, u), s.dispatchEvent(b), b.defaultPrevented || (yh(Rh(Dl(s)), {
          select: !0
        }), document.activeElement === p && ke(s));
      }
      return () => {
        s.removeEventListener(jr, u), setTimeout(() => {
          const b = new CustomEvent(Ir, Yo);
          s.addEventListener(Ir, d), s.dispatchEvent(b), b.defaultPrevented || ke(p ?? document.body, {
            select: !0
          }), s.removeEventListener(Ir, d), Jo.remove(f);
        }, 0);
      };
    }
  }, [
    s,
    u,
    d,
    f
  ]);
  const g = U((p) => {
    if (!r && !n || f.paused) return;
    const m = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, b = document.activeElement;
    if (m && b) {
      const _ = p.currentTarget, [C, R] = _h(_);
      C && R ? !p.shiftKey && b === R ? (p.preventDefault(), r && ke(C, {
        select: !0
      })) : p.shiftKey && b === C && (p.preventDefault(), r && ke(R, {
        select: !0
      })) : b === _ && p.preventDefault();
    }
  }, [
    r,
    n,
    f.paused
  ]);
  return /* @__PURE__ */ V(mh.div, tr({
    tabIndex: -1
  }, o, {
    ref: h,
    onKeyDown: g
  }));
});
function yh(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (ke(n, {
      select: t
    }), document.activeElement !== r) return;
}
function _h(e) {
  const t = Dl(e), r = Xo(t, e), n = Xo(t.reverse(), e);
  return [
    r,
    n
  ];
}
function Dl(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const a = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || a ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Xo(e, t) {
  for (const r of e)
    if (!xh(r, {
      upTo: t
    })) return r;
}
function xh(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function wh(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ke(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== r && wh(e) && t && e.select();
  }
}
const Jo = Ch();
function Ch() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && r?.pause(), e = Zo(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = Zo(e, t), (r = e[0]) === null || r === void 0 || r.resume();
    }
  };
}
function Zo(e, t) {
  const r = [
    ...e
  ], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function Rh(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const Sh = globalThis?.document ? Pt : () => {
}, $h = D.useId || (() => {
});
let Ph = 0;
function Eh(e) {
  const [t, r] = D.useState($h());
  return Sh(() => {
    r(
      (n) => n ?? String(Ph++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function Ct() {
  return Ct = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ct.apply(this, arguments);
}
const Oh = ["top", "right", "bottom", "left"], Le = Math.min, me = Math.max, rr = Math.round, kt = Math.floor, Be = (e) => ({
  x: e,
  y: e
}), Ah = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Th = {
  start: "end",
  end: "start"
};
function Yi(e, t, r) {
  return me(e, Le(t, r));
}
function je(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ie(e) {
  return e.split("-")[0];
}
function ft(e) {
  return e.split("-")[1];
}
function co(e) {
  return e === "x" ? "y" : "x";
}
function uo(e) {
  return e === "y" ? "height" : "width";
}
function dt(e) {
  return ["top", "bottom"].includes(Ie(e)) ? "y" : "x";
}
function lo(e) {
  return co(dt(e));
}
function qh(e, t, r) {
  r === void 0 && (r = !1);
  const n = ft(e), a = lo(e), i = uo(a);
  let o = a === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = nr(o)), [o, nr(o)];
}
function jh(e) {
  const t = nr(e);
  return [Xi(e), t, Xi(t)];
}
function Xi(e) {
  return e.replace(/start|end/g, (t) => Th[t]);
}
function Ih(e, t, r) {
  const n = ["left", "right"], a = ["right", "left"], i = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? a : n : t ? n : a;
    case "left":
    case "right":
      return t ? i : o;
    default:
      return [];
  }
}
function Mh(e, t, r, n) {
  const a = ft(e);
  let i = Ih(Ie(e), r === "start", n);
  return a && (i = i.map((o) => o + "-" + a), t && (i = i.concat(i.map(Xi)))), i;
}
function nr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Ah[t]);
}
function Dh(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Fl(e) {
  return typeof e != "number" ? Dh(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ar(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Qo(e, t, r) {
  let {
    reference: n,
    floating: a
  } = e;
  const i = dt(t), o = lo(t), s = uo(o), c = Ie(t), u = i === "y", d = n.x + n.width / 2 - a.width / 2, l = n.y + n.height / 2 - a.height / 2, h = n[s] / 2 - a[s] / 2;
  let f;
  switch (c) {
    case "top":
      f = {
        x: d,
        y: n.y - a.height
      };
      break;
    case "bottom":
      f = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      f = {
        x: n.x + n.width,
        y: l
      };
      break;
    case "left":
      f = {
        x: n.x - a.width,
        y: l
      };
      break;
    default:
      f = {
        x: n.x,
        y: n.y
      };
  }
  switch (ft(t)) {
    case "start":
      f[o] -= h * (r && u ? -1 : 1);
      break;
    case "end":
      f[o] += h * (r && u ? -1 : 1);
      break;
  }
  return f;
}
const Fh = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: o
  } = r, s = i.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let u = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: d,
    y: l
  } = Qo(u, n, c), h = n, f = {}, g = 0;
  for (let p = 0; p < s.length; p++) {
    const {
      name: m,
      fn: b
    } = s[p], {
      x: _,
      y: C,
      data: R,
      reset: $
    } = await b({
      x: d,
      y: l,
      initialPlacement: n,
      placement: h,
      strategy: a,
      middlewareData: f,
      rects: u,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (d = _ ?? d, l = C ?? l, f = {
      ...f,
      [m]: {
        ...f[m],
        ...R
      }
    }, $ && g <= 50) {
      g++, typeof $ == "object" && ($.placement && (h = $.placement), $.rects && (u = $.rects === !0 ? await o.getElementRects({
        reference: e,
        floating: t,
        strategy: a
      }) : $.rects), {
        x: d,
        y: l
      } = Qo(u, h, c)), p = -1;
      continue;
    }
  }
  return {
    x: d,
    y: l,
    placement: h,
    strategy: a,
    middlewareData: f
  };
};
async function Rt(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: a,
    platform: i,
    rects: o,
    elements: s,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: l = "floating",
    altBoundary: h = !1,
    padding: f = 0
  } = je(t, e), g = Fl(f), m = s[h ? l === "floating" ? "reference" : "floating" : l], b = ar(await i.getClippingRect({
    element: (r = await (i.isElement == null ? void 0 : i.isElement(m))) == null || r ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: c
  })), _ = l === "floating" ? {
    ...o.floating,
    x: n,
    y: a
  } : o.reference, C = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), R = await (i.isElement == null ? void 0 : i.isElement(C)) ? await (i.getScale == null ? void 0 : i.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, $ = ar(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: _,
    offsetParent: C,
    strategy: c
  }) : _);
  return {
    top: (b.top - $.top + g.top) / R.y,
    bottom: ($.bottom - b.bottom + g.bottom) / R.y,
    left: (b.left - $.left + g.left) / R.x,
    right: ($.right - b.right + g.right) / R.x
  };
}
const es = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: a,
      rects: i,
      platform: o,
      elements: s
    } = t, {
      element: c,
      padding: u = 0
    } = je(e, t) || {};
    if (c == null)
      return {};
    const d = Fl(u), l = {
      x: r,
      y: n
    }, h = lo(a), f = uo(h), g = await o.getDimensions(c), p = h === "y", m = p ? "top" : "left", b = p ? "bottom" : "right", _ = p ? "clientHeight" : "clientWidth", C = i.reference[f] + i.reference[h] - l[h] - i.floating[f], R = l[h] - i.reference[h], $ = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c));
    let E = $ ? $[_] : 0;
    (!E || !await (o.isElement == null ? void 0 : o.isElement($))) && (E = s.floating[_] || i.floating[f]);
    const A = C / 2 - R / 2, x = E / 2 - g[f] / 2 - 1, w = Le(d[m], x), P = Le(d[b], x), S = w, I = E - g[f] - P, T = E / 2 - g[f] / 2 + A, M = Yi(S, T, I), q = ft(a) != null && T != M && i.reference[f] / 2 - (T < S ? w : P) - g[f] / 2 < 0 ? T < S ? S - T : I - T : 0;
    return {
      [h]: l[h] - q,
      data: {
        [h]: M,
        centerOffset: T - M + q
      }
    };
  }
}), Nh = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r;
      const {
        placement: n,
        middlewareData: a,
        rects: i,
        initialPlacement: o,
        platform: s,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: l,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: f = "none",
        flipAlignment: g = !0,
        ...p
      } = je(e, t), m = Ie(n), b = Ie(o) === o, _ = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), C = l || (b || !g ? [nr(o)] : jh(o));
      !l && f !== "none" && C.push(...Mh(o, g, f, _));
      const R = [o, ...C], $ = await Rt(t, p), E = [];
      let A = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (u && E.push($[m]), d) {
        const S = qh(n, i, _);
        E.push($[S[0]], $[S[1]]);
      }
      if (A = [...A, {
        placement: n,
        overflows: E
      }], !E.every((S) => S <= 0)) {
        var x, w;
        const S = (((x = a.flip) == null ? void 0 : x.index) || 0) + 1, I = R[S];
        if (I)
          return {
            data: {
              index: S,
              overflows: A
            },
            reset: {
              placement: I
            }
          };
        let T = (w = A.filter((M) => M.overflows[0] <= 0).sort((M, F) => M.overflows[1] - F.overflows[1])[0]) == null ? void 0 : w.placement;
        if (!T)
          switch (h) {
            case "bestFit": {
              var P;
              const M = (P = A.map((F) => [F.placement, F.overflows.filter((q) => q > 0).reduce((q, k) => q + k, 0)]).sort((F, q) => F[1] - q[1])[0]) == null ? void 0 : P[0];
              M && (T = M);
              break;
            }
            case "initialPlacement":
              T = o;
              break;
          }
        if (n !== T)
          return {
            reset: {
              placement: T
            }
          };
      }
      return {};
    }
  };
};
function ts(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function rs(e) {
  return Oh.some((t) => e[t] >= 0);
}
const kh = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: n = "referenceHidden",
        ...a
      } = je(e, t);
      switch (n) {
        case "referenceHidden": {
          const i = await Rt(t, {
            ...a,
            elementContext: "reference"
          }), o = ts(i, r.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: rs(o)
            }
          };
        }
        case "escaped": {
          const i = await Rt(t, {
            ...a,
            altBoundary: !0
          }), o = ts(i, r.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: rs(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Lh(e, t) {
  const {
    placement: r,
    platform: n,
    elements: a
  } = e, i = await (n.isRTL == null ? void 0 : n.isRTL(a.floating)), o = Ie(r), s = ft(r), c = dt(r) === "y", u = ["left", "top"].includes(o) ? -1 : 1, d = i && c ? -1 : 1, l = je(t, e);
  let {
    mainAxis: h,
    crossAxis: f,
    alignmentAxis: g
  } = typeof l == "number" ? {
    mainAxis: l,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...l
  };
  return s && typeof g == "number" && (f = s === "end" ? g * -1 : g), c ? {
    x: f * d,
    y: h * u
  } : {
    x: h * u,
    y: f * d
  };
}
const Bh = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n
      } = t, a = await Lh(t, e);
      return {
        x: r + a.x,
        y: n + a.y,
        data: a
      };
    }
  };
}, Vh = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (m) => {
            let {
              x: b,
              y: _
            } = m;
            return {
              x: b,
              y: _
            };
          }
        },
        ...c
      } = je(e, t), u = {
        x: r,
        y: n
      }, d = await Rt(t, c), l = dt(Ie(a)), h = co(l);
      let f = u[h], g = u[l];
      if (i) {
        const m = h === "y" ? "top" : "left", b = h === "y" ? "bottom" : "right", _ = f + d[m], C = f - d[b];
        f = Yi(_, f, C);
      }
      if (o) {
        const m = l === "y" ? "top" : "left", b = l === "y" ? "bottom" : "right", _ = g + d[m], C = g - d[b];
        g = Yi(_, g, C);
      }
      const p = s.fn({
        ...t,
        [h]: f,
        [l]: g
      });
      return {
        ...p,
        data: {
          x: p.x - r,
          y: p.y - n
        }
      };
    }
  };
}, Hh = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: n,
        placement: a,
        rects: i,
        middlewareData: o
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: u = !0
      } = je(e, t), d = {
        x: r,
        y: n
      }, l = dt(a), h = co(l);
      let f = d[h], g = d[l];
      const p = je(s, t), m = typeof p == "number" ? {
        mainAxis: p,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...p
      };
      if (c) {
        const C = h === "y" ? "height" : "width", R = i.reference[h] - i.floating[C] + m.mainAxis, $ = i.reference[h] + i.reference[C] - m.mainAxis;
        f < R ? f = R : f > $ && (f = $);
      }
      if (u) {
        var b, _;
        const C = h === "y" ? "width" : "height", R = ["top", "left"].includes(Ie(a)), $ = i.reference[l] - i.floating[C] + (R && ((b = o.offset) == null ? void 0 : b[l]) || 0) + (R ? 0 : m.crossAxis), E = i.reference[l] + i.reference[C] + (R ? 0 : ((_ = o.offset) == null ? void 0 : _[l]) || 0) - (R ? m.crossAxis : 0);
        g < $ ? g = $ : g > E && (g = E);
      }
      return {
        [h]: f,
        [l]: g
      };
    }
  };
}, zh = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: r,
        rects: n,
        platform: a,
        elements: i
      } = t, {
        apply: o = () => {
        },
        ...s
      } = je(e, t), c = await Rt(t, s), u = Ie(r), d = ft(r), l = dt(r) === "y", {
        width: h,
        height: f
      } = n.floating;
      let g, p;
      u === "top" || u === "bottom" ? (g = u, p = d === (await (a.isRTL == null ? void 0 : a.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (p = u, g = d === "end" ? "top" : "bottom");
      const m = f - c[g], b = h - c[p], _ = !t.middlewareData.shift;
      let C = m, R = b;
      if (l) {
        const E = h - c.left - c.right;
        R = d || _ ? Le(b, E) : E;
      } else {
        const E = f - c.top - c.bottom;
        C = d || _ ? Le(m, E) : E;
      }
      if (_ && !d) {
        const E = me(c.left, 0), A = me(c.right, 0), x = me(c.top, 0), w = me(c.bottom, 0);
        l ? R = h - 2 * (E !== 0 || A !== 0 ? E + A : me(c.left, c.right)) : C = f - 2 * (x !== 0 || w !== 0 ? x + w : me(c.top, c.bottom));
      }
      await o({
        ...t,
        availableWidth: R,
        availableHeight: C
      });
      const $ = await a.getDimensions(i.floating);
      return h !== $.width || f !== $.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ve(e) {
  return Nl(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function be(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function De(e) {
  var t;
  return (t = (Nl(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Nl(e) {
  return e instanceof Node || e instanceof be(e).Node;
}
function Me(e) {
  return e instanceof Element || e instanceof be(e).Element;
}
function Ee(e) {
  return e instanceof HTMLElement || e instanceof be(e).HTMLElement;
}
function ns(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof be(e).ShadowRoot;
}
function At(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: a
  } = xe(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(a);
}
function Uh(e) {
  return ["table", "td", "th"].includes(Ve(e));
}
function fo(e) {
  const t = ho(), r = xe(e);
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function Wh(e) {
  let t = lt(e);
  for (; Ee(t) && !fr(t); ) {
    if (fo(t))
      return t;
    t = lt(t);
  }
  return null;
}
function ho() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function fr(e) {
  return ["html", "body", "#document"].includes(Ve(e));
}
function xe(e) {
  return be(e).getComputedStyle(e);
}
function dr(e) {
  return Me(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function lt(e) {
  if (Ve(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    ns(e) && e.host || // Fallback.
    De(e)
  );
  return ns(t) ? t.host : t;
}
function kl(e) {
  const t = lt(e);
  return fr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ee(t) && At(t) ? t : kl(t);
}
function ir(e, t) {
  var r;
  t === void 0 && (t = []);
  const n = kl(e), a = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = be(n);
  return a ? t.concat(i, i.visualViewport || [], At(n) ? n : []) : t.concat(n, ir(n));
}
function Ll(e) {
  const t = xe(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const a = Ee(e), i = a ? e.offsetWidth : r, o = a ? e.offsetHeight : n, s = rr(r) !== i || rr(n) !== o;
  return s && (r = i, n = o), {
    width: r,
    height: n,
    $: s
  };
}
function po(e) {
  return Me(e) ? e : e.contextElement;
}
function ut(e) {
  const t = po(e);
  if (!Ee(t))
    return Be(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: a,
    $: i
  } = Ll(t);
  let o = (i ? rr(r.width) : r.width) / n, s = (i ? rr(r.height) : r.height) / a;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const Gh = /* @__PURE__ */ Be(0);
function Bl(e) {
  const t = be(e);
  return !ho() || !t.visualViewport ? Gh : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Kh(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== be(e) ? !1 : t;
}
function We(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const a = e.getBoundingClientRect(), i = po(e);
  let o = Be(1);
  t && (n ? Me(n) && (o = ut(n)) : o = ut(e));
  const s = Kh(i, r, n) ? Bl(i) : Be(0);
  let c = (a.left + s.x) / o.x, u = (a.top + s.y) / o.y, d = a.width / o.x, l = a.height / o.y;
  if (i) {
    const h = be(i), f = n && Me(n) ? be(n) : n;
    let g = h.frameElement;
    for (; g && n && f !== h; ) {
      const p = ut(g), m = g.getBoundingClientRect(), b = xe(g), _ = m.left + (g.clientLeft + parseFloat(b.paddingLeft)) * p.x, C = m.top + (g.clientTop + parseFloat(b.paddingTop)) * p.y;
      c *= p.x, u *= p.y, d *= p.x, l *= p.y, c += _, u += C, g = be(g).frameElement;
    }
  }
  return ar({
    width: d,
    height: l,
    x: c,
    y: u
  });
}
function Yh(e) {
  let {
    rect: t,
    offsetParent: r,
    strategy: n
  } = e;
  const a = Ee(r), i = De(r);
  if (r === i)
    return t;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = Be(1);
  const c = Be(0);
  if ((a || !a && n !== "fixed") && ((Ve(r) !== "body" || At(i)) && (o = dr(r)), Ee(r))) {
    const u = We(r);
    s = ut(r), c.x = u.x + r.clientLeft, c.y = u.y + r.clientTop;
  }
  return {
    width: t.width * s.x,
    height: t.height * s.y,
    x: t.x * s.x - o.scrollLeft * s.x + c.x,
    y: t.y * s.y - o.scrollTop * s.y + c.y
  };
}
function Xh(e) {
  return Array.from(e.getClientRects());
}
function Vl(e) {
  return We(De(e)).left + dr(e).scrollLeft;
}
function Jh(e) {
  const t = De(e), r = dr(e), n = e.ownerDocument.body, a = me(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = me(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -r.scrollLeft + Vl(e);
  const s = -r.scrollTop;
  return xe(n).direction === "rtl" && (o += me(t.clientWidth, n.clientWidth) - a), {
    width: a,
    height: i,
    x: o,
    y: s
  };
}
function Zh(e, t) {
  const r = be(e), n = De(e), a = r.visualViewport;
  let i = n.clientWidth, o = n.clientHeight, s = 0, c = 0;
  if (a) {
    i = a.width, o = a.height;
    const u = ho();
    (!u || u && t === "fixed") && (s = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s,
    y: c
  };
}
function Qh(e, t) {
  const r = We(e, !0, t === "fixed"), n = r.top + e.clientTop, a = r.left + e.clientLeft, i = Ee(e) ? ut(e) : Be(1), o = e.clientWidth * i.x, s = e.clientHeight * i.y, c = a * i.x, u = n * i.y;
  return {
    width: o,
    height: s,
    x: c,
    y: u
  };
}
function as(e, t, r) {
  let n;
  if (t === "viewport")
    n = Zh(e, r);
  else if (t === "document")
    n = Jh(De(e));
  else if (Me(t))
    n = Qh(t, r);
  else {
    const a = Bl(e);
    n = {
      ...t,
      x: t.x - a.x,
      y: t.y - a.y
    };
  }
  return ar(n);
}
function Hl(e, t) {
  const r = lt(e);
  return r === t || !Me(r) || fr(r) ? !1 : xe(r).position === "fixed" || Hl(r, t);
}
function ep(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = ir(e).filter((s) => Me(s) && Ve(s) !== "body"), a = null;
  const i = xe(e).position === "fixed";
  let o = i ? lt(e) : e;
  for (; Me(o) && !fr(o); ) {
    const s = xe(o), c = fo(o);
    !c && s.position === "fixed" && (a = null), (i ? !c && !a : !c && s.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || At(o) && !c && Hl(e, o)) ? n = n.filter((d) => d !== o) : a = s, o = lt(o);
  }
  return t.set(e, n), n;
}
function tp(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: a
  } = e;
  const o = [...r === "clippingAncestors" ? ep(t, this._c) : [].concat(r), n], s = o[0], c = o.reduce((u, d) => {
    const l = as(t, d, a);
    return u.top = me(l.top, u.top), u.right = Le(l.right, u.right), u.bottom = Le(l.bottom, u.bottom), u.left = me(l.left, u.left), u;
  }, as(t, s, a));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function rp(e) {
  return Ll(e);
}
function np(e, t, r) {
  const n = Ee(t), a = De(t), i = r === "fixed", o = We(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Be(0);
  if (n || !n && !i)
    if ((Ve(t) !== "body" || At(a)) && (s = dr(t)), n) {
      const u = We(t, !0, i, t);
      c.x = u.x + t.clientLeft, c.y = u.y + t.clientTop;
    } else a && (c.x = Vl(a));
  return {
    x: o.left + s.scrollLeft - c.x,
    y: o.top + s.scrollTop - c.y,
    width: o.width,
    height: o.height
  };
}
function is(e, t) {
  return !Ee(e) || xe(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function zl(e, t) {
  const r = be(e);
  if (!Ee(e))
    return r;
  let n = is(e, t);
  for (; n && Uh(n) && xe(n).position === "static"; )
    n = is(n, t);
  return n && (Ve(n) === "html" || Ve(n) === "body" && xe(n).position === "static" && !fo(n)) ? r : n || Wh(e) || r;
}
const ap = async function(e) {
  let {
    reference: t,
    floating: r,
    strategy: n
  } = e;
  const a = this.getOffsetParent || zl, i = this.getDimensions;
  return {
    reference: np(t, await a(r), n),
    floating: {
      x: 0,
      y: 0,
      ...await i(r)
    }
  };
};
function ip(e) {
  return xe(e).direction === "rtl";
}
const op = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Yh,
  getDocumentElement: De,
  getClippingRect: tp,
  getOffsetParent: zl,
  getElementRects: ap,
  getClientRects: Xh,
  getDimensions: rp,
  getScale: ut,
  isElement: Me,
  isRTL: ip
};
function sp(e, t) {
  let r = null, n;
  const a = De(e);
  function i() {
    clearTimeout(n), r && r.disconnect(), r = null;
  }
  function o(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), i();
    const {
      left: u,
      top: d,
      width: l,
      height: h
    } = e.getBoundingClientRect();
    if (s || t(), !l || !h)
      return;
    const f = kt(d), g = kt(a.clientWidth - (u + l)), p = kt(a.clientHeight - (d + h)), m = kt(u), _ = {
      rootMargin: -f + "px " + -g + "px " + -p + "px " + -m + "px",
      threshold: me(0, Le(1, c)) || 1
    };
    let C = !0;
    function R($) {
      const E = $[0].intersectionRatio;
      if (E !== c) {
        if (!C)
          return o();
        E ? o(!1, E) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 100);
      }
      C = !1;
    }
    try {
      r = new IntersectionObserver(R, {
        ..._,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(R, _);
    }
    r.observe(e);
  }
  return o(!0), i;
}
function cp(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = n, u = po(e), d = a || i ? [...u ? ir(u) : [], ...ir(t)] : [];
  d.forEach((b) => {
    a && b.addEventListener("scroll", r, {
      passive: !0
    }), i && b.addEventListener("resize", r);
  });
  const l = u && s ? sp(u, r) : null;
  let h = -1, f = null;
  o && (f = new ResizeObserver((b) => {
    let [_] = b;
    _ && _.target === u && f && (f.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      f && f.observe(t);
    })), r();
  }), u && !c && f.observe(u), f.observe(t));
  let g, p = c ? We(e) : null;
  c && m();
  function m() {
    const b = We(e);
    p && (b.x !== p.x || b.y !== p.y || b.width !== p.width || b.height !== p.height) && r(), p = b, g = requestAnimationFrame(m);
  }
  return r(), () => {
    d.forEach((b) => {
      a && b.removeEventListener("scroll", r), i && b.removeEventListener("resize", r);
    }), l && l(), f && f.disconnect(), f = null, c && cancelAnimationFrame(g);
  };
}
const up = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), a = {
    platform: op,
    ...r
  }, i = {
    ...a.platform,
    _c: n
  };
  return Fh(e, t, {
    ...a,
    platform: i
  });
}, lp = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: n,
        padding: a
      } = typeof e == "function" ? e(r) : e;
      return n && t(n) ? n.current != null ? es({
        element: n.current,
        padding: a
      }).fn(r) : {} : n ? es({
        element: n,
        padding: a
      }).fn(r) : {};
    }
  };
};
var Kt = typeof document < "u" ? Pt : Y;
function or(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r != t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!or(e[n], t[n]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), r = a.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const i = a[n];
      if (!(i === "_owner" && e.$$typeof) && !or(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Ul(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function os(e, t) {
  const r = Ul(e);
  return Math.round(t * r) / r;
}
function ss(e) {
  const t = D.useRef(e);
  return Kt(() => {
    t.current = e;
  }), t;
}
function fp(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: a,
    elements: {
      reference: i,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: u
  } = e, [d, l] = D.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, f] = D.useState(n);
  or(h, n) || f(n);
  const [g, p] = D.useState(null), [m, b] = D.useState(null), _ = D.useCallback((q) => {
    q != E.current && (E.current = q, p(q));
  }, [p]), C = D.useCallback((q) => {
    q !== A.current && (A.current = q, b(q));
  }, [b]), R = i || g, $ = o || m, E = D.useRef(null), A = D.useRef(null), x = D.useRef(d), w = ss(c), P = ss(a), S = D.useCallback(() => {
    if (!E.current || !A.current)
      return;
    const q = {
      placement: t,
      strategy: r,
      middleware: h
    };
    P.current && (q.platform = P.current), up(E.current, A.current, q).then((k) => {
      const L = {
        ...k,
        isPositioned: !0
      };
      I.current && !or(x.current, L) && (x.current = L, gd.flushSync(() => {
        l(L);
      }));
    });
  }, [h, t, r, P]);
  Kt(() => {
    u === !1 && x.current.isPositioned && (x.current.isPositioned = !1, l((q) => ({
      ...q,
      isPositioned: !1
    })));
  }, [u]);
  const I = D.useRef(!1);
  Kt(() => (I.current = !0, () => {
    I.current = !1;
  }), []), Kt(() => {
    if (R && (E.current = R), $ && (A.current = $), R && $) {
      if (w.current)
        return w.current(R, $, S);
      S();
    }
  }, [R, $, S, w]);
  const T = D.useMemo(() => ({
    reference: E,
    floating: A,
    setReference: _,
    setFloating: C
  }), [_, C]), M = D.useMemo(() => ({
    reference: R,
    floating: $
  }), [R, $]), F = D.useMemo(() => {
    const q = {
      position: r,
      left: 0,
      top: 0
    };
    if (!M.floating)
      return q;
    const k = os(M.floating, d.x), L = os(M.floating, d.y);
    return s ? {
      ...q,
      transform: "translate(" + k + "px, " + L + "px)",
      ...Ul(M.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: k,
      top: L
    };
  }, [r, s, M.floating, d.x, d.y]);
  return D.useMemo(() => ({
    ...d,
    update: S,
    refs: T,
    elements: M,
    floatingStyles: F
  }), [d, S, T, M, F]);
}
const dp = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Wl = dp.reduce((e, t) => {
  const r = /* @__PURE__ */ se((n, a) => {
    const { asChild: i, ...o } = n, s = i ? Ge : t;
    return Y(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ V(s, Ct({}, o, {
      ref: a
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {});
function hp(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function pp(...e) {
  return (t) => e.forEach(
    (r) => hp(r, t)
  );
}
function Gl(...e) {
  return U(pp(...e), e);
}
function vp(e, t = []) {
  let r = [];
  function n(i, o) {
    const s = /* @__PURE__ */ wt(o), c = r.length;
    r = [
      ...r,
      o
    ];
    function u(l) {
      const { scope: h, children: f, ...g } = l, p = h?.[e][c] || s, m = W(
        () => g,
        Object.values(g)
      );
      return /* @__PURE__ */ V(p.Provider, {
        value: m
      }, f);
    }
    function d(l, h) {
      const f = h?.[e][c] || s, g = no(f);
      if (g) return g;
      if (o !== void 0) return o;
      throw new Error(`\`${l}\` must be used within \`${i}\``);
    }
    return u.displayName = i + "Provider", [
      u,
      d
    ];
  }
  const a = () => {
    const i = r.map((o) => /* @__PURE__ */ wt(o));
    return function(s) {
      const c = s?.[e] || i;
      return W(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return a.scopeName = e, [
    n,
    gp(a, ...t)
  ];
}
function gp(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map(
      (a) => ({
        useScope: a(),
        scopeName: a.scopeName
      })
    );
    return function(i) {
      const o = n.reduce((s, { useScope: c, scopeName: u }) => {
        const l = c(i)[`__scope${u}`];
        return {
          ...s,
          ...l
        };
      }, {});
      return W(
        () => ({
          [`__scope${t.scopeName}`]: o
        }),
        [
          o
        ]
      );
    };
  };
  return r.scopeName = t.scopeName, r;
}
function mp(e) {
  const t = Q(e);
  return Y(() => {
    t.current = e;
  }), W(
    () => (...r) => {
      var n;
      return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...r);
    },
    []
  );
}
const Ji = globalThis?.document ? Pt : () => {
};
function bp(e) {
  const [t, r] = ee(void 0);
  return Ji(() => {
    if (e) {
      r({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const n = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length) return;
        const i = a[0];
        let o, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, u = Array.isArray(c) ? c[0] : c;
          o = u.inlineSize, s = u.blockSize;
        } else
          o = e.offsetWidth, s = e.offsetHeight;
        r({
          width: o,
          height: s
        });
      });
      return n.observe(e, {
        box: "border-box"
      }), () => n.unobserve(e);
    } else
      r(void 0);
  }, [
    e
  ]), t;
}
const Kl = "Popper", [Yl, Xl] = vp(Kl), [yp, Jl] = Yl(Kl), _p = (e) => {
  const { __scopePopper: t, children: r } = e, [n, a] = ee(null);
  return /* @__PURE__ */ V(yp, {
    scope: t,
    anchor: n,
    onAnchorChange: a
  }, r);
}, xp = "PopperAnchor", wp = /* @__PURE__ */ se((e, t) => {
  const { __scopePopper: r, virtualRef: n, ...a } = e, i = Jl(xp, r), o = Q(null), s = Gl(t, o);
  return Y(() => {
    i.onAnchorChange(n?.current || o.current);
  }), n ? null : /* @__PURE__ */ V(Wl.div, Ct({}, a, {
    ref: s
  }));
}), Zl = "PopperContent", [Cp, Zy] = Yl(Zl), Rp = /* @__PURE__ */ se((e, t) => {
  var r, n, a, i, o, s, c, u;
  const { __scopePopper: d, side: l = "bottom", sideOffset: h = 0, align: f = "center", alignOffset: g = 0, arrowPadding: p = 0, avoidCollisions: m = !0, collisionBoundary: b = [], collisionPadding: _ = 0, sticky: C = "partial", hideWhenDetached: R = !1, updatePositionStrategy: $ = "optimized", onPlaced: E, ...A } = e, x = Jl(Zl, d), [w, P] = ee(null), S = Gl(
    t,
    (ce) => P(ce)
  ), [I, T] = ee(null), M = bp(I), F = (r = M?.width) !== null && r !== void 0 ? r : 0, q = (n = M?.height) !== null && n !== void 0 ? n : 0, k = l + (f !== "center" ? "-" + f : ""), L = typeof _ == "number" ? _ : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ..._
  }, te = Array.isArray(b) ? b : [
    b
  ], ae = te.length > 0, ne = {
    padding: L,
    boundary: te.filter(Sp),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: ae
  }, { refs: pe, floatingStyles: oe, placement: le, isPositioned: ve, middlewareData: J } = fp({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: k,
    whileElementsMounted: (...ce) => cp(...ce, {
      animationFrame: $ === "always"
    }),
    elements: {
      reference: x.anchor
    },
    middleware: [
      Bh({
        mainAxis: h + q,
        alignmentAxis: g
      }),
      m && Vh({
        mainAxis: !0,
        crossAxis: !1,
        limiter: C === "partial" ? Hh() : void 0,
        ...ne
      }),
      m && Nh({
        ...ne
      }),
      zh({
        ...ne,
        apply: ({ elements: ce, rects: Ne, availableWidth: Mt, availableHeight: Dt }) => {
          const { width: Ze, height: Rr } = Ne.reference, Qe = ce.floating.style;
          Qe.setProperty("--radix-popper-available-width", `${Mt}px`), Qe.setProperty("--radix-popper-available-height", `${Dt}px`), Qe.setProperty("--radix-popper-anchor-width", `${Ze}px`), Qe.setProperty("--radix-popper-anchor-height", `${Rr}px`);
        }
      }),
      I && lp({
        element: I,
        padding: p
      }),
      $p({
        arrowWidth: F,
        arrowHeight: q
      }),
      R && kh({
        strategy: "referenceHidden",
        ...ne
      })
    ]
  }), [ge, fe] = Ql(le), ie = mp(E);
  Ji(() => {
    ve && ie?.();
  }, [
    ve,
    ie
  ]);
  const ye = (a = J.arrow) === null || a === void 0 ? void 0 : a.x, Ae = (i = J.arrow) === null || i === void 0 ? void 0 : i.y, Fe = ((o = J.arrow) === null || o === void 0 ? void 0 : o.centerOffset) !== 0, [de, Te] = ee();
  return Ji(() => {
    w && Te(window.getComputedStyle(w).zIndex);
  }, [
    w
  ]), /* @__PURE__ */ V("div", {
    ref: pe.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...oe,
      transform: ve ? oe.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: de,
      "--radix-popper-transform-origin": [
        (s = J.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = J.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ V(Cp, {
    scope: d,
    placedSide: ge,
    onArrowChange: T,
    arrowX: ye,
    arrowY: Ae,
    shouldHideArrow: Fe
  }, /* @__PURE__ */ V(Wl.div, Ct({
    "data-side": ge,
    "data-align": fe
  }, A, {
    ref: S,
    style: {
      ...A.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: ve ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (u = J.hide) !== null && u !== void 0 && u.referenceHidden ? 0 : void 0
    }
  }))));
});
function Sp(e) {
  return e !== null;
}
const $p = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var r, n, a, i, o;
    const { placement: s, rects: c, middlewareData: u } = t, l = ((r = u.arrow) === null || r === void 0 ? void 0 : r.centerOffset) !== 0, h = l ? 0 : e.arrowWidth, f = l ? 0 : e.arrowHeight, [g, p] = Ql(s), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[p], b = ((n = (a = u.arrow) === null || a === void 0 ? void 0 : a.x) !== null && n !== void 0 ? n : 0) + h / 2, _ = ((i = (o = u.arrow) === null || o === void 0 ? void 0 : o.y) !== null && i !== void 0 ? i : 0) + f / 2;
    let C = "", R = "";
    return g === "bottom" ? (C = l ? m : `${b}px`, R = `${-f}px`) : g === "top" ? (C = l ? m : `${b}px`, R = `${c.floating.height + f}px`) : g === "right" ? (C = `${-f}px`, R = l ? m : `${_}px`) : g === "left" && (C = `${c.floating.width + f}px`, R = l ? m : `${_}px`), {
      data: {
        x: C,
        y: R
      }
    };
  }
});
function Ql(e) {
  const [t, r = "center"] = e.split("-");
  return [
    t,
    r
  ];
}
const Pp = _p, Ep = wp, Op = Rp;
function sr() {
  return sr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sr.apply(this, arguments);
}
const Ap = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Tp = Ap.reduce((e, t) => {
  const r = /* @__PURE__ */ se((n, a) => {
    const { asChild: i, ...o } = n, s = i ? Ge : t;
    return Y(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ V(s, sr({}, o, {
      ref: a
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {}), qp = /* @__PURE__ */ se((e, t) => {
  var r;
  const { container: n = globalThis == null || (r = globalThis.document) === null || r === void 0 ? void 0 : r.body, ...a } = e;
  return n ? /* @__PURE__ */ md.createPortal(/* @__PURE__ */ V(Tp.div, sr({}, a, {
    ref: t
  })), n) : null;
}), cs = globalThis?.document ? Pt : () => {
};
function jp(e, t) {
  return fd((r, n) => {
    const a = t[r][n];
    return a ?? r;
  }, e);
}
const vo = (e) => {
  const { present: t, children: r } = e, n = Ip(t), a = typeof r == "function" ? r({
    present: n.isPresent
  }) : st.only(r), i = oo(n.ref, a.ref);
  return typeof r == "function" || n.isPresent ? /* @__PURE__ */ lr(a, {
    ref: i
  }) : null;
};
vo.displayName = "Presence";
function Ip(e) {
  const [t, r] = ee(), n = Q({}), a = Q(e), i = Q("none"), o = e ? "mounted" : "unmounted", [s, c] = jp(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Y(() => {
    const u = Lt(n.current);
    i.current = s === "mounted" ? u : "none";
  }, [
    s
  ]), cs(() => {
    const u = n.current, d = a.current;
    if (d !== e) {
      const h = i.current, f = Lt(u);
      e ? c("MOUNT") : f === "none" || u?.display === "none" ? c("UNMOUNT") : c(d && h !== f ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [
    e,
    c
  ]), cs(() => {
    if (t) {
      const u = (l) => {
        const f = Lt(n.current).includes(l.animationName);
        l.target === t && f && ql(
          () => c("ANIMATION_END")
        );
      }, d = (l) => {
        l.target === t && (i.current = Lt(n.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: U((u) => {
      u && (n.current = getComputedStyle(u)), r(u);
    }, [])
  };
}
function Lt(e) {
  return e?.animationName || "none";
}
const Mp = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Dp = Mp.reduce((e, t) => {
  const r = /* @__PURE__ */ se((n, a) => {
    const { asChild: i, ...o } = n, s = i ? Ge : t;
    return Y(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ V(s, Pe({}, o, {
      ref: a
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {});
function ef(e) {
  const t = Q(e);
  return Y(() => {
    t.current = e;
  }), W(
    () => (...r) => {
      var n;
      return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...r);
    },
    []
  );
}
function Fp({ prop: e, defaultProp: t, onChange: r = () => {
} }) {
  const [n, a] = Np({
    defaultProp: t,
    onChange: r
  }), i = e !== void 0, o = i ? e : n, s = ef(r), c = U((u) => {
    if (i) {
      const l = typeof u == "function" ? u(e) : u;
      l !== e && s(l);
    } else a(u);
  }, [
    i,
    e,
    a,
    s
  ]);
  return [
    o,
    c
  ];
}
function Np({ defaultProp: e, onChange: t }) {
  const r = ee(e), [n] = r, a = Q(n), i = ef(t);
  return Y(() => {
    a.current !== n && (i(n), a.current = n);
  }, [
    n,
    a,
    i
  ]), r;
}
var kp = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, rt = /* @__PURE__ */ new WeakMap(), Bt = /* @__PURE__ */ new WeakMap(), Vt = {}, Mr = 0, tf = function(e) {
  return e && (e.host || tf(e.parentNode));
}, Lp = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = tf(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, Bp = function(e, t, r, n) {
  var a = Lp(t, Array.isArray(e) ? e : [e]);
  Vt[r] || (Vt[r] = /* @__PURE__ */ new WeakMap());
  var i = Vt[r], o = [], s = /* @__PURE__ */ new Set(), c = new Set(a), u = function(l) {
    !l || s.has(l) || (s.add(l), u(l.parentNode));
  };
  a.forEach(u);
  var d = function(l) {
    !l || c.has(l) || Array.prototype.forEach.call(l.children, function(h) {
      if (s.has(h))
        d(h);
      else {
        var f = h.getAttribute(n), g = f !== null && f !== "false", p = (rt.get(h) || 0) + 1, m = (i.get(h) || 0) + 1;
        rt.set(h, p), i.set(h, m), o.push(h), p === 1 && g && Bt.set(h, !0), m === 1 && h.setAttribute(r, "true"), g || h.setAttribute(n, "true");
      }
    });
  };
  return d(t), s.clear(), Mr++, function() {
    o.forEach(function(l) {
      var h = rt.get(l) - 1, f = i.get(l) - 1;
      rt.set(l, h), i.set(l, f), h || (Bt.has(l) || l.removeAttribute(n), Bt.delete(l)), f || l.removeAttribute(r);
    }), Mr--, Mr || (rt = /* @__PURE__ */ new WeakMap(), rt = /* @__PURE__ */ new WeakMap(), Bt = /* @__PURE__ */ new WeakMap(), Vt = {});
  };
}, Vp = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), a = kp(e);
  return a ? (n.push.apply(n, Array.from(a.querySelectorAll("[aria-live]"))), Bp(n, a, r, "aria-hidden")) : function() {
    return null;
  };
}, $e = function() {
  return $e = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, $e.apply(this, arguments);
};
function rf(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
function Hp(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, i; n < a; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Yt = "right-scroll-bar-position", Xt = "width-before-scroll-bar", zp = "with-scroll-bars-hidden", Up = "--removed-body-scroll-bar-size";
function Wp(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Gp(e, t) {
  var r = ee(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var a = r.value;
          a !== n && (r.value = n, r.callback(n, a));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
function Kp(e, t) {
  return Gp(null, function(r) {
    return e.forEach(function(n) {
      return Wp(n, r);
    });
  });
}
function Yp(e) {
  return e;
}
function Xp(e, t) {
  t === void 0 && (t = Yp);
  var r = [], n = !1, a = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(i) {
      var o = t(i, n);
      return r.push(o), function() {
        r = r.filter(function(s) {
          return s !== o;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (n = !0; r.length; ) {
        var o = r;
        r = [], o.forEach(i);
      }
      r = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(i) {
      n = !0;
      var o = [];
      if (r.length) {
        var s = r;
        r = [], s.forEach(i), o = r;
      }
      var c = function() {
        var d = o;
        o = [], d.forEach(i);
      }, u = function() {
        return Promise.resolve().then(c);
      };
      u(), r = {
        push: function(d) {
          o.push(d), u();
        },
        filter: function(d) {
          return o = o.filter(d), r;
        }
      };
    }
  };
  return a;
}
function Jp(e) {
  e === void 0 && (e = {});
  var t = Xp(null);
  return t.options = $e({ async: !0, ssr: !1 }, e), t;
}
var nf = function(e) {
  var t = e.sideCar, r = rf(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return D.createElement(n, $e({}, r));
};
nf.isSideCarExport = !0;
function Zp(e, t) {
  return e.useMedium(t), nf;
}
var af = Jp(), Dr = function() {
}, hr = D.forwardRef(function(e, t) {
  var r = D.useRef(null), n = D.useState({
    onScrollCapture: Dr,
    onWheelCapture: Dr,
    onTouchMoveCapture: Dr
  }), a = n[0], i = n[1], o = e.forwardProps, s = e.children, c = e.className, u = e.removeScrollBar, d = e.enabled, l = e.shards, h = e.sideCar, f = e.noIsolation, g = e.inert, p = e.allowPinchZoom, m = e.as, b = m === void 0 ? "div" : m, _ = rf(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), C = h, R = Kp([r, t]), $ = $e($e({}, _), a);
  return D.createElement(
    D.Fragment,
    null,
    d && D.createElement(C, { sideCar: af, removeScrollBar: u, shards: l, noIsolation: f, inert: g, setCallbacks: i, allowPinchZoom: !!p, lockRef: r }),
    o ? D.cloneElement(D.Children.only(s), $e($e({}, $), { ref: R })) : D.createElement(b, $e({}, $, { className: c, ref: R }), s)
  );
});
hr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
hr.classNames = {
  fullWidth: Xt,
  zeroRight: Yt
};
var Qp = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function ev() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Qp();
  return t && e.setAttribute("nonce", t), e;
}
function tv(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function rv(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var nv = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = ev()) && (tv(t, r), rv(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, av = function() {
  var e = nv();
  return function(t, r) {
    D.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, of = function() {
  var e = av(), t = function(r) {
    var n = r.styles, a = r.dynamic;
    return e(n, a), null;
  };
  return t;
}, iv = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Fr = function(e) {
  return parseInt(e || "", 10) || 0;
}, ov = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Fr(r), Fr(n), Fr(a)];
}, sv = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return iv;
  var t = ov(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, cv = of(), uv = function(e, t, r, n) {
  var a = e.left, i = e.top, o = e.right, s = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(zp, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(s, "px ").concat(n, `;
  }
  body {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(s, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Yt, ` {
    right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Xt, ` {
    margin-right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Yt, " .").concat(Yt, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Xt, " .").concat(Xt, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body {
    `).concat(Up, ": ").concat(s, `px;
  }
`);
}, lv = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, a = n === void 0 ? "margin" : n, i = D.useMemo(function() {
    return sv(a);
  }, [a]);
  return D.createElement(cv, { styles: uv(i, !t, a, r ? "" : "!important") });
}, Zi = !1;
if (typeof window < "u")
  try {
    var Ht = Object.defineProperty({}, "passive", {
      get: function() {
        return Zi = !0, !0;
      }
    });
    window.addEventListener("test", Ht, Ht), window.removeEventListener("test", Ht, Ht);
  } catch {
    Zi = !1;
  }
var nt = Zi ? { passive: !1 } : !1, fv = function(e) {
  return e.tagName === "TEXTAREA";
}, sf = function(e, t) {
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !fv(e) && r[t] === "visible")
  );
}, dv = function(e) {
  return sf(e, "overflowY");
}, hv = function(e) {
  return sf(e, "overflowX");
}, us = function(e, t) {
  var r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var n = cf(e, r);
    if (n) {
      var a = uf(e, r), i = a[1], o = a[2];
      if (i > o)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== document.body);
  return !1;
}, pv = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, vv = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, cf = function(e, t) {
  return e === "v" ? dv(t) : hv(t);
}, uf = function(e, t) {
  return e === "v" ? pv(t) : vv(t);
}, gv = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, mv = function(e, t, r, n, a) {
  var i = gv(e, window.getComputedStyle(t).direction), o = i * n, s = r.target, c = t.contains(s), u = !1, d = o > 0, l = 0, h = 0;
  do {
    var f = uf(e, s), g = f[0], p = f[1], m = f[2], b = p - m - i * g;
    (g || b) && cf(e, s) && (l += b, h += g), s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (d && l === 0 || !d && h === 0) && (u = !0), u;
}, zt = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, ls = function(e) {
  return [e.deltaX, e.deltaY];
}, fs = function(e) {
  return e && "current" in e ? e.current : e;
}, bv = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, yv = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, _v = 0, at = [];
function xv(e) {
  var t = D.useRef([]), r = D.useRef([0, 0]), n = D.useRef(), a = D.useState(_v++)[0], i = D.useState(function() {
    return of();
  })[0], o = D.useRef(e);
  D.useEffect(function() {
    o.current = e;
  }, [e]), D.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = Hp([e.lockRef.current], (e.shards || []).map(fs), !0).filter(Boolean);
      return p.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = D.useCallback(function(p, m) {
    if ("touches" in p && p.touches.length === 2)
      return !o.current.allowPinchZoom;
    var b = zt(p), _ = r.current, C = "deltaX" in p ? p.deltaX : _[0] - b[0], R = "deltaY" in p ? p.deltaY : _[1] - b[1], $, E = p.target, A = Math.abs(C) > Math.abs(R) ? "h" : "v";
    if ("touches" in p && A === "h" && E.type === "range")
      return !1;
    var x = us(A, E);
    if (!x)
      return !0;
    if (x ? $ = A : ($ = A === "v" ? "h" : "v", x = us(A, E)), !x)
      return !1;
    if (!n.current && "changedTouches" in p && (C || R) && (n.current = $), !$)
      return !0;
    var w = n.current || $;
    return mv(w, m, p, w === "h" ? C : R);
  }, []), c = D.useCallback(function(p) {
    var m = p;
    if (!(!at.length || at[at.length - 1] !== i)) {
      var b = "deltaY" in m ? ls(m) : zt(m), _ = t.current.filter(function($) {
        return $.name === m.type && $.target === m.target && bv($.delta, b);
      })[0];
      if (_ && _.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!_) {
        var C = (o.current.shards || []).map(fs).filter(Boolean).filter(function($) {
          return $.contains(m.target);
        }), R = C.length > 0 ? s(m, C[0]) : !o.current.noIsolation;
        R && m.cancelable && m.preventDefault();
      }
    }
  }, []), u = D.useCallback(function(p, m, b, _) {
    var C = { name: p, delta: m, target: b, should: _ };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(R) {
        return R !== C;
      });
    }, 1);
  }, []), d = D.useCallback(function(p) {
    r.current = zt(p), n.current = void 0;
  }, []), l = D.useCallback(function(p) {
    u(p.type, ls(p), p.target, s(p, e.lockRef.current));
  }, []), h = D.useCallback(function(p) {
    u(p.type, zt(p), p.target, s(p, e.lockRef.current));
  }, []);
  D.useEffect(function() {
    return at.push(i), e.setCallbacks({
      onScrollCapture: l,
      onWheelCapture: l,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", c, nt), document.addEventListener("touchmove", c, nt), document.addEventListener("touchstart", d, nt), function() {
      at = at.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", c, nt), document.removeEventListener("touchmove", c, nt), document.removeEventListener("touchstart", d, nt);
    };
  }, []);
  var f = e.removeScrollBar, g = e.inert;
  return D.createElement(
    D.Fragment,
    null,
    g ? D.createElement(i, { styles: yv(a) }) : null,
    f ? D.createElement(lv, { gapMode: "margin" }) : null
  );
}
const wv = Zp(af, xv);
var lf = D.forwardRef(function(e, t) {
  return D.createElement(hr, $e({}, e, { ref: t, sideCar: wv }));
});
lf.classNames = hr.classNames;
const ff = "Popover", [df, Qy] = Wd(ff, [
  Xl
]), go = Xl(), [Cv, ht] = df(ff), Rv = (e) => {
  const { __scopePopover: t, children: r, open: n, defaultOpen: a, onOpenChange: i, modal: o = !1 } = e, s = go(t), c = Q(null), [u, d] = ee(!1), [l = !1, h] = Fp({
    prop: n,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ V(Pp, s, /* @__PURE__ */ V(Cv, {
    scope: t,
    contentId: Eh(),
    triggerRef: c,
    open: l,
    onOpenChange: h,
    onOpenToggle: U(
      () => h(
        (f) => !f
      ),
      [
        h
      ]
    ),
    hasCustomAnchor: u,
    onCustomAnchorAdd: U(
      () => d(!0),
      []
    ),
    onCustomAnchorRemove: U(
      () => d(!1),
      []
    ),
    modal: o
  }, r));
}, Sv = "PopoverTrigger", $v = /* @__PURE__ */ se((e, t) => {
  const { __scopePopover: r, ...n } = e, a = ht(Sv, r), i = go(r), o = oo(t, a.triggerRef), s = /* @__PURE__ */ V(Dp.button, Pe({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": a.open,
    "aria-controls": a.contentId,
    "data-state": vf(a.open)
  }, n, {
    ref: o,
    onClick: Gt(e.onClick, a.onOpenToggle)
  }));
  return a.hasCustomAnchor ? s : /* @__PURE__ */ V(Ep, Pe({
    asChild: !0
  }, i), s);
}), hf = "PopoverPortal", [Pv, Ev] = df(hf, {
  forceMount: void 0
}), Ov = (e) => {
  const { __scopePopover: t, forceMount: r, children: n, container: a } = e, i = ht(hf, t);
  return /* @__PURE__ */ V(Pv, {
    scope: t,
    forceMount: r
  }, /* @__PURE__ */ V(vo, {
    present: r || i.open
  }, /* @__PURE__ */ V(qp, {
    asChild: !0,
    container: a
  }, n)));
}, St = "PopoverContent", Av = /* @__PURE__ */ se((e, t) => {
  const r = Ev(St, e.__scopePopover), { forceMount: n = r.forceMount, ...a } = e, i = ht(St, e.__scopePopover);
  return /* @__PURE__ */ V(vo, {
    present: n || i.open
  }, i.modal ? /* @__PURE__ */ V(Tv, Pe({}, a, {
    ref: t
  })) : /* @__PURE__ */ V(qv, Pe({}, a, {
    ref: t
  })));
}), Tv = /* @__PURE__ */ se((e, t) => {
  const r = ht(St, e.__scopePopover), n = Q(null), a = oo(t, n), i = Q(!1);
  return Y(() => {
    const o = n.current;
    if (o) return Vp(o);
  }, []), /* @__PURE__ */ V(lf, {
    as: Ge,
    allowPinchZoom: !0
  }, /* @__PURE__ */ V(pf, Pe({}, e, {
    ref: a,
    trapFocus: r.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Gt(e.onCloseAutoFocus, (o) => {
      var s;
      o.preventDefault(), i.current || (s = r.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: Gt(e.onPointerDownOutside, (o) => {
      const s = o.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, u = s.button === 2 || c;
      i.current = u;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: Gt(
      e.onFocusOutside,
      (o) => o.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), qv = /* @__PURE__ */ se((e, t) => {
  const r = ht(St, e.__scopePopover), n = Q(!1), a = Q(!1);
  return /* @__PURE__ */ V(pf, Pe({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var o;
      if ((o = e.onCloseAutoFocus) === null || o === void 0 || o.call(e, i), !i.defaultPrevented) {
        var s;
        n.current || (s = r.triggerRef.current) === null || s === void 0 || s.focus(), i.preventDefault();
      }
      n.current = !1, a.current = !1;
    },
    onInteractOutside: (i) => {
      var o, s;
      (o = e.onInteractOutside) === null || o === void 0 || o.call(e, i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (a.current = !0));
      const c = i.target;
      !((s = r.triggerRef.current) === null || s === void 0) && s.contains(c) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && a.current && i.preventDefault();
    }
  }));
}), pf = /* @__PURE__ */ se((e, t) => {
  const { __scopePopover: r, trapFocus: n, onOpenAutoFocus: a, onCloseAutoFocus: i, disableOutsidePointerEvents: o, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: u, onInteractOutside: d, ...l } = e, h = ht(St, r), f = go(r);
  return dh(), /* @__PURE__ */ V(bh, {
    asChild: !0,
    loop: !0,
    trapped: n,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ V(uh, {
    asChild: !0,
    disableOutsidePointerEvents: o,
    onInteractOutside: d,
    onEscapeKeyDown: s,
    onPointerDownOutside: c,
    onFocusOutside: u,
    onDismiss: () => h.onOpenChange(!1)
  }, /* @__PURE__ */ V(Op, Pe({
    "data-state": vf(h.open),
    role: "dialog",
    id: h.contentId
  }, f, l, {
    ref: t,
    style: {
      ...l.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
});
function vf(e) {
  return e ? "open" : "closed";
}
const gf = Rv, mf = $v, bf = Ov, yf = Av, jv = "_tooltip_5svgn_1", Iv = "_popover_5svgn_5", ds = {
  tooltip: jv,
  popover: Iv
}, e0 = ({
  actions: e,
  buttonProps: { onClick: t, ...r } = {},
  side: n = "bottom",
  align: a = "end"
}) => {
  const [i, o] = ee(!1), s = U(
    (u) => {
      u.stopPropagation(), t?.(u);
    },
    [t]
  );
  if (!e.length) return null;
  const c = (u, d) => {
    switch (u.type) {
      case "button":
      case "link": {
        const l = /* @__PURE__ */ y.jsx(
          Ar.Item,
          {
            icon: u.icon,
            onClick: (h) => {
              u.onClick?.(h), o(!1);
            },
            isDisabled: u.disabled ?? !1,
            children: /* @__PURE__ */ y.jsxs(
              X,
              {
                as: "span",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "2px",
                children: [
                  /* @__PURE__ */ y.jsx("span", { children: u.label }),
                  u.description && /* @__PURE__ */ y.jsx(K.Paragraph, { as: "span", variant: "4", subdued: !0, children: u.description })
                ]
              }
            )
          }
        );
        return /* @__PURE__ */ y.jsx(
          Et,
          {
            className: ds.tooltip,
            content: u.tooltip,
            children: u.type === "link" ? lr(u.link, {
              children: l
            }) : l
          },
          d
        );
      }
      case "divider":
        return /* @__PURE__ */ y.jsx(Ar.Divider, {}, d);
      default:
        return null;
    }
  };
  return /* @__PURE__ */ y.jsxs(gf, { open: i, onOpenChange: o, children: [
    /* @__PURE__ */ y.jsx(mf, { asChild: !0, children: /* @__PURE__ */ y.jsx(
      ao,
      {
        variant: "tertiary",
        icon: "dots-v",
        onClick: s,
        ...r
      }
    ) }),
    /* @__PURE__ */ y.jsx(bf, { children: /* @__PURE__ */ y.jsx(
      yf,
      {
        className: ds.popover,
        side: n,
        align: a,
        sideOffset: 8,
        onOpenAutoFocus: (u) => u.preventDefault(),
        children: /* @__PURE__ */ y.jsx(Ar, { children: e.map((u, d) => c(u, d)) })
      }
    ) })
  ] });
};
var gt = {}, Qi = function() {
  return (Qi = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    return e;
  }).apply(this, arguments);
}, Mv = (function() {
  function e(t, r, n) {
    var a = this;
    this.endVal = r, this.options = n, this.version = "2.6.0", this.defaults = { startVal: 0, decimalPlaces: 0, duration: 2, useEasing: !0, useGrouping: !0, useIndianSeparators: !1, smartEasingThreshold: 999, smartEasingAmount: 333, separator: ",", decimal: ".", prefix: "", suffix: "", enableScrollSpy: !1, scrollSpyDelay: 200, scrollSpyOnce: !1 }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(i) {
      a.startTime || (a.startTime = i);
      var o = i - a.startTime;
      a.remaining = a.duration - o, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(o, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(o, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (o / a.duration);
      var s = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
      a.frameVal = s ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), o < a.duration ? a.rAF = requestAnimationFrame(a.count) : a.finalEndVal !== null ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
    }, this.formatNumber = function(i) {
      var o, s, c, u, d = i < 0 ? "-" : "";
      o = Math.abs(i).toFixed(a.options.decimalPlaces);
      var l = (o += "").split(".");
      if (s = l[0], c = l.length > 1 ? a.options.decimal + l[1] : "", a.options.useGrouping) {
        u = "";
        for (var h = 3, f = 0, g = 0, p = s.length; g < p; ++g) a.options.useIndianSeparators && g === 4 && (h = 2, f = 1), g !== 0 && f % h == 0 && (u = a.options.separator + u), f++, u = s[p - g - 1] + u;
        s = u;
      }
      return a.options.numerals && a.options.numerals.length && (s = s.replace(/[0-9]/g, function(m) {
        return a.options.numerals[+m];
      }), c = c.replace(/[0-9]/g, function(m) {
        return a.options.numerals[+m];
      })), d + a.options.prefix + s + c + a.options.suffix;
    }, this.easeOutExpo = function(i, o, s, c) {
      return s * (1 - Math.pow(2, -10 * i / c)) * 1024 / 1023 + o;
    }, this.options = Qi(Qi({}, this.defaults), n), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(r), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, this.options.separator === "" && (this.options.useGrouping = !1), this.el = typeof t == "string" ? document.getElementById(t) : t, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", typeof window < "u" && this.options.enableScrollSpy && (this.error ? console.error(this.error, t) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
      return a.handleScroll(a);
    }), window.onscroll = function() {
      window.onScrollFns.forEach(function(i) {
        return i();
      });
    }, this.handleScroll(this)));
  }
  return e.prototype.handleScroll = function(t) {
    if (t && window && !t.once) {
      var r = window.innerHeight + window.scrollY, n = t.el.getBoundingClientRect(), a = n.top + window.pageYOffset, i = n.top + n.height + window.pageYOffset;
      i < r && i > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function() {
        return t.start();
      }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > i || a > r) && !t.paused && t.reset();
    }
  }, e.prototype.determineDirectionAndSmartEasing = function() {
    var t = this.finalEndVal ? this.finalEndVal : this.endVal;
    this.countDown = this.startVal > t;
    var r = t - this.startVal;
    if (Math.abs(r) > this.options.smartEasingThreshold && this.options.useEasing) {
      this.finalEndVal = t;
      var n = this.countDown ? 1 : -1;
      this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
    } else this.endVal = t, this.finalEndVal = null;
    this.finalEndVal !== null ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
  }, e.prototype.start = function(t) {
    this.error || (t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
  }, e.prototype.pauseResume = function() {
    this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
  }, e.prototype.reset = function() {
    cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
  }, e.prototype.update = function(t) {
    cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal == null && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
  }, e.prototype.printValue = function(t) {
    var r;
    if (this.el) {
      var n = this.formattingFn(t);
      (r = this.options.plugin) !== null && r !== void 0 && r.render ? this.options.plugin.render(this.el, n) : this.el.tagName === "INPUT" ? this.el.value = n : this.el.tagName === "text" || this.el.tagName === "tspan" ? this.el.textContent = n : this.el.innerHTML = n;
    }
  }, e.prototype.ensureNumber = function(t) {
    return typeof t == "number" && !isNaN(t);
  }, e.prototype.validateValue = function(t) {
    var r = Number(t);
    return this.ensureNumber(r) ? r : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
  }, e.prototype.resetDuration = function() {
    this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
  }, e;
})();
const Dv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CountUp: Mv
}, Symbol.toStringTag, { value: "Module" })), Fv = /* @__PURE__ */ Ld(Dv);
var hs;
function Nv() {
  if (hs) return gt;
  hs = 1, Object.defineProperty(gt, "__esModule", { value: !0 });
  var e = ro, t = Fv;
  function r(x, w) {
    var P = x == null ? null : typeof Symbol < "u" && x[Symbol.iterator] || x["@@iterator"];
    if (P != null) {
      var S, I, T, M, F = [], q = !0, k = !1;
      try {
        if (T = (P = P.call(x)).next, w !== 0) for (; !(q = (S = T.call(P)).done) && (F.push(S.value), F.length !== w); q = !0) ;
      } catch (L) {
        k = !0, I = L;
      } finally {
        try {
          if (!q && P.return != null && (M = P.return(), Object(M) !== M)) return;
        } finally {
          if (k) throw I;
        }
      }
      return F;
    }
  }
  function n(x, w) {
    var P = Object.keys(x);
    if (Object.getOwnPropertySymbols) {
      var S = Object.getOwnPropertySymbols(x);
      w && (S = S.filter(function(I) {
        return Object.getOwnPropertyDescriptor(x, I).enumerable;
      })), P.push.apply(P, S);
    }
    return P;
  }
  function a(x) {
    for (var w = 1; w < arguments.length; w++) {
      var P = arguments[w] != null ? arguments[w] : {};
      w % 2 ? n(Object(P), !0).forEach(function(S) {
        i(x, S, P[S]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(x, Object.getOwnPropertyDescriptors(P)) : n(Object(P)).forEach(function(S) {
        Object.defineProperty(x, S, Object.getOwnPropertyDescriptor(P, S));
      });
    }
    return x;
  }
  function i(x, w, P) {
    return w = p(w), w in x ? Object.defineProperty(x, w, {
      value: P,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : x[w] = P, x;
  }
  function o() {
    return o = Object.assign ? Object.assign.bind() : function(x) {
      for (var w = 1; w < arguments.length; w++) {
        var P = arguments[w];
        for (var S in P)
          Object.prototype.hasOwnProperty.call(P, S) && (x[S] = P[S]);
      }
      return x;
    }, o.apply(this, arguments);
  }
  function s(x, w) {
    if (x == null) return {};
    var P = {}, S = Object.keys(x), I, T;
    for (T = 0; T < S.length; T++)
      I = S[T], !(w.indexOf(I) >= 0) && (P[I] = x[I]);
    return P;
  }
  function c(x, w) {
    if (x == null) return {};
    var P = s(x, w), S, I;
    if (Object.getOwnPropertySymbols) {
      var T = Object.getOwnPropertySymbols(x);
      for (I = 0; I < T.length; I++)
        S = T[I], !(w.indexOf(S) >= 0) && Object.prototype.propertyIsEnumerable.call(x, S) && (P[S] = x[S]);
    }
    return P;
  }
  function u(x, w) {
    return d(x) || r(x, w) || l(x, w) || f();
  }
  function d(x) {
    if (Array.isArray(x)) return x;
  }
  function l(x, w) {
    if (x) {
      if (typeof x == "string") return h(x, w);
      var P = Object.prototype.toString.call(x).slice(8, -1);
      if (P === "Object" && x.constructor && (P = x.constructor.name), P === "Map" || P === "Set") return Array.from(x);
      if (P === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(P)) return h(x, w);
    }
  }
  function h(x, w) {
    (w == null || w > x.length) && (w = x.length);
    for (var P = 0, S = new Array(w); P < w; P++) S[P] = x[P];
    return S;
  }
  function f() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function g(x, w) {
    if (typeof x != "object" || x === null) return x;
    var P = x[Symbol.toPrimitive];
    if (P !== void 0) {
      var S = P.call(x, w);
      if (typeof S != "object") return S;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (w === "string" ? String : Number)(x);
  }
  function p(x) {
    var w = g(x, "string");
    return typeof w == "symbol" ? w : String(w);
  }
  var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? e.useLayoutEffect : e.useEffect;
  function b(x) {
    var w = e.useRef(x);
    return m(function() {
      w.current = x;
    }), e.useCallback(function() {
      for (var P = arguments.length, S = new Array(P), I = 0; I < P; I++)
        S[I] = arguments[I];
      return w.current.apply(void 0, S);
    }, []);
  }
  var _ = function(w, P) {
    var S = P.decimal, I = P.decimals, T = P.duration, M = P.easingFn, F = P.end, q = P.formattingFn, k = P.numerals, L = P.prefix, te = P.separator, ae = P.start, ne = P.suffix, pe = P.useEasing, oe = P.useGrouping, le = P.useIndianSeparators, ve = P.enableScrollSpy, J = P.scrollSpyDelay, ge = P.scrollSpyOnce;
    return new t.CountUp(w, F, {
      startVal: ae,
      duration: T,
      decimal: S,
      decimalPlaces: I,
      easingFn: M,
      formattingFn: q,
      numerals: k,
      separator: te,
      prefix: L,
      suffix: ne,
      useEasing: pe,
      useIndianSeparators: le,
      useGrouping: oe,
      enableScrollSpy: ve,
      scrollSpyDelay: J,
      scrollSpyOnce: ge
    });
  }, C = ["ref", "startOnMount", "enableReinitialize", "delay", "onEnd", "onStart", "onPauseResume", "onReset", "onUpdate"], R = {
    decimal: ".",
    separator: ",",
    delay: null,
    prefix: "",
    suffix: "",
    duration: 2,
    start: 0,
    decimals: 0,
    startOnMount: !0,
    enableReinitialize: !0,
    useEasing: !0,
    useGrouping: !0,
    useIndianSeparators: !1
  }, $ = function(w) {
    var P = Object.fromEntries(Object.entries(w).filter(function(de) {
      var Te = u(de, 2), ce = Te[1];
      return ce !== void 0;
    })), S = e.useMemo(function() {
      return a(a({}, R), P);
    }, [w]), I = S.ref, T = S.startOnMount, M = S.enableReinitialize, F = S.delay, q = S.onEnd, k = S.onStart, L = S.onPauseResume, te = S.onReset, ae = S.onUpdate, ne = c(S, C), pe = e.useRef(), oe = e.useRef(), le = e.useRef(!1), ve = b(function() {
      return _(typeof I == "string" ? I : I.current, ne);
    }), J = b(function(de) {
      var Te = pe.current;
      if (Te && !de)
        return Te;
      var ce = ve();
      return pe.current = ce, ce;
    }), ge = b(function() {
      var de = function() {
        return J(!0).start(function() {
          q?.({
            pauseResume: fe,
            reset: ie,
            start: Ae,
            update: ye
          });
        });
      };
      F && F > 0 ? oe.current = setTimeout(de, F * 1e3) : de(), k?.({
        pauseResume: fe,
        reset: ie,
        update: ye
      });
    }), fe = b(function() {
      J().pauseResume(), L?.({
        reset: ie,
        start: Ae,
        update: ye
      });
    }), ie = b(function() {
      J().el && (oe.current && clearTimeout(oe.current), J().reset(), te?.({
        pauseResume: fe,
        start: Ae,
        update: ye
      }));
    }), ye = b(function(de) {
      J().update(de), ae?.({
        pauseResume: fe,
        reset: ie,
        start: Ae
      });
    }), Ae = b(function() {
      ie(), ge();
    }), Fe = b(function(de) {
      T && (de && ie(), ge());
    });
    return e.useEffect(function() {
      le.current ? M && Fe(!0) : (le.current = !0, Fe());
    }, [M, le, Fe, F, w.start, w.suffix, w.prefix, w.duration, w.separator, w.decimals, w.decimal, w.formattingFn]), e.useEffect(function() {
      return function() {
        ie();
      };
    }, [ie]), {
      start: Ae,
      pauseResume: fe,
      reset: ie,
      update: ye,
      getCountUp: J
    };
  }, E = ["className", "redraw", "containerProps", "children", "style"], A = function(w) {
    var P = w.className, S = w.redraw, I = w.containerProps, T = w.children, M = w.style, F = c(w, E), q = e.useRef(null), k = e.useRef(!1), L = $(a(a({}, F), {}, {
      ref: q,
      startOnMount: typeof T != "function" || w.delay === 0,
      // component manually restarts
      enableReinitialize: !1
    })), te = L.start, ae = L.reset, ne = L.update, pe = L.pauseResume, oe = L.getCountUp, le = b(function() {
      te();
    }), ve = b(function(fe) {
      w.preserveValue || ae(), ne(fe);
    }), J = b(function() {
      if (typeof w.children == "function" && !(q.current instanceof Element)) {
        console.error(`Couldn't find attached element to hook the CountUp instance into! Try to attach "containerRef" from the render prop to a an Element, eg. <span ref={containerRef} />.`);
        return;
      }
      oe();
    });
    e.useEffect(function() {
      J();
    }, [J]), e.useEffect(function() {
      k.current && ve(w.end);
    }, [w.end, ve]);
    var ge = S && w;
    return e.useEffect(function() {
      S && k.current && le();
    }, [le, S, ge]), e.useEffect(function() {
      !S && k.current && le();
    }, [le, S, w.start, w.suffix, w.prefix, w.duration, w.separator, w.decimals, w.decimal, w.className, w.formattingFn]), e.useEffect(function() {
      k.current = !0;
    }, []), typeof T == "function" ? T({
      countUpRef: q,
      start: te,
      reset: ae,
      update: ne,
      pauseResume: pe,
      getCountUp: oe
    }) : /* @__PURE__ */ e.createElement("span", o({
      className: P,
      ref: q,
      style: M
    }, I), typeof w.start < "u" ? oe().formattingFn(w.start) : "");
  };
  return gt.default = A, gt.useCountUp = $, gt;
}
var kv = Nv();
const Lv = /* @__PURE__ */ Re(kv), Bv = "_bar_1n5dj_1", Vv = "_section_1n5dj_5", Hv = "_sectionHidden_1n5dj_8", zv = "_sectionInheritRadius_1n5dj_11", Uv = "_valueOutside_1n5dj_15", it = {
  bar: Bv,
  section: Vv,
  sectionHidden: Hv,
  sectionInheritRadius: zv,
  valueOutside: Uv
}, Jt = ({
  value: e,
  label: t,
  labelWidth: r,
  theme: n = ["var(--dixa-color-purple-700)", "var(--dixa-color-neutral-200)"],
  showFullBar: a = !1,
  showDifference: i = !1
}) => {
  const o = Math.min(e, 100), [s, c] = ee([
    null,
    null
  ]), u = jl(s);
  Y(() => {
    c([
      o,
      ...a ? [100 - o] : []
    ]);
  }, [o, a]);
  const d = 1.5, l = W(
    () => s.map((h, f) => {
      const g = o && f === 0 || i, p = h !== null && h < 20, m = qe(it.section, {
        [it.sectionHidden]: a && h === 0,
        [it.sectionInheritRadius]: !a
      }), b = qe(it.section, {
        [it.valueOutside]: p
      });
      return /* @__PURE__ */ y.jsx(
        X,
        {
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "0 100",
          background: n[f],
          color: "neutral.000",
          className: m,
          style: {
            flexBasis: `${h ?? 0}%`,
            transition: `flex-basis ${d}s ease-out`
          },
          children: g && /* @__PURE__ */ y.jsx(
            K.Paragraph,
            {
              className: b,
              variant: "4",
              color: f === 0 && !p ? "var(--dixa-color-neutral-000)" : "var(--dixa-color-neutral-900)",
              children: /* @__PURE__ */ y.jsx(
                Lv,
                {
                  start: u?.[f] ?? 0,
                  end: h ?? 0,
                  duration: d,
                  delay: 0,
                  suffix: "%",
                  children: ({ countUpRef: _ }) => /* @__PURE__ */ y.jsx("span", { ref: _ })
                }
              )
            }
          )
        },
        f
      );
    }),
    [
      o,
      n,
      i,
      a,
      s,
      u
    ]
  );
  return /* @__PURE__ */ y.jsxs(X, { alignItems: "center", gap: "200", children: [
    t && /* @__PURE__ */ y.jsx(io, { minWidth: r ? `${r}px` : "auto", children: /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "4", children: t }) }),
    /* @__PURE__ */ y.jsx(X, { flex: "1", className: it.bar, height: "20px", borderRadius: "50", children: l })
  ] });
};
function ze(e, t = { compact: !1 }) {
  if (e < 1e3)
    return `${(e / 1e3).toFixed(0)}s`;
  const r = Math.floor(e / 1e3 % 60), n = Math.floor(e / (1e3 * 60) % 60), a = Math.floor(e / (1e3 * 60 * 60) % 24), i = Math.floor(e / (1e3 * 60 * 60 * 24)), o = (c, u) => c > 0 ? `${c}${u}` : "";
  return [
    o(i, "d"),
    o(a, "h"),
    o(n, "m") || (t.compact ? "" : "0m"),
    o(r, "s") || (t.compact ? "" : "0s")
  ].filter(Boolean).join(" ");
}
function cr(e) {
  return /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?(Z|[+-]\d{2}:\d{2})?)?$/.test(e) ? ct(e, ct.ISO_8601, !0).isValid() : !1;
}
const ps = 1e6, vs = 1e3;
function _f(e) {
  if (e < vs) return `${e}`;
  const t = e >= ps;
  return `${parseFloat(
    (e / (t ? ps : vs)).toFixed(1)
  )}${t ? "M" : "K"}`;
}
function $t(e) {
  return e.toLocaleString(navigator.language);
}
const t0 = (e) => ({
  metrics: e.filter(Wv),
  chart: e.find(Gv),
  heatmap: e.find(Kv),
  table: e.find(Yv),
  presence: e.find(Xv),
  insight: e.find(Jv)
}), Wv = (e) => e.type === "metric", Gv = (e) => e.type === "chart" && e.visualization !== "heatmap", Kv = (e) => e.type === "chart" && e.visualization === "heatmap", Yv = (e) => e.type === "table", Xv = (e) => e.type === "presence", Jv = (e) => e.type === "ai_insight", Tt = (e, t) => {
  switch (t) {
    case "duration":
      return ze(e).split(" ").slice(0, 2).join(" ");
    case "count":
      return _f(e);
    case "number":
      return $t(e);
    case "percentage":
      return `${$t(e)}%`;
    case "timer":
      return ze(e);
    default:
      return "";
  }
}, ur = {
  default: 8,
  rating: 5
}, eo = Il.purple[700], Zv = (e) => /^#|^rgb(a)?\(|^hsl(a)?\(|^var\(/.test(e), Qv = (e) => {
  const [t, r] = e.split("-"), n = Number(r);
  return ur[t] ? n >= 1 && n <= ur[t] : !1;
}, xf = (e) => Zv(e) ? e : Qv(e) ? `var(--dixa-analytics-color-${e}, ${eo})` : eo, ot = (e, t = "default", r) => {
  if (r)
    return xf(r);
  const n = ur[t] ?? ur.default, a = e % n + 1;
  return `var(--dixa-analytics-color-${t}-${a}, ${eo})`;
}, eg = "_container_1t2a7_1", tg = {
  container: eg
}, rg = we(
  function({
    granularities: t,
    onChangeGranularity: r
  }) {
    return /* @__PURE__ */ y.jsx(Ol, { variant: "secondary", children: t.map(({ value: n, selected: a }) => /* @__PURE__ */ y.jsx(
      Al,
      {
        onClick: a ? void 0 : () => r?.(n),
        active: a,
        children: n
      },
      n
    )) });
  }
), ng = "_root_6kwn9_1", ag = "_rootBounded_6kwn9_7", ig = "_rootFluid_6kwn9_7", Nr = {
  root: ng,
  rootBounded: ag,
  rootFluid: ig
}, to = ({
  bounded: e = !1,
  fluid: t = !1,
  children: r
}) => {
  const n = qe(Nr.root, {
    [Nr.rootBounded]: e,
    [Nr.rootFluid]: t
  });
  return /* @__PURE__ */ y.jsx("div", { className: n, children: r });
}, og = we(
  function({
    data: t
  }) {
    const [r, n] = ee(0);
    return Y(() => {
      n(Math.max(0, Date.now() - t));
    }, [t]), bd(() => {
      n(Math.max(0, Date.now() - t));
    }, 1e3), /* @__PURE__ */ y.jsx(y.Fragment, { children: Tt(r, "timer") });
  }
), sg = "_wrapper_1w7q6_1", cg = "_text_1w7q6_6", gs = {
  wrapper: sg,
  text: cg
}, ug = we(function({
  className: t,
  data: r,
  format: n,
  color: a,
  suffix: i
}) {
  const o = W(() => r === null ? "n.a." : n === "timer" ? /* @__PURE__ */ y.jsx(og, { data: r }) : Tt(r, n), [r, n]), s = W(() => {
    if (r !== null)
      switch (n) {
        case "duration":
          return ze(r);
        case "count":
          return $t(r);
        default:
          return;
      }
  }, [r, n]), u = !(r !== null && s !== o) || ["number", "percentage", "timer"].includes(n);
  return /* @__PURE__ */ y.jsx(
    Et,
    {
      content: s,
      disabled: u,
      wrap: "div",
      wrapProps: { className: gs.wrapper },
      children: /* @__PURE__ */ y.jsxs(
        K.Heading,
        {
          variant: "heading-1",
          color: a ?? (r === null ? "tertiary" : void 0),
          className: qe(gs.text, t),
          as: "span",
          children: [
            o,
            i
          ]
        }
      )
    }
  );
}), lg = "_colorIndicator_luubh_1", fg = {
  colorIndicator: lg
}, wf = we(function({
  instrument: t,
  theme: r = "light"
}) {
  const { data: n, format: a, title: i, description: o, color: s } = t, c = s ? xf(s) : void 0, u = r === "dark" ? "inherit" : void 0;
  return /* @__PURE__ */ y.jsxs(X, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ y.jsxs(X, { alignItems: "center", gap: "100", title: i, children: [
      s && /* @__PURE__ */ y.jsx(
        io,
        {
          as: "span",
          className: fg.colorIndicator,
          background: c
        }
      ),
      /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "4", color: u, subdued: !0, children: i })
    ] }),
    /* @__PURE__ */ y.jsx(ug, { data: n, format: a, color: u }),
    o && /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "4", color: u, subdued: !0, children: o })
  ] });
}), dg = {
  fontFamily: "var(--dixa-typography-family-default)",
  fontSize: "var(--dixa-typography-size-200)",
  fill: "var(--dixa-typography-color-tertiary)"
}, hg = {
  bar: "chart-bar",
  line: "chart-line",
  area: "chart-area",
  pie: "chart-pie",
  donut: "chart-donut"
}, Ue = {
  tickCount: 5,
  tickProps: dg,
  visualizationIcons: hg
}, pg = ({ categories: e, series: t }, { omitZero: r }) => e.map((n, a) => {
  const i = t.reduce(
    (o, { label: s, data: c }) => {
      const { value: u } = pr(c[a]);
      return (r ? !u : u === null) ? o : { ...o, [s]: u };
    },
    {}
  );
  return {
    name: n.label,
    ...i
  };
}), pr = (e) => e === null || typeof e == "number" ? { value: e } : {
  value: e?.value ?? null,
  metrics: e?.metrics
};
var kr, ms;
function Cf() {
  if (ms) return kr;
  ms = 1;
  var e = typeof Ft == "object" && Ft && Ft.Object === Object && Ft;
  return kr = e, kr;
}
var Lr, bs;
function Oe() {
  if (bs) return Lr;
  bs = 1;
  var e = Cf(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return Lr = r, Lr;
}
var Br, ys;
function qt() {
  if (ys) return Br;
  ys = 1;
  var e = Oe(), t = e.Symbol;
  return Br = t, Br;
}
var Vr, _s;
function Rf() {
  if (_s) return Vr;
  _s = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, i = Array(a); ++n < a; )
      i[n] = r(t[n], n, t);
    return i;
  }
  return Vr = e, Vr;
}
var Hr, xs;
function Se() {
  if (xs) return Hr;
  xs = 1;
  var e = Array.isArray;
  return Hr = e, Hr;
}
var zr, ws;
function vg() {
  if (ws) return zr;
  ws = 1;
  var e = qt(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, a = e ? e.toStringTag : void 0;
  function i(o) {
    var s = r.call(o, a), c = o[a];
    try {
      o[a] = void 0;
      var u = !0;
    } catch {
    }
    var d = n.call(o);
    return u && (s ? o[a] = c : delete o[a]), d;
  }
  return zr = i, zr;
}
var Ur, Cs;
function gg() {
  if (Cs) return Ur;
  Cs = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return Ur = r, Ur;
}
var Wr, Rs;
function Ke() {
  if (Rs) return Wr;
  Rs = 1;
  var e = qt(), t = vg(), r = gg(), n = "[object Null]", a = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function o(s) {
    return s == null ? s === void 0 ? a : n : i && i in Object(s) ? t(s) : r(s);
  }
  return Wr = o, Wr;
}
var Gr, Ss;
function Ye() {
  if (Ss) return Gr;
  Ss = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return Gr = e, Gr;
}
var Kr, $s;
function jt() {
  if ($s) return Kr;
  $s = 1;
  var e = Ke(), t = Ye(), r = "[object Symbol]";
  function n(a) {
    return typeof a == "symbol" || t(a) && e(a) == r;
  }
  return Kr = n, Kr;
}
var Yr, Ps;
function Sf() {
  if (Ps) return Yr;
  Ps = 1;
  var e = qt(), t = Rf(), r = Se(), n = jt(), a = e ? e.prototype : void 0, i = a ? a.toString : void 0;
  function o(s) {
    if (typeof s == "string")
      return s;
    if (r(s))
      return t(s, o) + "";
    if (n(s))
      return i ? i.call(s) : "";
    var c = s + "";
    return c == "0" && 1 / s == -1 / 0 ? "-0" : c;
  }
  return Yr = o, Yr;
}
var Xr, Es;
function mg() {
  if (Es) return Xr;
  Es = 1;
  function e(t, r, n) {
    var a = -1, i = t.length;
    r < 0 && (r = -r > i ? 0 : i + r), n = n > i ? i : n, n < 0 && (n += i), i = r > n ? 0 : n - r >>> 0, r >>>= 0;
    for (var o = Array(i); ++a < i; )
      o[a] = t[a + r];
    return o;
  }
  return Xr = e, Xr;
}
var Jr, Os;
function $f() {
  if (Os) return Jr;
  Os = 1;
  var e = mg();
  function t(r, n, a) {
    var i = r.length;
    return a = a === void 0 ? i : a, !n && a >= i ? r : e(r, n, a);
  }
  return Jr = t, Jr;
}
var Zr, As;
function vr() {
  if (As) return Zr;
  As = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, i = "\\ufe0e\\ufe0f", o = "\\u200d", s = RegExp("[" + o + e + a + i + "]");
  function c(u) {
    return s.test(u);
  }
  return Zr = c, Zr;
}
var Qr, Ts;
function Xe() {
  if (Ts) return Qr;
  Ts = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return Qr = e, Qr;
}
var en, qs;
function bg() {
  if (qs) return en;
  qs = 1;
  var e = Ke(), t = Ye(), r = "[object RegExp]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return en = n, en;
}
var tn, js;
function mo() {
  if (js) return tn;
  js = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return tn = e, tn;
}
var _t = { exports: {} };
_t.exports;
var Is;
function Pf() {
  return Is || (Is = 1, (function(e, t) {
    var r = Cf(), n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, s = (function() {
      try {
        var c = a && a.require && a.require("util").types;
        return c || o && o.binding && o.binding("util");
      } catch {
      }
    })();
    e.exports = s;
  })(_t, _t.exports)), _t.exports;
}
var rn, Ms;
function yg() {
  if (Ms) return rn;
  Ms = 1;
  var e = bg(), t = mo(), r = Pf(), n = r && r.isRegExp, a = n ? t(n) : e;
  return rn = a, rn;
}
var nn, Ds;
function Ef() {
  if (Ds) return nn;
  Ds = 1;
  function e(t) {
    return function(r) {
      return r?.[t];
    };
  }
  return nn = e, nn;
}
var an, Fs;
function _g() {
  if (Fs) return an;
  Fs = 1;
  var e = Ef(), t = e("length");
  return an = t, an;
}
var on, Ns;
function xg() {
  if (Ns) return on;
  Ns = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, i = "\\ufe0e\\ufe0f", o = "[" + e + "]", s = "[" + a + "]", c = "\\ud83c[\\udffb-\\udfff]", u = "(?:" + s + "|" + c + ")", d = "[^" + e + "]", l = "(?:\\ud83c[\\udde6-\\uddff]){2}", h = "[\\ud800-\\udbff][\\udc00-\\udfff]", f = "\\u200d", g = u + "?", p = "[" + i + "]?", m = "(?:" + f + "(?:" + [d, l, h].join("|") + ")" + p + g + ")*", b = p + g + m, _ = "(?:" + [d + s + "?", s, l, h, o].join("|") + ")", C = RegExp(c + "(?=" + c + ")|" + _ + b, "g");
  function R($) {
    for (var E = C.lastIndex = 0; C.test($); )
      ++E;
    return E;
  }
  return on = R, on;
}
var sn, ks;
function wg() {
  if (ks) return sn;
  ks = 1;
  var e = _g(), t = vr(), r = xg();
  function n(a) {
    return t(a) ? r(a) : e(a);
  }
  return sn = n, sn;
}
var cn, Ls;
function Cg() {
  if (Ls) return cn;
  Ls = 1;
  function e(t) {
    return t.split("");
  }
  return cn = e, cn;
}
var un, Bs;
function Rg() {
  if (Bs) return un;
  Bs = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, i = "\\ufe0e\\ufe0f", o = "[" + e + "]", s = "[" + a + "]", c = "\\ud83c[\\udffb-\\udfff]", u = "(?:" + s + "|" + c + ")", d = "[^" + e + "]", l = "(?:\\ud83c[\\udde6-\\uddff]){2}", h = "[\\ud800-\\udbff][\\udc00-\\udfff]", f = "\\u200d", g = u + "?", p = "[" + i + "]?", m = "(?:" + f + "(?:" + [d, l, h].join("|") + ")" + p + g + ")*", b = p + g + m, _ = "(?:" + [d + s + "?", s, l, h, o].join("|") + ")", C = RegExp(c + "(?=" + c + ")|" + _ + b, "g");
  function R($) {
    return $.match(C) || [];
  }
  return un = R, un;
}
var ln, Vs;
function Of() {
  if (Vs) return ln;
  Vs = 1;
  var e = Cg(), t = vr(), r = Rg();
  function n(a) {
    return t(a) ? r(a) : e(a);
  }
  return ln = n, ln;
}
var fn, Hs;
function Sg() {
  if (Hs) return fn;
  Hs = 1;
  var e = /\s/;
  function t(r) {
    for (var n = r.length; n-- && e.test(r.charAt(n)); )
      ;
    return n;
  }
  return fn = t, fn;
}
var dn, zs;
function $g() {
  if (zs) return dn;
  zs = 1;
  var e = Sg(), t = /^\s+/;
  function r(n) {
    return n && n.slice(0, e(n) + 1).replace(t, "");
  }
  return dn = r, dn;
}
var hn, Us;
function Af() {
  if (Us) return hn;
  Us = 1;
  var e = $g(), t = Xe(), r = jt(), n = NaN, a = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, o = /^0o[0-7]+$/i, s = parseInt;
  function c(u) {
    if (typeof u == "number")
      return u;
    if (r(u))
      return n;
    if (t(u)) {
      var d = typeof u.valueOf == "function" ? u.valueOf() : u;
      u = t(d) ? d + "" : d;
    }
    if (typeof u != "string")
      return u === 0 ? u : +u;
    u = e(u);
    var l = i.test(u);
    return l || o.test(u) ? s(u.slice(2), l ? 2 : 8) : a.test(u) ? n : +u;
  }
  return hn = c, hn;
}
var pn, Ws;
function Pg() {
  if (Ws) return pn;
  Ws = 1;
  var e = Af(), t = 1 / 0, r = 17976931348623157e292;
  function n(a) {
    if (!a)
      return a === 0 ? a : 0;
    if (a = e(a), a === t || a === -t) {
      var i = a < 0 ? -1 : 1;
      return i * r;
    }
    return a === a ? a : 0;
  }
  return pn = n, pn;
}
var vn, Gs;
function Eg() {
  if (Gs) return vn;
  Gs = 1;
  var e = Pg();
  function t(r) {
    var n = e(r), a = n % 1;
    return n === n ? a ? n - a : n : 0;
  }
  return vn = t, vn;
}
var gn, Ks;
function gr() {
  if (Ks) return gn;
  Ks = 1;
  var e = Sf();
  function t(r) {
    return r == null ? "" : e(r);
  }
  return gn = t, gn;
}
var mn, Ys;
function Og() {
  if (Ys) return mn;
  Ys = 1;
  var e = Sf(), t = $f(), r = vr(), n = Xe(), a = yg(), i = wg(), o = Of(), s = Eg(), c = gr(), u = 30, d = "...", l = /\w*$/;
  function h(f, g) {
    var p = u, m = d;
    if (n(g)) {
      var b = "separator" in g ? g.separator : b;
      p = "length" in g ? s(g.length) : p, m = "omission" in g ? e(g.omission) : m;
    }
    f = c(f);
    var _ = f.length;
    if (r(f)) {
      var C = o(f);
      _ = C.length;
    }
    if (p >= _)
      return f;
    var R = p - i(m);
    if (R < 1)
      return m;
    var $ = C ? t(C, 0, R).join("") : f.slice(0, R);
    if (b === void 0)
      return $ + m;
    if (C && (R += $.length - R), a(b)) {
      if (f.slice(R).search(b)) {
        var E, A = $;
        for (b.global || (b = RegExp(b.source, c(l.exec(b)) + "g")), b.lastIndex = 0; E = b.exec(A); )
          var x = E.index;
        $ = $.slice(0, x === void 0 ? R : x);
      }
    } else if (f.indexOf(e(b), R) != R) {
      var w = $.lastIndexOf(b);
      w > -1 && ($ = $.slice(0, w));
    }
    return $ + m;
  }
  return mn = h, mn;
}
var Ag = Og();
const Tg = /* @__PURE__ */ Re(Ag), Tf = (e, t = "D", {
  long: r = !1,
  timezone: n = ct.tz.guess()
} = {}) => {
  const a = ct.tz(e, n), i = ct.locale() === "en", o = (s) => r ? s.format("ddd, ll") : s.format(i ? "MMM DD" : "DD MMM");
  switch (t) {
    case "H":
      return a.format("LT");
    case "W":
      return r ? `${o(a)} - ${o(
        a.endOf("week")
      )} (W${a.format("W")})` : o(a);
    case "M":
      return a.format(r ? "MMM YYYY" : "MMM");
    default:
      return o(a);
  }
}, qf = (e, t = {}) => t?.length ? Tg(e, t) : e, qg = "_root_7a8ds_48", jg = {
  root: qg
}, Ig = we(function({
  instrument: t,
  granularity: r,
  timezone: n,
  tooltipProps: a
}) {
  const { active: i, payload: o, label: s } = a, { categories: c, series: u } = t.data, d = c.find((_) => _.label === s), l = d?.metrics ?? [], h = 24, f = Math.max(0, (o?.length ?? 0) - h), g = W(() => u.length === 1 && ["count", "number"].includes(u[0].options?.format ?? "number") && !c.every(({ label: C }) => cr(C)) ? u[0].data.reduce((C, R) => {
    const { value: $ } = pr(R);
    return typeof $ == "number" ? C + $ : C;
  }, 0) : null, [c, u]), p = W(
    () => o?.slice(
      0,
      // When there are more series than the limit, subtract one to make room for the overflow indicator.
      f > 0 ? h - 1 : h
    ).map((_, C) => {
      const R = _.value ?? 0, $ = R && g ? R / g * 100 : null, E = $ ? `${$.toFixed(2)}%` : void 0;
      return {
        type: "metric",
        title: _.name ?? "",
        color: _.color,
        data: R,
        format: u[C].options?.format ?? "number",
        description: E
      };
    }),
    [o, u, h, f, g]
  ), m = U(
    (_) => _?.map((C) => /* @__PURE__ */ y.jsx(
      wf,
      {
        instrument: C,
        theme: "dark"
      },
      C.title
    )),
    []
  ), b = W(
    () => d?.label ? cr(d.label) ? Tf(d.label, r, {
      timezone: n,
      long: !0
    }) : qf(d.label) : null,
    [d?.label, r, n]
  );
  return !i || !o ? null : /* @__PURE__ */ y.jsxs("div", { className: jg.root, children: [
    b && /* @__PURE__ */ y.jsxs(X, { flexDirection: "column", gap: "100", children: [
      /* @__PURE__ */ y.jsx(K.Heading, { variant: "heading-2", color: "inherit", children: b }),
      d?.description && /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "4", color: "inherit", children: d.description })
    ] }),
    l.length > 0 && /* @__PURE__ */ y.jsx(to, { bounded: !0, children: m(l) }),
    /* @__PURE__ */ y.jsxs(to, { bounded: !0, children: [
      m(p),
      f > 0 && /* @__PURE__ */ y.jsx(X, { flex: "1", alignItems: "center", children: /* @__PURE__ */ y.jsxs(K.Heading, { variant: "heading-2", color: "inherit", children: [
        "+ ",
        f + 1,
        " more"
      ] }) })
    ] })
  ] });
});
var bn, Xs;
function Mg() {
  if (Xs) return bn;
  Xs = 1;
  var e = $f(), t = vr(), r = Of(), n = gr();
  function a(i) {
    return function(o) {
      o = n(o);
      var s = t(o) ? r(o) : void 0, c = s ? s[0] : o.charAt(0), u = s ? e(s, 1).join("") : o.slice(1);
      return c[i]() + u;
    };
  }
  return bn = a, bn;
}
var yn, Js;
function Dg() {
  if (Js) return yn;
  Js = 1;
  var e = Mg(), t = e("toUpperCase");
  return yn = t, yn;
}
var _n, Zs;
function Fg() {
  if (Zs) return _n;
  Zs = 1;
  var e = gr(), t = Dg();
  function r(n) {
    return t(e(n).toLowerCase());
  }
  return _n = r, _n;
}
var Ng = Fg();
const kg = /* @__PURE__ */ Re(Ng), Lg = we(
  function({
    visualization: t,
    visualizations: r,
    onChangeVisualization: n
  }) {
    return r.length <= 1 ? null : /* @__PURE__ */ y.jsx(Ol, { variant: "secondary", children: r.map((a) => /* @__PURE__ */ y.jsx(
      ao,
      {
        icon: Ue.visualizationIcons[a],
        onClick: () => {
          n(a);
        },
        active: t === a,
        title: `${kg(a)} chart`
      },
      a
    )) });
  }
), Bg = ({
  instrument: e,
  granularity: t,
  timezone: r,
  syncOptions: n
}) => {
  const { data: a, layout: i } = e, o = i === "horizontal", s = i === "vertical", c = 192, u = W(() => {
    if (s) return 0;
    const g = a.categories.length % 2 === 0;
    switch (t) {
      // There are always an even number of categories, so we preserve the first tick in order to
      // ensure that hours are shown in even intervals e.g. 08:00, 10:00, 12:00 ... 22:00.
      case "H":
        return "preserveStart";
      // When the number of days is even, we preserve the last tick in order to ensure that
      // days are shown in equal intervals e.g. Apr 2, Apr 4, Apr 6 ... Apr 30. When uneven, we
      // preserve the first tick, resulting in equal intervals e.g. Mar 1, Mar 4, Mar 7 ... Mar 31.
      case "D":
      case "W":
        return g ? "preserveEnd" : "preserveStart";
      default:
        return "preserveStartEnd";
    }
  }, [a.categories.length, t, s]), d = {
    dataKey: "name",
    width: s ? c : 0,
    tickLine: {
      stroke: "var(--dixa-color-neutral-200)"
    },
    axisLine: {
      stroke: "var(--dixa-color-neutral-200)"
    },
    tickSize: 6,
    tickMargin: 8,
    interval: u,
    tick: Ue.tickProps,
    tickFormatter: (g) => cr(g) ? Tf(g, t, { timezone: r }) : qf(g, { length: c / 10 })
  }, l = {
    domain: [0, "auto"],
    allowDecimals: !1,
    tickLine: !1,
    axisLine: !1,
    tick: Ue.tickProps,
    ticks: n?.ticks,
    tickCount: Ue.tickCount,
    tickFormatter: (g) => Tt(g, a.series[0].options?.format ?? "number")
  }, h = o ? { type: "category", ...d } : { type: "number", ...l }, f = o ? { type: "number", ...l } : { type: "category", ...d };
  return { xAxisProps: h, yAxisProps: f };
};
var xn, Qs;
function Vg() {
  if (Qs) return xn;
  Qs = 1;
  var e = Oe(), t = function() {
    return e.Date.now();
  };
  return xn = t, xn;
}
var wn, ec;
function Hg() {
  if (ec) return wn;
  ec = 1;
  var e = Xe(), t = Vg(), r = Af(), n = "Expected a function", a = Math.max, i = Math.min;
  function o(s, c, u) {
    var d, l, h, f, g, p, m = 0, b = !1, _ = !1, C = !0;
    if (typeof s != "function")
      throw new TypeError(n);
    c = r(c) || 0, e(u) && (b = !!u.leading, _ = "maxWait" in u, h = _ ? a(r(u.maxWait) || 0, c) : h, C = "trailing" in u ? !!u.trailing : C);
    function R(T) {
      var M = d, F = l;
      return d = l = void 0, m = T, f = s.apply(F, M), f;
    }
    function $(T) {
      return m = T, g = setTimeout(x, c), b ? R(T) : f;
    }
    function E(T) {
      var M = T - p, F = T - m, q = c - M;
      return _ ? i(q, h - F) : q;
    }
    function A(T) {
      var M = T - p, F = T - m;
      return p === void 0 || M >= c || M < 0 || _ && F >= h;
    }
    function x() {
      var T = t();
      if (A(T))
        return w(T);
      g = setTimeout(x, E(T));
    }
    function w(T) {
      return g = void 0, C && d ? R(T) : (d = l = void 0, f);
    }
    function P() {
      g !== void 0 && clearTimeout(g), m = 0, d = p = l = g = void 0;
    }
    function S() {
      return g === void 0 ? f : w(t());
    }
    function I() {
      var T = t(), M = A(T);
      if (d = arguments, l = this, p = T, M) {
        if (g === void 0)
          return $(p);
        if (_)
          return clearTimeout(g), g = setTimeout(x, c), R(p);
      }
      return g === void 0 && (g = setTimeout(x, c)), f;
    }
    return I.cancel = P, I.flush = S, I;
  }
  return wn = o, wn;
}
var zg = Hg();
const Ug = /* @__PURE__ */ Re(zg), Wg = "_legendItem_1mjjb_48", Gg = "_legendItemInactive_1mjjb_55", Kg = "_legendIcon_1mjjb_59", Yg = "_legendIconBar_1mjjb_66", Xg = "_legendIconLine_1mjjb_69", mt = {
  legendItem: Wg,
  legendItemInactive: Gg,
  legendIcon: Kg,
  legendIconBar: Yg,
  legendIconLine: Xg
}, Jg = we(function({
  instrument: t,
  legend: r,
  visualization: n,
  onToggleLegendItem: a,
  onMouseEnterLegendItem: i,
  onMouseLeaveLegendItem: o,
  hoveredLegend: s
}) {
  const { series: c, options: u } = t.data, { layout: d } = u?.legend ?? {
    layout: "horizontal"
  }, l = d === "horizontal";
  return /* @__PURE__ */ y.jsx(
    X,
    {
      padding: l ? "0" : "0 0 0 400",
      flexDirection: l ? "row" : "column",
      gap: l ? "400" : "200",
      justifyContent: "center",
      children: c.map(({ label: h, options: f }, g) => {
        const p = ot(
          g,
          void 0,
          f?.color
        ), m = qe(mt.legendItem, {
          [mt.legendItemInactive]: s && s !== h
        }), b = qe(mt.legendIcon, {
          [mt.legendIconBar]: n !== "line",
          [mt.legendIconLine]: n === "line"
        });
        return /* @__PURE__ */ y.jsxs(
          X,
          {
            gap: "200",
            flexDirection: "row",
            alignItems: "center",
            className: m,
            onClick: () => a(h),
            onMouseEnter: () => i?.(h),
            onMouseLeave: () => o?.(h),
            children: [
              /* @__PURE__ */ y.jsx(
                "span",
                {
                  className: b,
                  style: {
                    borderColor: p,
                    backgroundColor: r.includes(h) ? p : "transparent"
                  }
                }
              ),
              /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "4", subdued: !0, children: h })
            ]
          },
          h
        );
      })
    }
  );
}), Zg = ({
  instrument: e,
  visualization: t
}) => {
  const {
    data: { series: r, options: n }
  } = e, a = n?.legend?.layout === "horizontal", [i, o] = yd(
    r.filter(({ options: m }) => m?.visible ?? !0).map(({ label: m }) => m)
  ), [s, c] = ee(null);
  Ot(() => {
    u();
  }, [r.length]);
  const u = U(() => {
    o.set(r.map(({ label: m }) => m));
  }, [r, o]), d = U(
    (m) => {
      i.includes(m) && c(m);
    },
    [i]
  ), l = W(
    () => Ug(d, 300),
    [d]
  ), h = U(() => {
    l.cancel(), c(null);
  }, [l]), f = U(
    (m) => {
      i.length === r.length ? o.filter((b) => b === m) : i.length === 1 && i.includes(m) ? u() : i.includes(m) ? o.removeAt(i.indexOf(m)) : o.push(m);
    },
    [r.length, u, i, o]
  ), g = W(
    () => r.length < 10 ? {
      onMouseEnterLegendItem: l,
      onMouseLeaveLegendItem: h,
      hoveredLegend: s
    } : {},
    [
      l,
      h,
      s,
      r.length
    ]
  ), p = W(
    () => ({
      layout: n?.legend?.layout,
      align: a ? "center" : "right",
      verticalAlign: a ? "bottom" : "middle",
      wrapperStyle: {
        overflow: "auto",
        ...a ? {
          bottom: 0
        } : {
          right: 0,
          width: 208,
          maxHeight: "100%"
        }
      },
      // Using the render function form instead of directly passing an element prevents the
      // `ChartInstrumentLegend` component from re-rendering unnecessarily due to Recharts props
      // changing, because Recharts automatically passes props to the `content` element.
      content: () => /* @__PURE__ */ y.jsx(
        Jg,
        {
          visualization: t,
          instrument: e,
          legend: i,
          onToggleLegendItem: f,
          ...g
        }
      )
    }),
    [
      f,
      e,
      a,
      i,
      g,
      n?.legend?.layout,
      t
    ]
  );
  return {
    legend: i,
    legendProps: p,
    hoveredLegend: s
  };
};
var Cn, tc;
function Qg() {
  if (tc) return Cn;
  tc = 1;
  function e(t) {
    var r = t == null ? 0 : t.length;
    return r ? t[r - 1] : void 0;
  }
  return Cn = e, Cn;
}
var em = Qg();
const tm = /* @__PURE__ */ Re(em);
var Rn, rc;
function bo() {
  if (rc) return Rn;
  rc = 1;
  var e = Se(), t = jt(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function a(i, o) {
    if (e(i))
      return !1;
    var s = typeof i;
    return s == "number" || s == "symbol" || s == "boolean" || i == null || t(i) ? !0 : n.test(i) || !r.test(i) || o != null && i in Object(o);
  }
  return Rn = a, Rn;
}
var Sn, nc;
function jf() {
  if (nc) return Sn;
  nc = 1;
  var e = Ke(), t = Xe(), r = "[object AsyncFunction]", n = "[object Function]", a = "[object GeneratorFunction]", i = "[object Proxy]";
  function o(s) {
    if (!t(s))
      return !1;
    var c = e(s);
    return c == n || c == a || c == r || c == i;
  }
  return Sn = o, Sn;
}
var $n, ac;
function rm() {
  if (ac) return $n;
  ac = 1;
  var e = Oe(), t = e["__core-js_shared__"];
  return $n = t, $n;
}
var Pn, ic;
function nm() {
  if (ic) return Pn;
  ic = 1;
  var e = rm(), t = (function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  })();
  function r(n) {
    return !!t && t in n;
  }
  return Pn = r, Pn;
}
var En, oc;
function If() {
  if (oc) return En;
  oc = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return En = r, En;
}
var On, sc;
function am() {
  if (sc) return On;
  sc = 1;
  var e = jf(), t = nm(), r = Xe(), n = If(), a = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, o = Function.prototype, s = Object.prototype, c = o.toString, u = s.hasOwnProperty, d = RegExp(
    "^" + c.call(u).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function l(h) {
    if (!r(h) || t(h))
      return !1;
    var f = e(h) ? d : i;
    return f.test(n(h));
  }
  return On = l, On;
}
var An, cc;
function im() {
  if (cc) return An;
  cc = 1;
  function e(t, r) {
    return t?.[r];
  }
  return An = e, An;
}
var Tn, uc;
function Je() {
  if (uc) return Tn;
  uc = 1;
  var e = am(), t = im();
  function r(n, a) {
    var i = t(n, a);
    return e(i) ? i : void 0;
  }
  return Tn = r, Tn;
}
var qn, lc;
function mr() {
  if (lc) return qn;
  lc = 1;
  var e = Je(), t = e(Object, "create");
  return qn = t, qn;
}
var jn, fc;
function om() {
  if (fc) return jn;
  fc = 1;
  var e = mr();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return jn = t, jn;
}
var In, dc;
function sm() {
  if (dc) return In;
  dc = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return In = e, In;
}
var Mn, hc;
function cm() {
  if (hc) return Mn;
  hc = 1;
  var e = mr(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function a(i) {
    var o = this.__data__;
    if (e) {
      var s = o[i];
      return s === t ? void 0 : s;
    }
    return n.call(o, i) ? o[i] : void 0;
  }
  return Mn = a, Mn;
}
var Dn, pc;
function um() {
  if (pc) return Dn;
  pc = 1;
  var e = mr(), t = Object.prototype, r = t.hasOwnProperty;
  function n(a) {
    var i = this.__data__;
    return e ? i[a] !== void 0 : r.call(i, a);
  }
  return Dn = n, Dn;
}
var Fn, vc;
function lm() {
  if (vc) return Fn;
  vc = 1;
  var e = mr(), t = "__lodash_hash_undefined__";
  function r(n, a) {
    var i = this.__data__;
    return this.size += this.has(n) ? 0 : 1, i[n] = e && a === void 0 ? t : a, this;
  }
  return Fn = r, Fn;
}
var Nn, gc;
function fm() {
  if (gc) return Nn;
  gc = 1;
  var e = om(), t = sm(), r = cm(), n = um(), a = lm();
  function i(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var u = o[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, Nn = i, Nn;
}
var kn, mc;
function dm() {
  if (mc) return kn;
  mc = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return kn = e, kn;
}
var Ln, bc;
function yo() {
  if (bc) return Ln;
  bc = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return Ln = e, Ln;
}
var Bn, yc;
function br() {
  if (yc) return Bn;
  yc = 1;
  var e = yo();
  function t(r, n) {
    for (var a = r.length; a--; )
      if (e(r[a][0], n))
        return a;
    return -1;
  }
  return Bn = t, Bn;
}
var Vn, _c;
function hm() {
  if (_c) return Vn;
  _c = 1;
  var e = br(), t = Array.prototype, r = t.splice;
  function n(a) {
    var i = this.__data__, o = e(i, a);
    if (o < 0)
      return !1;
    var s = i.length - 1;
    return o == s ? i.pop() : r.call(i, o, 1), --this.size, !0;
  }
  return Vn = n, Vn;
}
var Hn, xc;
function pm() {
  if (xc) return Hn;
  xc = 1;
  var e = br();
  function t(r) {
    var n = this.__data__, a = e(n, r);
    return a < 0 ? void 0 : n[a][1];
  }
  return Hn = t, Hn;
}
var zn, wc;
function vm() {
  if (wc) return zn;
  wc = 1;
  var e = br();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return zn = t, zn;
}
var Un, Cc;
function gm() {
  if (Cc) return Un;
  Cc = 1;
  var e = br();
  function t(r, n) {
    var a = this.__data__, i = e(a, r);
    return i < 0 ? (++this.size, a.push([r, n])) : a[i][1] = n, this;
  }
  return Un = t, Un;
}
var Wn, Rc;
function yr() {
  if (Rc) return Wn;
  Rc = 1;
  var e = dm(), t = hm(), r = pm(), n = vm(), a = gm();
  function i(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var u = o[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, Wn = i, Wn;
}
var Gn, Sc;
function _o() {
  if (Sc) return Gn;
  Sc = 1;
  var e = Je(), t = Oe(), r = e(t, "Map");
  return Gn = r, Gn;
}
var Kn, $c;
function mm() {
  if ($c) return Kn;
  $c = 1;
  var e = fm(), t = yr(), r = _o();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return Kn = n, Kn;
}
var Yn, Pc;
function bm() {
  if (Pc) return Yn;
  Pc = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return Yn = e, Yn;
}
var Xn, Ec;
function _r() {
  if (Ec) return Xn;
  Ec = 1;
  var e = bm();
  function t(r, n) {
    var a = r.__data__;
    return e(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  return Xn = t, Xn;
}
var Jn, Oc;
function ym() {
  if (Oc) return Jn;
  Oc = 1;
  var e = _r();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return Jn = t, Jn;
}
var Zn, Ac;
function _m() {
  if (Ac) return Zn;
  Ac = 1;
  var e = _r();
  function t(r) {
    return e(this, r).get(r);
  }
  return Zn = t, Zn;
}
var Qn, Tc;
function xm() {
  if (Tc) return Qn;
  Tc = 1;
  var e = _r();
  function t(r) {
    return e(this, r).has(r);
  }
  return Qn = t, Qn;
}
var ea, qc;
function wm() {
  if (qc) return ea;
  qc = 1;
  var e = _r();
  function t(r, n) {
    var a = e(this, r), i = a.size;
    return a.set(r, n), this.size += a.size == i ? 0 : 1, this;
  }
  return ea = t, ea;
}
var ta, jc;
function xo() {
  if (jc) return ta;
  jc = 1;
  var e = mm(), t = ym(), r = _m(), n = xm(), a = wm();
  function i(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var u = o[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, ta = i, ta;
}
var ra, Ic;
function Cm() {
  if (Ic) return ra;
  Ic = 1;
  var e = xo(), t = "Expected a function";
  function r(n, a) {
    if (typeof n != "function" || a != null && typeof a != "function")
      throw new TypeError(t);
    var i = function() {
      var o = arguments, s = a ? a.apply(this, o) : o[0], c = i.cache;
      if (c.has(s))
        return c.get(s);
      var u = n.apply(this, o);
      return i.cache = c.set(s, u) || c, u;
    };
    return i.cache = new (r.Cache || e)(), i;
  }
  return r.Cache = e, ra = r, ra;
}
var na, Mc;
function Rm() {
  if (Mc) return na;
  Mc = 1;
  var e = Cm(), t = 500;
  function r(n) {
    var a = e(n, function(o) {
      return i.size === t && i.clear(), o;
    }), i = a.cache;
    return a;
  }
  return na = r, na;
}
var aa, Dc;
function Sm() {
  if (Dc) return aa;
  Dc = 1;
  var e = Rm(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, n = e(function(a) {
    var i = [];
    return a.charCodeAt(0) === 46 && i.push(""), a.replace(t, function(o, s, c, u) {
      i.push(c ? u.replace(r, "$1") : s || o);
    }), i;
  });
  return aa = n, aa;
}
var ia, Fc;
function xr() {
  if (Fc) return ia;
  Fc = 1;
  var e = Se(), t = bo(), r = Sm(), n = gr();
  function a(i, o) {
    return e(i) ? i : t(i, o) ? [i] : r(n(i));
  }
  return ia = a, ia;
}
var oa, Nc;
function It() {
  if (Nc) return oa;
  Nc = 1;
  var e = jt();
  function t(r) {
    if (typeof r == "string" || e(r))
      return r;
    var n = r + "";
    return n == "0" && 1 / r == -1 / 0 ? "-0" : n;
  }
  return oa = t, oa;
}
var sa, kc;
function wr() {
  if (kc) return sa;
  kc = 1;
  var e = xr(), t = It();
  function r(n, a) {
    a = e(a, n);
    for (var i = 0, o = a.length; n != null && i < o; )
      n = n[t(a[i++])];
    return i && i == o ? n : void 0;
  }
  return sa = r, sa;
}
var ca, Lc;
function Mf() {
  if (Lc) return ca;
  Lc = 1;
  var e = Je(), t = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return ca = t, ca;
}
var ua, Bc;
function $m() {
  if (Bc) return ua;
  Bc = 1;
  var e = Mf();
  function t(r, n, a) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[n] = a;
  }
  return ua = t, ua;
}
var la, Vc;
function Pm() {
  if (Vc) return la;
  Vc = 1;
  var e = $m(), t = yo(), r = Object.prototype, n = r.hasOwnProperty;
  function a(i, o, s) {
    var c = i[o];
    (!(n.call(i, o) && t(c, s)) || s === void 0 && !(o in i)) && e(i, o, s);
  }
  return la = a, la;
}
var fa, Hc;
function wo() {
  if (Hc) return fa;
  Hc = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, a) {
    var i = typeof n;
    return a = a ?? e, !!a && (i == "number" || i != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < a;
  }
  return fa = r, fa;
}
var da, zc;
function Em() {
  if (zc) return da;
  zc = 1;
  var e = Pm(), t = xr(), r = wo(), n = Xe(), a = It();
  function i(o, s, c, u) {
    if (!n(o))
      return o;
    s = t(s, o);
    for (var d = -1, l = s.length, h = l - 1, f = o; f != null && ++d < l; ) {
      var g = a(s[d]), p = c;
      if (g === "__proto__" || g === "constructor" || g === "prototype")
        return o;
      if (d != h) {
        var m = f[g];
        p = u ? u(m, g, f) : void 0, p === void 0 && (p = n(m) ? m : r(s[d + 1]) ? [] : {});
      }
      e(f, g, p), f = f[g];
    }
    return o;
  }
  return da = i, da;
}
var ha, Uc;
function Om() {
  if (Uc) return ha;
  Uc = 1;
  var e = wr(), t = Em(), r = xr();
  function n(a, i, o) {
    for (var s = -1, c = i.length, u = {}; ++s < c; ) {
      var d = i[s], l = e(a, d);
      o(l, d) && t(u, r(d, a), l);
    }
    return u;
  }
  return ha = n, ha;
}
var pa, Wc;
function Am() {
  if (Wc) return pa;
  Wc = 1;
  function e(t, r) {
    return t != null && r in Object(t);
  }
  return pa = e, pa;
}
var va, Gc;
function Tm() {
  if (Gc) return va;
  Gc = 1;
  var e = Ke(), t = Ye(), r = "[object Arguments]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return va = n, va;
}
var ga, Kc;
function Co() {
  if (Kc) return ga;
  Kc = 1;
  var e = Tm(), t = Ye(), r = Object.prototype, n = r.hasOwnProperty, a = r.propertyIsEnumerable, i = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(o) {
    return t(o) && n.call(o, "callee") && !a.call(o, "callee");
  };
  return ga = i, ga;
}
var ma, Yc;
function Ro() {
  if (Yc) return ma;
  Yc = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return ma = t, ma;
}
var ba, Xc;
function qm() {
  if (Xc) return ba;
  Xc = 1;
  var e = xr(), t = Co(), r = Se(), n = wo(), a = Ro(), i = It();
  function o(s, c, u) {
    c = e(c, s);
    for (var d = -1, l = c.length, h = !1; ++d < l; ) {
      var f = i(c[d]);
      if (!(h = s != null && u(s, f)))
        break;
      s = s[f];
    }
    return h || ++d != l ? h : (l = s == null ? 0 : s.length, !!l && a(l) && n(f, l) && (r(s) || t(s)));
  }
  return ba = o, ba;
}
var ya, Jc;
function Df() {
  if (Jc) return ya;
  Jc = 1;
  var e = Am(), t = qm();
  function r(n, a) {
    return n != null && t(n, a, e);
  }
  return ya = r, ya;
}
var _a, Zc;
function jm() {
  if (Zc) return _a;
  Zc = 1;
  var e = Om(), t = Df();
  function r(n, a) {
    return e(n, a, function(i, o) {
      return t(n, o);
    });
  }
  return _a = r, _a;
}
var xa, Qc;
function Ff() {
  if (Qc) return xa;
  Qc = 1;
  function e(t, r) {
    for (var n = -1, a = r.length, i = t.length; ++n < a; )
      t[i + n] = r[n];
    return t;
  }
  return xa = e, xa;
}
var wa, eu;
function Im() {
  if (eu) return wa;
  eu = 1;
  var e = qt(), t = Co(), r = Se(), n = e ? e.isConcatSpreadable : void 0;
  function a(i) {
    return r(i) || t(i) || !!(n && i && i[n]);
  }
  return wa = a, wa;
}
var Ca, tu;
function Mm() {
  if (tu) return Ca;
  tu = 1;
  var e = Ff(), t = Im();
  function r(n, a, i, o, s) {
    var c = -1, u = n.length;
    for (i || (i = t), s || (s = []); ++c < u; ) {
      var d = n[c];
      a > 0 && i(d) ? a > 1 ? r(d, a - 1, i, o, s) : e(s, d) : o || (s[s.length] = d);
    }
    return s;
  }
  return Ca = r, Ca;
}
var Ra, ru;
function Dm() {
  if (ru) return Ra;
  ru = 1;
  var e = Mm();
  function t(r) {
    var n = r == null ? 0 : r.length;
    return n ? e(r, 1) : [];
  }
  return Ra = t, Ra;
}
var Sa, nu;
function Fm() {
  if (nu) return Sa;
  nu = 1;
  function e(t, r, n) {
    switch (n.length) {
      case 0:
        return t.call(r);
      case 1:
        return t.call(r, n[0]);
      case 2:
        return t.call(r, n[0], n[1]);
      case 3:
        return t.call(r, n[0], n[1], n[2]);
    }
    return t.apply(r, n);
  }
  return Sa = e, Sa;
}
var $a, au;
function Nm() {
  if (au) return $a;
  au = 1;
  var e = Fm(), t = Math.max;
  function r(n, a, i) {
    return a = t(a === void 0 ? n.length - 1 : a, 0), function() {
      for (var o = arguments, s = -1, c = t(o.length - a, 0), u = Array(c); ++s < c; )
        u[s] = o[a + s];
      s = -1;
      for (var d = Array(a + 1); ++s < a; )
        d[s] = o[s];
      return d[a] = i(u), e(n, this, d);
    };
  }
  return $a = r, $a;
}
var Pa, iu;
function km() {
  if (iu) return Pa;
  iu = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return Pa = e, Pa;
}
var Ea, ou;
function Cr() {
  if (ou) return Ea;
  ou = 1;
  function e(t) {
    return t;
  }
  return Ea = e, Ea;
}
var Oa, su;
function Lm() {
  if (su) return Oa;
  su = 1;
  var e = km(), t = Mf(), r = Cr(), n = t ? function(a, i) {
    return t(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(i),
      writable: !0
    });
  } : r;
  return Oa = n, Oa;
}
var Aa, cu;
function Bm() {
  if (cu) return Aa;
  cu = 1;
  var e = 800, t = 16, r = Date.now;
  function n(a) {
    var i = 0, o = 0;
    return function() {
      var s = r(), c = t - (s - o);
      if (o = s, c > 0) {
        if (++i >= e)
          return arguments[0];
      } else
        i = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Aa = n, Aa;
}
var Ta, uu;
function Vm() {
  if (uu) return Ta;
  uu = 1;
  var e = Lm(), t = Bm(), r = t(e);
  return Ta = r, Ta;
}
var qa, lu;
function Hm() {
  if (lu) return qa;
  lu = 1;
  var e = Dm(), t = Nm(), r = Vm();
  function n(a) {
    return r(t(a, void 0, e), a + "");
  }
  return qa = n, qa;
}
var ja, fu;
function zm() {
  if (fu) return ja;
  fu = 1;
  var e = jm(), t = Hm(), r = t(function(n, a) {
    return n == null ? {} : e(n, a);
  });
  return ja = r, ja;
}
var Um = zm();
const Wm = /* @__PURE__ */ Re(Um);
var Ia, du;
function Gm() {
  if (du) return Ia;
  du = 1;
  function e(t, r) {
    for (var n, a = -1, i = t.length; ++a < i; ) {
      var o = r(t[a]);
      o !== void 0 && (n = n === void 0 ? o : n + o);
    }
    return n;
  }
  return Ia = e, Ia;
}
var Ma, hu;
function Km() {
  if (hu) return Ma;
  hu = 1;
  var e = Gm(), t = Cr();
  function r(n) {
    return n && n.length ? e(n, t) : 0;
  }
  return Ma = r, Ma;
}
var Ym = Km();
const Xm = /* @__PURE__ */ Re(Ym), Jm = (e) => {
  const { outerRadius: t } = e;
  return /* @__PURE__ */ y.jsxs("g", { children: [
    /* @__PURE__ */ y.jsx(Lo, { ...e }),
    /* @__PURE__ */ y.jsx(
      Lo,
      {
        ...e,
        innerRadius: t,
        outerRadius: t + 10,
        fillOpacity: 0.4
      }
    )
  ] });
}, Zm = (e) => {
  const { name: t, value: r, cx: n, cy: a, midAngle: i, outerRadius: o, fill: s, percent: c } = e, u = !!r, d = typeof c == "number" && c >= 0.01;
  if (!u || !d || !(typeof n == "number" && typeof a == "number" && typeof i == "number" && typeof o == "number"))
    return null;
  const h = Math.PI / 180, f = o + 24, g = n + o * Math.cos(-i * h), p = a + o * Math.sin(-i * h), m = n + f * Math.cos(-i * h), b = a + f * Math.sin(-i * h), _ = m + (m > n ? 12 : -12), C = b;
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(
      "polyline",
      {
        points: `${g},${p} ${m},${b} ${_},${C}`,
        stroke: s,
        fill: "none",
        strokeWidth: 1
      }
    ),
    /* @__PURE__ */ y.jsx(
      "text",
      {
        ...Ue.tickProps,
        fill: Nd.color.secondary,
        x: _ + (_ > n ? 8 : -8),
        y: C,
        textAnchor: _ > n ? "start" : "end",
        dominantBaseline: "middle",
        children: t
      }
    )
  ] });
}, Qm = ({
  instrument: e,
  legend: t,
  hoveredLegend: r,
  hoveredCategory: n
}) => {
  const { data: a, layout: i } = e, o = U(() => {
    const { categories: l, series: h } = a, f = h.filter(({ label: b }) => t.includes(b)), g = i === "vertical", p = g ? [0, 2, 2, 0] : [2, 2, 0, 0];
    return h.map(
      ({ label: b, options: _, data: C }, R) => {
        const $ = ot(
          R,
          a.options?.theme,
          _?.color
        ), E = _?.stack, A = E ? tm(f)?.label === b : !0, x = f.length <= 10 && (E ? A : !0), w = /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
          x && /* @__PURE__ */ y.jsx(
            xd,
            {
              position: g ? "right" : "top",
              valueAccessor: ({ payload: S }) => (
                // In the case of stacked series, the total sum of all
                // visible series values for the current category is
                // displayed. For individual series, their own value is
                // displayed by using their `label` from the Recharts data.
                E ? Xm(Object.values(Wm(S, t))) : Number(S[b] ?? 0)
              ),
              formatter: (S) => S ? Tt(S, _?.format ?? "number") : "",
              ...Ue.tickProps,
              offset: 8,
              fontSize: "var(--dixa-typography-size-100)"
            }
          ),
          C.map((S, I) => {
            const T = h.length > 1 ? $ : ot(
              I,
              a.options?.theme,
              // If there is only one series, the category color is used if specified, otherwise
              // the colors are determined by the category index, resulting in different colors
              // being used for each category and repeating as necessary.
              l[I]?.options?.color ?? _?.color
            ), M = n === null || n === I, F = r === null || r === b;
            return /* @__PURE__ */ y.jsx(
              Bo,
              {
                fill: T,
                fillOpacity: M && F ? 1 : 0.4
              },
              `${b}-${I}`
            );
          })
        ] });
        return {
          key: b,
          dataKey: b,
          stackId: E,
          fill: $,
          radius: A ? p : 0,
          maxBarSize: 80,
          hide: !t.includes(b),
          children: w
        };
      }
    );
  }, [a, n, r, i, t]), s = U(() => {
    const { series: l } = a;
    return l.map(({ label: f, options: g }, p) => {
      const m = ot(
        p,
        a.options?.theme,
        g?.color
      );
      return {
        key: f,
        type: "monotone",
        dot: !1,
        activeDot: { r: 5 },
        dataKey: f,
        stroke: m,
        strokeWidth: 2,
        strokeOpacity: r === null || r === f ? 1 : 0.4,
        connectNulls: !0,
        hide: !t.includes(f)
      };
    });
  }, [a, r, t]), c = U(() => {
    const { series: l } = a;
    return l.map(({ label: f, options: g }, p) => {
      const m = ot(
        p,
        a.options?.theme,
        g?.color
      ), b = r === null || r === f;
      return {
        key: f,
        type: "monotone",
        dot: !1,
        activeDot: { r: 5 },
        dataKey: f,
        stackId: g?.stack,
        stroke: m,
        strokeWidth: 2,
        fill: m,
        fillOpacity: b ? 0.9 : 0.2,
        strokeOpacity: b ? 1 : 0,
        connectNulls: !0,
        hide: !t.includes(f)
      };
    });
  }, [a, r, t]), u = U(
    (l) => {
      const { categories: h, series: f } = a, g = h.map(
        ({ label: p, options: m }, b) => {
          const _ = ot(
            b,
            a.options?.theme,
            m?.color
          );
          return /* @__PURE__ */ y.jsx(Bo, { fill: _, style: { outline: "none" } }, p);
        }
      );
      return {
        dataKey: f[0]?.label,
        cx: "50%",
        cy: "50%",
        label: Zm,
        labelLine: !1,
        activeShape: Jm,
        inactiveShape: {
          fillOpacity: 0.4
        },
        stroke: Il.neutral["000"],
        strokeWidth: 1.5,
        innerRadius: l === "donut" ? "50%" : 0,
        outerRadius: "80%",
        startAngle: 90,
        endAngle: -270,
        children: g
      };
    },
    [a]
  );
  return { getSeriesProps: U(
    (l) => {
      switch (l) {
        case "bar":
          return o();
        case "line":
          return s();
        case "area":
          return c();
        case "pie":
        case "donut":
          return u(
            l
          );
        default:
          return [];
      }
      return [];
    },
    [c, o, s, u]
  ) };
}, r0 = we(function({
  instrument: t,
  panel: r,
  timezone: n,
  syncOptions: a,
  onChangeGranularity: i,
  onChangeVisualization: o
}) {
  const [s, c] = ee(
    r.controls?.settings.visualization ?? t.visualization
  ), [u, d] = ee(null), { data: l, layout: h, title: f } = t, g = h === "horizontal", p = h === "vertical", m = W(
    () => pg(l, { omitZero: s === "bar" }),
    [l, s]
  ), b = W(
    () => l.granularities?.find(({ selected: q }) => q)?.value,
    [l.granularities]
  ), _ = W(() => {
    if (!l.options?.visualizations) return [];
    const q = ["bar"], k = l.series.length === 1;
    return l.categories.every(
      ({ label: te }) => cr(te)
    ) ? q.push("line", "area") : k && q.push("pie", "donut"), q;
  }, [l.categories, l.options?.visualizations, l.series.length]), { xAxisProps: C, yAxisProps: R } = Bg({
    instrument: t,
    granularity: b,
    timezone: n,
    syncOptions: a
  }), { legend: $, legendProps: E, hoveredLegend: A } = Zg({
    instrument: t,
    visualization: s
  }), { getSeriesProps: x } = Qm({
    instrument: t,
    legend: $,
    hoveredLegend: A,
    hoveredCategory: u
  });
  Ot(() => {
    c(
      r.controls?.settings.visualization ?? t.visualization
    );
  }, [r.controls?.settings.visualization, t.visualization]);
  const w = U(
    (q) => {
      c(q), o?.(q);
    },
    [o]
  ), P = (q) => {
    if (!q?.isTooltipActive) {
      d(null);
      return;
    }
    const k = q.activeTooltipIndex;
    if (typeof k != "number") return;
    const L = Object.values(m[k] ?? {}).length > 1;
    d(L ? k : null);
  }, S = () => {
    d(null);
  }, I = () => s === "line" ? x(s).map(({ key: k, ...L }) => /* @__PURE__ */ y.jsx(Id, { ...L }, k)) : s === "bar" ? x(s).map(({ key: k, ...L }) => /* @__PURE__ */ y.jsx(Md, { ...L }, k)) : s === "area" ? x(s).map(({ key: k, ...L }) => /* @__PURE__ */ y.jsx(Dd, { ...L }, k)) : s === "pie" || s === "donut" ? /* @__PURE__ */ y.jsx(Fd, { data: m, ...x(s) }) : null, T = () => {
    const q = l.options?.legend?.layout, k = 16, L = {
      layout: h,
      syncId: a?.tooltip ? r.id : void 0,
      data: m,
      margin: {
        top: g ? k : 0,
        right: p || q === "vertical" ? k : 0,
        bottom: q === "horizontal" ? k / 2 : 0,
        left: 0
      }
    }, te = s === "bar" || s === "line" || s === "area", ae = /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
      te && /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
        /* @__PURE__ */ y.jsx(Cd, { ...C }),
        /* @__PURE__ */ y.jsx(Rd, { ...R })
      ] }),
      te && l.options?.cartesian && /* @__PURE__ */ y.jsx(
        Sd,
        {
          vertical: p,
          horizontal: g,
          stroke: "var(--dixa-color-neutral-200)"
        }
      ),
      te && l.references?.map(({ value: ne, label: pe }, oe) => /* @__PURE__ */ y.jsx(
        $d,
        {
          ...g ? { y: ne } : { x: ne },
          stroke: "var(--dixa-color-neutral-500)",
          strokeDasharray: "5 5",
          isFront: !0,
          children: /* @__PURE__ */ y.jsx(
            Pd,
            {
              value: pe,
              offset: 8,
              fontSize: "var(--dixa-typography-size-200)",
              position: g ? "insideBottomLeft" : "insideTopLeft"
            }
          )
        },
        oe
      )),
      l.options?.legend && /* @__PURE__ */ y.jsx(Ed, { ...E }),
      l.options?.tooltip && /* @__PURE__ */ y.jsx(
        Od,
        {
          content: (ne) => /* @__PURE__ */ y.jsx(
            Ig,
            {
              instrument: t,
              granularity: b,
              timezone: n,
              tooltipProps: ne
            }
          ),
          cursor: { fill: "transparent" }
        }
      ),
      I()
    ] });
    switch (s) {
      case "bar":
        return /* @__PURE__ */ y.jsx(
          jd,
          {
            ...L,
            barGap: "1",
            onMouseMove: P,
            onMouseLeave: S,
            children: ae
          }
        );
      case "line":
        return /* @__PURE__ */ y.jsx(qd, { ...L, children: ae });
      case "area":
        return /* @__PURE__ */ y.jsx(Td, { ...L, children: ae });
      case "pie":
      case "donut":
        return /* @__PURE__ */ y.jsx(Ad, { ...L, children: ae });
    }
  };
  if (!l.categories.length || !l.series.length)
    return /* @__PURE__ */ y.jsx(
      X,
      {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        children: /* @__PURE__ */ y.jsx(
          Tl,
          {
            title: "No data available",
            description: "There is no data available for the selected period and filters.",
            icon: Ue.visualizationIcons[s]
          }
        )
      }
    );
  const M = [
    l.granularities && l.granularities.length > 1 ? /* @__PURE__ */ y.jsx(
      rg,
      {
        granularities: l.granularities,
        onChangeGranularity: i
      },
      "granularity"
    ) : null,
    l.options?.visualizations ? /* @__PURE__ */ y.jsx(
      Lg,
      {
        visualization: s,
        visualizations: _,
        onChangeVisualization: w
      },
      "visualization"
    ) : null
  ], F = M.some(Boolean);
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    f && /* @__PURE__ */ y.jsx("div", { children: /* @__PURE__ */ y.jsx(K.Heading, { variant: "heading-4", children: f }) }),
    F && /* @__PURE__ */ y.jsx(X, { alignSelf: "flex-end", gap: "300", children: M.map((q, k) => /* @__PURE__ */ y.jsx(El, { children: q }, k)) }),
    /* @__PURE__ */ y.jsx(
      wd,
      {
        className: tg.container,
        width: "100%",
        height: "100%",
        debounce: 100,
        children: T()
      }
    )
  ] });
});
var Da, pu;
function eb() {
  if (pu) return Da;
  pu = 1;
  var e = yr();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Da = t, Da;
}
var Fa, vu;
function tb() {
  if (vu) return Fa;
  vu = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return Fa = e, Fa;
}
var Na, gu;
function rb() {
  if (gu) return Na;
  gu = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Na = e, Na;
}
var ka, mu;
function nb() {
  if (mu) return ka;
  mu = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return ka = e, ka;
}
var La, bu;
function ab() {
  if (bu) return La;
  bu = 1;
  var e = yr(), t = _o(), r = xo(), n = 200;
  function a(i, o) {
    var s = this.__data__;
    if (s instanceof e) {
      var c = s.__data__;
      if (!t || c.length < n - 1)
        return c.push([i, o]), this.size = ++s.size, this;
      s = this.__data__ = new r(c);
    }
    return s.set(i, o), this.size = s.size, this;
  }
  return La = a, La;
}
var Ba, yu;
function Nf() {
  if (yu) return Ba;
  yu = 1;
  var e = yr(), t = eb(), r = tb(), n = rb(), a = nb(), i = ab();
  function o(s) {
    var c = this.__data__ = new e(s);
    this.size = c.size;
  }
  return o.prototype.clear = t, o.prototype.delete = r, o.prototype.get = n, o.prototype.has = a, o.prototype.set = i, Ba = o, Ba;
}
var Va, _u;
function ib() {
  if (_u) return Va;
  _u = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return Va = t, Va;
}
var Ha, xu;
function ob() {
  if (xu) return Ha;
  xu = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Ha = e, Ha;
}
var za, wu;
function sb() {
  if (wu) return za;
  wu = 1;
  var e = xo(), t = ib(), r = ob();
  function n(a) {
    var i = -1, o = a == null ? 0 : a.length;
    for (this.__data__ = new e(); ++i < o; )
      this.add(a[i]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, za = n, za;
}
var Ua, Cu;
function cb() {
  if (Cu) return Ua;
  Cu = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return Ua = e, Ua;
}
var Wa, Ru;
function ub() {
  if (Ru) return Wa;
  Ru = 1;
  function e(t, r) {
    return t.has(r);
  }
  return Wa = e, Wa;
}
var Ga, Su;
function kf() {
  if (Su) return Ga;
  Su = 1;
  var e = sb(), t = cb(), r = ub(), n = 1, a = 2;
  function i(o, s, c, u, d, l) {
    var h = c & n, f = o.length, g = s.length;
    if (f != g && !(h && g > f))
      return !1;
    var p = l.get(o), m = l.get(s);
    if (p && m)
      return p == s && m == o;
    var b = -1, _ = !0, C = c & a ? new e() : void 0;
    for (l.set(o, s), l.set(s, o); ++b < f; ) {
      var R = o[b], $ = s[b];
      if (u)
        var E = h ? u($, R, b, s, o, l) : u(R, $, b, o, s, l);
      if (E !== void 0) {
        if (E)
          continue;
        _ = !1;
        break;
      }
      if (C) {
        if (!t(s, function(A, x) {
          if (!r(C, x) && (R === A || d(R, A, c, u, l)))
            return C.push(x);
        })) {
          _ = !1;
          break;
        }
      } else if (!(R === $ || d(R, $, c, u, l))) {
        _ = !1;
        break;
      }
    }
    return l.delete(o), l.delete(s), _;
  }
  return Ga = i, Ga;
}
var Ka, $u;
function lb() {
  if ($u) return Ka;
  $u = 1;
  var e = Oe(), t = e.Uint8Array;
  return Ka = t, Ka;
}
var Ya, Pu;
function fb() {
  if (Pu) return Ya;
  Pu = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a, i) {
      n[++r] = [i, a];
    }), n;
  }
  return Ya = e, Ya;
}
var Xa, Eu;
function db() {
  if (Eu) return Xa;
  Eu = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a) {
      n[++r] = a;
    }), n;
  }
  return Xa = e, Xa;
}
var Ja, Ou;
function hb() {
  if (Ou) return Ja;
  Ou = 1;
  var e = qt(), t = lb(), r = yo(), n = kf(), a = fb(), i = db(), o = 1, s = 2, c = "[object Boolean]", u = "[object Date]", d = "[object Error]", l = "[object Map]", h = "[object Number]", f = "[object RegExp]", g = "[object Set]", p = "[object String]", m = "[object Symbol]", b = "[object ArrayBuffer]", _ = "[object DataView]", C = e ? e.prototype : void 0, R = C ? C.valueOf : void 0;
  function $(E, A, x, w, P, S, I) {
    switch (x) {
      case _:
        if (E.byteLength != A.byteLength || E.byteOffset != A.byteOffset)
          return !1;
        E = E.buffer, A = A.buffer;
      case b:
        return !(E.byteLength != A.byteLength || !S(new t(E), new t(A)));
      case c:
      case u:
      case h:
        return r(+E, +A);
      case d:
        return E.name == A.name && E.message == A.message;
      case f:
      case p:
        return E == A + "";
      case l:
        var T = a;
      case g:
        var M = w & o;
        if (T || (T = i), E.size != A.size && !M)
          return !1;
        var F = I.get(E);
        if (F)
          return F == A;
        w |= s, I.set(E, A);
        var q = n(T(E), T(A), w, P, S, I);
        return I.delete(E), q;
      case m:
        if (R)
          return R.call(E) == R.call(A);
    }
    return !1;
  }
  return Ja = $, Ja;
}
var Za, Au;
function pb() {
  if (Au) return Za;
  Au = 1;
  var e = Ff(), t = Se();
  function r(n, a, i) {
    var o = a(n);
    return t(n) ? o : e(o, i(n));
  }
  return Za = r, Za;
}
var Qa, Tu;
function vb() {
  if (Tu) return Qa;
  Tu = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, i = 0, o = []; ++n < a; ) {
      var s = t[n];
      r(s, n, t) && (o[i++] = s);
    }
    return o;
  }
  return Qa = e, Qa;
}
var ei, qu;
function gb() {
  if (qu) return ei;
  qu = 1;
  function e() {
    return [];
  }
  return ei = e, ei;
}
var ti, ju;
function mb() {
  if (ju) return ti;
  ju = 1;
  var e = vb(), t = gb(), r = Object.prototype, n = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, i = a ? function(o) {
    return o == null ? [] : (o = Object(o), e(a(o), function(s) {
      return n.call(o, s);
    }));
  } : t;
  return ti = i, ti;
}
var ri, Iu;
function bb() {
  if (Iu) return ri;
  Iu = 1;
  function e(t, r) {
    for (var n = -1, a = Array(t); ++n < t; )
      a[n] = r(n);
    return a;
  }
  return ri = e, ri;
}
var xt = { exports: {} }, ni, Mu;
function yb() {
  if (Mu) return ni;
  Mu = 1;
  function e() {
    return !1;
  }
  return ni = e, ni;
}
xt.exports;
var Du;
function Lf() {
  return Du || (Du = 1, (function(e, t) {
    var r = Oe(), n = yb(), a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, s = o ? r.Buffer : void 0, c = s ? s.isBuffer : void 0, u = c || n;
    e.exports = u;
  })(xt, xt.exports)), xt.exports;
}
var ai, Fu;
function _b() {
  if (Fu) return ai;
  Fu = 1;
  var e = Ke(), t = Ro(), r = Ye(), n = "[object Arguments]", a = "[object Array]", i = "[object Boolean]", o = "[object Date]", s = "[object Error]", c = "[object Function]", u = "[object Map]", d = "[object Number]", l = "[object Object]", h = "[object RegExp]", f = "[object Set]", g = "[object String]", p = "[object WeakMap]", m = "[object ArrayBuffer]", b = "[object DataView]", _ = "[object Float32Array]", C = "[object Float64Array]", R = "[object Int8Array]", $ = "[object Int16Array]", E = "[object Int32Array]", A = "[object Uint8Array]", x = "[object Uint8ClampedArray]", w = "[object Uint16Array]", P = "[object Uint32Array]", S = {};
  S[_] = S[C] = S[R] = S[$] = S[E] = S[A] = S[x] = S[w] = S[P] = !0, S[n] = S[a] = S[m] = S[i] = S[b] = S[o] = S[s] = S[c] = S[u] = S[d] = S[l] = S[h] = S[f] = S[g] = S[p] = !1;
  function I(T) {
    return r(T) && t(T.length) && !!S[e(T)];
  }
  return ai = I, ai;
}
var ii, Nu;
function Bf() {
  if (Nu) return ii;
  Nu = 1;
  var e = _b(), t = mo(), r = Pf(), n = r && r.isTypedArray, a = n ? t(n) : e;
  return ii = a, ii;
}
var oi, ku;
function xb() {
  if (ku) return oi;
  ku = 1;
  var e = bb(), t = Co(), r = Se(), n = Lf(), a = wo(), i = Bf(), o = Object.prototype, s = o.hasOwnProperty;
  function c(u, d) {
    var l = r(u), h = !l && t(u), f = !l && !h && n(u), g = !l && !h && !f && i(u), p = l || h || f || g, m = p ? e(u.length, String) : [], b = m.length;
    for (var _ in u)
      (d || s.call(u, _)) && !(p && // Safari 9 has enumerable `arguments.length` in strict mode.
      (_ == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      f && (_ == "offset" || _ == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      g && (_ == "buffer" || _ == "byteLength" || _ == "byteOffset") || // Skip index properties.
      a(_, b))) && m.push(_);
    return m;
  }
  return oi = c, oi;
}
var si, Lu;
function wb() {
  if (Lu) return si;
  Lu = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, a = typeof n == "function" && n.prototype || e;
    return r === a;
  }
  return si = t, si;
}
var ci, Bu;
function Cb() {
  if (Bu) return ci;
  Bu = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return ci = e, ci;
}
var ui, Vu;
function Rb() {
  if (Vu) return ui;
  Vu = 1;
  var e = Cb(), t = e(Object.keys, Object);
  return ui = t, ui;
}
var li, Hu;
function Sb() {
  if (Hu) return li;
  Hu = 1;
  var e = wb(), t = Rb(), r = Object.prototype, n = r.hasOwnProperty;
  function a(i) {
    if (!e(i))
      return t(i);
    var o = [];
    for (var s in Object(i))
      n.call(i, s) && s != "constructor" && o.push(s);
    return o;
  }
  return li = a, li;
}
var fi, zu;
function So() {
  if (zu) return fi;
  zu = 1;
  var e = jf(), t = Ro();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return fi = r, fi;
}
var di, Uu;
function $o() {
  if (Uu) return di;
  Uu = 1;
  var e = xb(), t = Sb(), r = So();
  function n(a) {
    return r(a) ? e(a) : t(a);
  }
  return di = n, di;
}
var hi, Wu;
function $b() {
  if (Wu) return hi;
  Wu = 1;
  var e = pb(), t = mb(), r = $o();
  function n(a) {
    return e(a, r, t);
  }
  return hi = n, hi;
}
var pi, Gu;
function Pb() {
  if (Gu) return pi;
  Gu = 1;
  var e = $b(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function a(i, o, s, c, u, d) {
    var l = s & t, h = e(i), f = h.length, g = e(o), p = g.length;
    if (f != p && !l)
      return !1;
    for (var m = f; m--; ) {
      var b = h[m];
      if (!(l ? b in o : n.call(o, b)))
        return !1;
    }
    var _ = d.get(i), C = d.get(o);
    if (_ && C)
      return _ == o && C == i;
    var R = !0;
    d.set(i, o), d.set(o, i);
    for (var $ = l; ++m < f; ) {
      b = h[m];
      var E = i[b], A = o[b];
      if (c)
        var x = l ? c(A, E, b, o, i, d) : c(E, A, b, i, o, d);
      if (!(x === void 0 ? E === A || u(E, A, s, c, d) : x)) {
        R = !1;
        break;
      }
      $ || ($ = b == "constructor");
    }
    if (R && !$) {
      var w = i.constructor, P = o.constructor;
      w != P && "constructor" in i && "constructor" in o && !(typeof w == "function" && w instanceof w && typeof P == "function" && P instanceof P) && (R = !1);
    }
    return d.delete(i), d.delete(o), R;
  }
  return pi = a, pi;
}
var vi, Ku;
function Eb() {
  if (Ku) return vi;
  Ku = 1;
  var e = Je(), t = Oe(), r = e(t, "DataView");
  return vi = r, vi;
}
var gi, Yu;
function Ob() {
  if (Yu) return gi;
  Yu = 1;
  var e = Je(), t = Oe(), r = e(t, "Promise");
  return gi = r, gi;
}
var mi, Xu;
function Ab() {
  if (Xu) return mi;
  Xu = 1;
  var e = Je(), t = Oe(), r = e(t, "Set");
  return mi = r, mi;
}
var bi, Ju;
function Tb() {
  if (Ju) return bi;
  Ju = 1;
  var e = Je(), t = Oe(), r = e(t, "WeakMap");
  return bi = r, bi;
}
var yi, Zu;
function qb() {
  if (Zu) return yi;
  Zu = 1;
  var e = Eb(), t = _o(), r = Ob(), n = Ab(), a = Tb(), i = Ke(), o = If(), s = "[object Map]", c = "[object Object]", u = "[object Promise]", d = "[object Set]", l = "[object WeakMap]", h = "[object DataView]", f = o(e), g = o(t), p = o(r), m = o(n), b = o(a), _ = i;
  return (e && _(new e(new ArrayBuffer(1))) != h || t && _(new t()) != s || r && _(r.resolve()) != u || n && _(new n()) != d || a && _(new a()) != l) && (_ = function(C) {
    var R = i(C), $ = R == c ? C.constructor : void 0, E = $ ? o($) : "";
    if (E)
      switch (E) {
        case f:
          return h;
        case g:
          return s;
        case p:
          return u;
        case m:
          return d;
        case b:
          return l;
      }
    return R;
  }), yi = _, yi;
}
var _i, Qu;
function jb() {
  if (Qu) return _i;
  Qu = 1;
  var e = Nf(), t = kf(), r = hb(), n = Pb(), a = qb(), i = Se(), o = Lf(), s = Bf(), c = 1, u = "[object Arguments]", d = "[object Array]", l = "[object Object]", h = Object.prototype, f = h.hasOwnProperty;
  function g(p, m, b, _, C, R) {
    var $ = i(p), E = i(m), A = $ ? d : a(p), x = E ? d : a(m);
    A = A == u ? l : A, x = x == u ? l : x;
    var w = A == l, P = x == l, S = A == x;
    if (S && o(p)) {
      if (!o(m))
        return !1;
      $ = !0, w = !1;
    }
    if (S && !w)
      return R || (R = new e()), $ || s(p) ? t(p, m, b, _, C, R) : r(p, m, A, b, _, C, R);
    if (!(b & c)) {
      var I = w && f.call(p, "__wrapped__"), T = P && f.call(m, "__wrapped__");
      if (I || T) {
        var M = I ? p.value() : p, F = T ? m.value() : m;
        return R || (R = new e()), C(M, F, b, _, R);
      }
    }
    return S ? (R || (R = new e()), n(p, m, b, _, C, R)) : !1;
  }
  return _i = g, _i;
}
var xi, el;
function Po() {
  if (el) return xi;
  el = 1;
  var e = jb(), t = Ye();
  function r(n, a, i, o, s) {
    return n === a ? !0 : n == null || a == null || !t(n) && !t(a) ? n !== n && a !== a : e(n, a, i, o, r, s);
  }
  return xi = r, xi;
}
var wi, tl;
function Ib() {
  if (tl) return wi;
  tl = 1;
  var e = Po();
  function t(r, n) {
    return e(r, n);
  }
  return wi = t, wi;
}
var Mb = Ib();
const Db = /* @__PURE__ */ Re(Mb);
var Ci, rl;
function Fb() {
  if (rl) return Ci;
  rl = 1;
  var e = Ke(), t = Ye(), r = "[object Number]";
  function n(a) {
    return typeof a == "number" || t(a) && e(a) == r;
  }
  return Ci = n, Ci;
}
var Nb = Fb();
const Vf = /* @__PURE__ */ Re(Nb), kb = "_trigger_1mrk9_1", Lb = {
  trigger: kb
}, Bb = we(function({
  title: t,
  metrics: r,
  children: n
}) {
  const a = /* @__PURE__ */ y.jsxs(X, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "1", color: "inherit", children: t }),
    r.length > 0 && /* @__PURE__ */ y.jsx(to, { bounded: !0, children: r.map((i, o) => /* @__PURE__ */ y.jsx(wf, { instrument: i, theme: "dark" }, o)) })
  ] });
  return /* @__PURE__ */ y.jsx(
    Et,
    {
      content: a,
      wrap: "div",
      wrapProps: { className: Lb.trigger },
      children: n
    }
  );
}), Vb = "_cell_hfkay_1", Hb = "_cellText_hfkay_11", zb = "_cellDimmed_hfkay_14", Ub = "_cellContent_hfkay_18", bt = {
  cell: Vb,
  cellText: Hb,
  cellDimmed: zb,
  cellContent: Ub
}, Ut = we(function({
  cell: t,
  dimmed: r = !1,
  background: n = "transparent",
  tooltipProps: a,
  textProps: i = {},
  onMouseEnter: o
}) {
  const [s, c] = ee(!1), u = jl(t?.value);
  Ot(() => {
    if (t?.value !== u) {
      c(!0);
      const h = setTimeout(() => {
        c(!1);
      }, 200);
      return () => {
        clearTimeout(h);
      };
    }
  }, [t?.value]);
  const d = W(() => {
    if (!t) return null;
    const { value: h, format: f } = t;
    return typeof h == "string" ? h : typeof h == "number" && f ? Tt(h, f) : "—";
  }, [t]);
  if (!t)
    return /* @__PURE__ */ y.jsx(
      "div",
      {
        className: bt.cell,
        onMouseEnter: o,
        "data-testid": "heatmap-instrument-cell"
      }
    );
  const l = /* @__PURE__ */ y.jsx("div", { className: bt.cellContent, children: /* @__PURE__ */ y.jsx(
    K.Paragraph,
    {
      className: qe({
        [bt.cellText]: typeof t.value == "string"
      }),
      variant: "3",
      subdued: !Vf(t.value),
      ...i,
      children: d
    }
  ) });
  return /* @__PURE__ */ y.jsx(
    "div",
    {
      className: qe(bt.cell, {
        [bt.cellDimmed]: r || s
      }),
      onMouseEnter: o,
      style: { backgroundColor: n },
      "data-animating": s,
      "data-testid": "heatmap-instrument-cell",
      children: a?.enabled ? /* @__PURE__ */ y.jsx(Bb, { ...a, children: l }) : l
    }
  );
}), Wb = "_grid_1qk2p_1", Gb = "_row_1qk2p_7", Ri = {
  grid: Wb,
  row: Gb
};
var nl = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function Kb(e, t) {
  return !!(e === t || nl(e) && nl(t));
}
function Yb(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!Kb(e[r], t[r]))
      return !1;
  return !0;
}
function Xb(e, t) {
  t === void 0 && (t = Yb);
  var r = null;
  function n() {
    for (var a = [], i = 0; i < arguments.length; i++)
      a[i] = arguments[i];
    if (r && r.lastThis === this && t(a, r.lastArgs))
      return r.lastResult;
    var o = e.apply(this, a);
    return r = {
      lastResult: o,
      lastArgs: a,
      lastThis: this
    }, o;
  }
  return n.clear = function() {
    r = null;
  }, n;
}
const Jb = [
  "100",
  "200",
  "400",
  "500",
  "700"
].map((e) => `var(--dixa-color-purple-${e})`), Zb = Xb(
  (e) => {
    if (e === null)
      return {
        backgroundColor: "var(--dixa-color-neutral-000)",
        color: "tertiary"
      };
    const t = Math.min(
      4,
      Math.floor(Math.min(e, 100) * (5 / 100))
    );
    return {
      backgroundColor: Jb?.[t] ?? "var(--dixa-color-neutral-000)",
      color: t >= 3 ? "white" : "primary"
    };
  }
);
function Qb(e) {
  return typeof e == "number" && !Number.isNaN(e) && e >= 0;
}
const ey = (e) => {
  const t = e.flatMap(({ data: a }) => a.map((i) => pr(i).value)).filter(Qb), r = Math.min(...t), n = Math.max(...t);
  return { min: r, max: n };
}, ty = (e, { min: t, max: r }) => t === r ? 100 : Math.round(100 * (e - t) / (r - t)), n0 = ({
  instrument: e
}) => {
  const {
    data: { categories: t, series: r }
  } = e, n = Q(null), [a, i] = _d({
    cell: null,
    column: null,
    row: null
  }), o = W(
    () => Object.values(a).some((f) => f !== null),
    [a]
  ), s = W(() => ey(r), [r]);
  Pt(() => {
    const f = (g) => {
      n.current && !n.current.contains(g.target) && o && i.reset();
    };
    return window.addEventListener("mousemove", f, !0), () => {
      window.removeEventListener("mousemove", f, !0);
    };
  }, [o, i]);
  const c = U(
    (f) => {
      if (!o)
        return !1;
      const [g, p] = f;
      return a.cell ? !Db(a.cell.id, f) : a.column !== null ? a.column !== p : a.row !== null ? a.row !== g : !1;
    },
    [o, a.cell, a.column, a.row]
  ), u = U(
    (f) => i.setAll({
      cell: null,
      column: f,
      row: null
    }),
    [i]
  ), d = U(
    (f) => i.setAll({
      cell: null,
      column: null,
      row: f
    }),
    [i]
  ), l = U(
    (f) => {
      (o || f !== null) && i.setAll({
        cell: f,
        column: null,
        row: null
      });
    },
    [o, i]
  ), h = U(() => {
    o && i.reset();
  }, [o, i]);
  return /* @__PURE__ */ y.jsxs(
    "div",
    {
      ref: n,
      className: Ri.grid,
      onMouseLeave: () => i.reset(),
      "data-testid": "heatmap-instrument",
      children: [
        /* @__PURE__ */ y.jsxs("div", { className: Ri.row, children: [
          /* @__PURE__ */ y.jsx(Ut, { onMouseEnter: h }),
          r.map((f, g) => {
            const p = r[g].metrics ?? [];
            return /* @__PURE__ */ y.jsx(
              Ut,
              {
                cell: { id: [0, g], value: f.label },
                tooltipProps: {
                  enabled: p.length > 0,
                  title: f.label,
                  metrics: p
                },
                onMouseEnter: () => u(g)
              },
              f.label
            );
          })
        ] }),
        t.map((f, g) => {
          const p = t[g].metrics ?? [];
          return /* @__PURE__ */ y.jsxs("div", { className: Ri.row, children: [
            /* @__PURE__ */ y.jsx(
              Ut,
              {
                cell: { id: [g, 0], value: f.label },
                tooltipProps: {
                  enabled: p.length > 0,
                  title: f.label,
                  metrics: p
                },
                onMouseEnter: () => d(g)
              }
            ),
            r.map((m, b) => {
              const _ = [g, b], { value: C, metrics: R } = pr(
                m.data[g]
              ), $ = m.options?.format ?? "number", E = Vf(C), { backgroundColor: A, color: x } = Zb(
                E ? ty(C, s) : null
              );
              return /* @__PURE__ */ y.jsx(
                Ut,
                {
                  cell: { id: _, value: C, format: $ },
                  dimmed: c(_),
                  background: A,
                  tooltipProps: {
                    enabled: E,
                    title: `${f.label}, ${m.label}`,
                    metrics: R?.length ? R : [
                      {
                        type: "metric",
                        title: "Total",
                        data: C,
                        format: $ === "count" ? "number" : $
                      }
                    ]
                  },
                  textProps: { color: x },
                  onMouseEnter: () => l(E ? { id: _, value: C } : null)
                },
                _.join(",")
              );
            })
          ] }, f.label);
        })
      ]
    }
  );
}, ry = "_legend_bx9pd_48", ny = "_trigger_bx9pd_52", ay = "_popover_bx9pd_58", iy = "_breakdown_bx9pd_77", Wt = {
  legend: ry,
  trigger: ny,
  popover: ay,
  breakdown: iy
}, a0 = we(function({
  instrument: t
}) {
  const {
    data: { availability: r, media_type: n, away: a }
  } = t, i = [
    "var(--dixa-color-purple-700)",
    "var(--dixa-color-neutral-200)"
  ], o = "No data available", s = {
    // Primitive way to ensure the labels are the same width, by deriving it from the longest
    // The number 7 is roughly the average width of a lowercase character
    labelWidth: Math.max(...n.map((l) => l.label.length)) * 7,
    theme: i
  }, c = () => /* @__PURE__ */ y.jsx(
    Jt,
    {
      ...s,
      value: 0,
      label: "n.a.",
      theme: ["var(--dixa-color-neutral-200)", "var(--dixa-color-neutral-200)"],
      showFullBar: !0
    }
  ), u = () => {
    if (!a || !a.length) return null;
    const [l, h, ...f] = a;
    return /* @__PURE__ */ y.jsxs(gf, { children: [
      /* @__PURE__ */ y.jsx(mf, { asChild: !0, children: /* @__PURE__ */ y.jsx(
        ao,
        {
          variant: "tertiary",
          icon: "dots-h",
          className: Wt.trigger
        }
      ) }),
      /* @__PURE__ */ y.jsx(bf, { children: /* @__PURE__ */ y.jsx(yf, { side: "right", className: Wt.popover, children: /* @__PURE__ */ y.jsxs("ul", { className: Wt.breakdown, children: [
        /* @__PURE__ */ y.jsxs("li", { children: [
          /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "1", children: l.label }),
          /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "1", children: ze(l.value) })
        ] }),
        /* @__PURE__ */ y.jsxs("li", { children: [
          /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "2", subdued: !0, children: h.label }),
          /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "2", subdued: !0, children: ze(h.value) })
        ] }),
        /* @__PURE__ */ y.jsx(dd, {}),
        f.map((g, p) => /* @__PURE__ */ y.jsxs("li", { children: [
          /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "2", children: g.label }),
          /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "1", children: ze(g.value) })
        ] }, p))
      ] }) }) })
    ] });
  }, d = () => /* @__PURE__ */ y.jsxs(X, { gap: "300", className: Wt.legend, children: [
    r.map((l, h) => /* @__PURE__ */ y.jsxs(X, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ y.jsx(
        io,
        {
          width: "6px",
          height: "6px",
          background: i[h],
          borderRadius: "50%"
        }
      ),
      /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "4", children: l.label })
    ] }, h)),
    u()
  ] });
  return /* @__PURE__ */ y.jsxs(X, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ y.jsxs(X, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "4", subdued: !0, children: r.length ? "Availability" : o }),
      r.length ? /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
        d(),
        /* @__PURE__ */ y.jsx(
          Jt,
          {
            ...s,
            value: r[0].value,
            label: "Total",
            showFullBar: !0,
            showDifference: !0
          }
        )
      ] }) : c()
    ] }),
    /* @__PURE__ */ y.jsxs(X, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "4", subdued: !0, children: n.length ? "Availability per channel" : o }),
      n.length > 0 ? /* @__PURE__ */ y.jsx(X, { flexDirection: "column", gap: "200", children: n.map((l, h) => /* @__PURE__ */ V(
        Jt,
        {
          ...s,
          key: h,
          value: l.value,
          label: l.label
        }
      )) }) : c()
    ] })
  ] });
}), oy = "_tooltip_h4i5v_1", sy = "_trigger_h4i5v_5", al = {
  tooltip: oy,
  trigger: sy
}, cy = ({
  text: e
}) => /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
  /* @__PURE__ */ y.jsx("span", { children: e }),
  /* @__PURE__ */ y.jsx(
    Et,
    {
      className: al.tooltip,
      content: e,
      wrap: "div",
      wrapProps: { className: al.trigger }
    }
  )
] }), uy = we(
  function({
    value: t
  }) {
    const [r, ...n] = t;
    return /* @__PURE__ */ y.jsxs(X, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "2", as: "span", children: r }),
      n.length > 0 && /* @__PURE__ */ y.jsx(Et, { content: n.join(", "), children: /* @__PURE__ */ y.jsxs(K.ExternalLink, { as: "span", children: [
        "+ ",
        n.length,
        " more"
      ] }) })
    ] });
  }
), ly = ({
  cell: e,
  format: t,
  timezone: r,
  customFormats: n
}) => {
  const a = W(() => {
    if (!e || fy(e.value))
      return /* @__PURE__ */ y.jsx(K.Paragraph, { variant: "2", color: "neutral.500", children: "n.a." });
    const { value: i, label: o } = e;
    if (o) return o;
    if (n?.[t])
      return n[t]?.({ value: i });
    switch (t) {
      case "boolean":
        return i ? "Y" : "N";
      case "date":
        return ct.tz(i, r).format("L, LT");
      case "count":
        return _f(i);
      case "number":
        return $t(i);
      case "percentage":
        return `${$t(i)}%`;
      case "duration":
        return ze(i);
      case "csid":
        return `#${i}`;
      case "rating":
        return `${i}`;
      case "presence":
        return /* @__PURE__ */ y.jsx(Jt, { value: i, showFullBar: !0 });
      case "tags":
        return /* @__PURE__ */ y.jsx(kd, { tags: i, limit: 1 });
      case "text":
        return /* @__PURE__ */ y.jsx(cy, { text: i });
      case "list":
        return /* @__PURE__ */ y.jsx(uy, { value: i });
      default:
        return `${i}`;
    }
  }, [e, n, t, r]);
  return e?.ui?.type === "badge" ? /* @__PURE__ */ y.jsx(hd, { variant: e.ui.variant, size: "medium", children: /* @__PURE__ */ y.jsx(y.Fragment, { children: a }) }) : /* @__PURE__ */ y.jsx(y.Fragment, { children: a });
};
function fy(e) {
  const t = e === null, r = typeof e == "string" && e.trim() === "", n = Array.isArray(e) && !e.length;
  return t || r || n;
}
const dy = "_tableWrapper_1xmkm_1", hy = "_tableWrapperEmpty_1xmkm_4", py = "_thCell_1xmkm_8", vy = "_tdCell_1xmkm_12", gy = "_tooltip_1xmkm_20", yt = {
  tableWrapper: dy,
  tableWrapperEmpty: hy,
  thCell: py,
  tdCell: vy,
  tooltip: gy
};
var Si, il;
function my() {
  if (il) return Si;
  il = 1;
  function e(t) {
    return t == null;
  }
  return Si = e, Si;
}
var by = my();
const yy = /* @__PURE__ */ Re(by);
var $i, ol;
function _y() {
  if (ol) return $i;
  ol = 1;
  var e = Nf(), t = Po(), r = 1, n = 2;
  function a(i, o, s, c) {
    var u = s.length, d = u, l = !c;
    if (i == null)
      return !d;
    for (i = Object(i); u--; ) {
      var h = s[u];
      if (l && h[2] ? h[1] !== i[h[0]] : !(h[0] in i))
        return !1;
    }
    for (; ++u < d; ) {
      h = s[u];
      var f = h[0], g = i[f], p = h[1];
      if (l && h[2]) {
        if (g === void 0 && !(f in i))
          return !1;
      } else {
        var m = new e();
        if (c)
          var b = c(g, p, f, i, o, m);
        if (!(b === void 0 ? t(p, g, r | n, c, m) : b))
          return !1;
      }
    }
    return !0;
  }
  return $i = a, $i;
}
var Pi, sl;
function Hf() {
  if (sl) return Pi;
  sl = 1;
  var e = Xe();
  function t(r) {
    return r === r && !e(r);
  }
  return Pi = t, Pi;
}
var Ei, cl;
function xy() {
  if (cl) return Ei;
  cl = 1;
  var e = Hf(), t = $o();
  function r(n) {
    for (var a = t(n), i = a.length; i--; ) {
      var o = a[i], s = n[o];
      a[i] = [o, s, e(s)];
    }
    return a;
  }
  return Ei = r, Ei;
}
var Oi, ul;
function zf() {
  if (ul) return Oi;
  ul = 1;
  function e(t, r) {
    return function(n) {
      return n == null ? !1 : n[t] === r && (r !== void 0 || t in Object(n));
    };
  }
  return Oi = e, Oi;
}
var Ai, ll;
function wy() {
  if (ll) return Ai;
  ll = 1;
  var e = _y(), t = xy(), r = zf();
  function n(a) {
    var i = t(a);
    return i.length == 1 && i[0][2] ? r(i[0][0], i[0][1]) : function(o) {
      return o === a || e(o, a, i);
    };
  }
  return Ai = n, Ai;
}
var Ti, fl;
function Cy() {
  if (fl) return Ti;
  fl = 1;
  var e = wr();
  function t(r, n, a) {
    var i = r == null ? void 0 : e(r, n);
    return i === void 0 ? a : i;
  }
  return Ti = t, Ti;
}
var qi, dl;
function Ry() {
  if (dl) return qi;
  dl = 1;
  var e = Po(), t = Cy(), r = Df(), n = bo(), a = Hf(), i = zf(), o = It(), s = 1, c = 2;
  function u(d, l) {
    return n(d) && a(l) ? i(o(d), l) : function(h) {
      var f = t(h, d);
      return f === void 0 && f === l ? r(h, d) : e(l, f, s | c);
    };
  }
  return qi = u, qi;
}
var ji, hl;
function Sy() {
  if (hl) return ji;
  hl = 1;
  var e = wr();
  function t(r) {
    return function(n) {
      return e(n, r);
    };
  }
  return ji = t, ji;
}
var Ii, pl;
function $y() {
  if (pl) return Ii;
  pl = 1;
  var e = Ef(), t = Sy(), r = bo(), n = It();
  function a(i) {
    return r(i) ? e(n(i)) : t(i);
  }
  return Ii = a, Ii;
}
var Mi, vl;
function Py() {
  if (vl) return Mi;
  vl = 1;
  var e = wy(), t = Ry(), r = Cr(), n = Se(), a = $y();
  function i(o) {
    return typeof o == "function" ? o : o == null ? r : typeof o == "object" ? n(o) ? t(o[0], o[1]) : e(o) : a(o);
  }
  return Mi = i, Mi;
}
var Di, gl;
function Ey() {
  if (gl) return Di;
  gl = 1;
  function e(t) {
    return function(r, n, a) {
      for (var i = -1, o = Object(r), s = a(r), c = s.length; c--; ) {
        var u = s[t ? c : ++i];
        if (n(o[u], u, o) === !1)
          break;
      }
      return r;
    };
  }
  return Di = e, Di;
}
var Fi, ml;
function Oy() {
  if (ml) return Fi;
  ml = 1;
  var e = Ey(), t = e();
  return Fi = t, Fi;
}
var Ni, bl;
function Ay() {
  if (bl) return Ni;
  bl = 1;
  var e = Oy(), t = $o();
  function r(n, a) {
    return n && e(n, a, t);
  }
  return Ni = r, Ni;
}
var ki, yl;
function Ty() {
  if (yl) return ki;
  yl = 1;
  var e = So();
  function t(r, n) {
    return function(a, i) {
      if (a == null)
        return a;
      if (!e(a))
        return r(a, i);
      for (var o = a.length, s = n ? o : -1, c = Object(a); (n ? s-- : ++s < o) && i(c[s], s, c) !== !1; )
        ;
      return a;
    };
  }
  return ki = t, ki;
}
var Li, _l;
function qy() {
  if (_l) return Li;
  _l = 1;
  var e = Ay(), t = Ty(), r = t(e);
  return Li = r, Li;
}
var Bi, xl;
function jy() {
  if (xl) return Bi;
  xl = 1;
  var e = qy(), t = So();
  function r(n, a) {
    var i = -1, o = t(n) ? Array(n.length) : [];
    return e(n, function(s, c, u) {
      o[++i] = a(s, c, u);
    }), o;
  }
  return Bi = r, Bi;
}
var Vi, wl;
function Iy() {
  if (wl) return Vi;
  wl = 1;
  function e(t, r) {
    var n = t.length;
    for (t.sort(r); n--; )
      t[n] = t[n].value;
    return t;
  }
  return Vi = e, Vi;
}
var Hi, Cl;
function My() {
  if (Cl) return Hi;
  Cl = 1;
  var e = jt();
  function t(r, n) {
    if (r !== n) {
      var a = r !== void 0, i = r === null, o = r === r, s = e(r), c = n !== void 0, u = n === null, d = n === n, l = e(n);
      if (!u && !l && !s && r > n || s && c && d && !u && !l || i && c && d || !a && d || !o)
        return 1;
      if (!i && !s && !l && r < n || l && a && o && !i && !s || u && a && o || !c && o || !d)
        return -1;
    }
    return 0;
  }
  return Hi = t, Hi;
}
var zi, Rl;
function Dy() {
  if (Rl) return zi;
  Rl = 1;
  var e = My();
  function t(r, n, a) {
    for (var i = -1, o = r.criteria, s = n.criteria, c = o.length, u = a.length; ++i < c; ) {
      var d = e(o[i], s[i]);
      if (d) {
        if (i >= u)
          return d;
        var l = a[i];
        return d * (l == "desc" ? -1 : 1);
      }
    }
    return r.index - n.index;
  }
  return zi = t, zi;
}
var Ui, Sl;
function Fy() {
  if (Sl) return Ui;
  Sl = 1;
  var e = Rf(), t = wr(), r = Py(), n = jy(), a = Iy(), i = mo(), o = Dy(), s = Cr(), c = Se();
  function u(d, l, h) {
    l.length ? l = e(l, function(p) {
      return c(p) ? function(m) {
        return t(m, p.length === 1 ? p[0] : p);
      } : p;
    }) : l = [s];
    var f = -1;
    l = e(l, i(r));
    var g = n(d, function(p, m, b) {
      var _ = e(l, function(C) {
        return C(p);
      });
      return { criteria: _, index: ++f, value: p };
    });
    return a(g, function(p, m) {
      return o(p, m, h);
    });
  }
  return Ui = u, Ui;
}
var Wi, $l;
function Ny() {
  if ($l) return Wi;
  $l = 1;
  var e = Fy(), t = Se();
  function r(n, a, i, o) {
    return n == null ? [] : (t(a) || (a = a == null ? [] : [a]), i = o ? void 0 : i, t(i) || (i = i == null ? [] : [i]), e(n, a, i));
  }
  return Wi = r, Wi;
}
var ky = Ny();
const Ly = /* @__PURE__ */ Re(ky), By = (e) => typeof e == "string" || typeof e == "number" || typeof e == "boolean", Pl = (e, t) => {
  const r = e.cells.find((n) => n.column === t.key);
  return !r || r.value === null ? null : (By(r.value), r.value);
}, Vy = ({
  data: { columns: e, rows: t },
  limit: r = 50,
  sortStatus: n
}) => {
  const i = Math.ceil(t.length / r), [o, s] = ee(1);
  Ot(() => {
    o !== 1 && s(1);
  }, [n, i]);
  const c = W(() => {
    if (!n) return t;
    const d = e.find(({ key: l }) => l === n.sortBy);
    return d ? Ly(
      t,
      [
        (l) => !yy(Pl(l, d)),
        (l) => Pl(l, d)
      ],
      ["desc", n.direction]
    ) : t;
  }, [e, t, n]);
  return {
    rows: W(
      () => c.slice((o - 1) * r, o * r),
      [o, r, c]
    ),
    currentPage: o,
    totalPages: i,
    setPage: s
  };
}, i0 = ({
  instrument: e,
  timezone: t,
  onReadInstruments: r,
  onLoadAll: n,
  onSortChange: a,
  customFormats: i
}) => {
  const {
    title: o,
    data: s,
    data: { columns: c, options: u }
  } = e, [d, l] = ee(null), h = Q(null), f = u?.limit ?? 50, { rows: g, currentPage: p, totalPages: m, setPage: b } = Vy({
    data: s,
    limit: f,
    sortStatus: d
  }), _ = s.rows.length === 0, C = !!u?.next_page, R = !C && m > 1;
  Ot(() => {
    h.current && (h.current.scrollTop = 0);
  }, [p]);
  const $ = U(() => (n?.(), r({
    meta: {
      pagination: {
        limit: null
      }
    }
  })), [n, r]), E = U(
    async (A) => {
      C && await $(), l(A), a?.(A);
    },
    [$, a, C]
  );
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    o && /* @__PURE__ */ y.jsx("div", { children: /* @__PURE__ */ y.jsx(K.Heading, { variant: "heading-4", children: o }) }),
    /* @__PURE__ */ y.jsxs(
      Ce,
      {
        stickyHeader: !0,
        sortingProps: {
          sortStatus: d,
          onSortChange: E
        },
        wrapperProps: {
          className: qe(yt.tableWrapper, {
            [yt.tableWrapperEmpty]: _
          })
        },
        wrapperRef: h,
        hoverable: !_,
        children: [
          /* @__PURE__ */ y.jsx(Ce.Thead, { children: /* @__PURE__ */ y.jsx(Ce.Tr, { children: c.map(({ key: A, label: x, sortable: w }) => /* @__PURE__ */ y.jsx(
            Ce.Th,
            {
              className: yt.thCell,
              columnId: w ? A : null,
              children: x
            },
            x
          )) }) }),
          /* @__PURE__ */ y.jsxs(Ce.Tbody, { children: [
            _ && /* @__PURE__ */ y.jsx(Ce.Tr, { children: /* @__PURE__ */ y.jsx(Ce.Td, { colSpan: c.length, children: /* @__PURE__ */ y.jsx(
              Tl,
              {
                title: "No data available",
                description: "There is no data available for the selected period and filters.",
                icon: "th"
              }
            ) }) }),
            g.map((A, x) => {
              const w = `row-${x}`;
              return /* @__PURE__ */ y.jsx(Ce.Tr, { children: c.map(({ key: P, format: S }, I) => {
                const T = A.cells.find((M) => M.column === P);
                return /* @__PURE__ */ y.jsx(
                  Ce.Td,
                  {
                    className: yt.tdCell,
                    children: /* @__PURE__ */ y.jsx(
                      ly,
                      {
                        cell: T,
                        format: S,
                        timezone: t,
                        customFormats: i
                      }
                    )
                  },
                  `${w}-cell-${I}`
                );
              }) }, w);
            })
          ] }),
          C && /* @__PURE__ */ y.jsx(Ce.Footer, { children: /* @__PURE__ */ y.jsxs(X, { alignItems: "center", justifyContent: "center", gap: "300", children: [
            /* @__PURE__ */ y.jsxs(X, { gap: "100", alignItems: "center", children: [
              /* @__PURE__ */ y.jsx(
                pd,
                {
                  tooltipClassName: yt.tooltip,
                  text: `By default we only load the first ${f} results. If you need to see all available results, click on the button, but beware that this may take a bit of time to load depending on the number of results.`
                }
              ),
              /* @__PURE__ */ y.jsxs(K.Paragraph, { variant: "2", children: [
                "Showing only the ",
                /* @__PURE__ */ y.jsxs("b", { children: [
                  "first ",
                  f,
                  " results"
                ] })
              ] })
            ] }),
            /* @__PURE__ */ y.jsx(Al, { variant: "secondary", onClick: $, children: "Load all results" })
          ] }) }),
          R && /* @__PURE__ */ y.jsx(Ce.Footer, { children: /* @__PURE__ */ y.jsx(X, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ y.jsx(
            vd,
            {
              pageCount: m,
              currentPage: p,
              pageRangeDisplayed: 6,
              onPageChange: b
            }
          ) }) })
        ]
      }
    )
  ] });
};
export {
  e0 as AnalyticsMenu,
  r0 as ChartInstrument,
  n0 as HeatmapInstrument,
  wf as MetricInstrument,
  ug as MetricInstrumentData,
  to as MetricInstrumentsGrid,
  Jt as PercentageBar,
  a0 as PresenceInstrument,
  i0 as TableInstrument,
  t0 as categorizeInstruments,
  Ue as chartAppearance,
  _f as formatAbbreviateNumber,
  Tt as formatInstrumentNumber,
  $t as formatLocalizedNumber,
  ze as formatMillisecondsToDuration,
  pr as getChartSeriesValue,
  Jv as isAIInsightInstrument,
  Gv as isChartInstrument,
  cr as isDateLikeString,
  Kv as isHeatmapInstrument,
  Wv as isMetricInstrument,
  Xv as isPresenceInstrument,
  Yv as isTableInstrument,
  By as isTableInstrumentDataValuePrimitive,
  ot as resolveChartElementColor,
  xf as resolveInstrumentColor
};
//# sourceMappingURL=index.js.map
